// Finnish translations
import { solutionComponentsFi } from './solutionComponentStrings.js';
import { lensComponentsFi } from './lensComponentStrings.js';
import { moduleIntroFi } from './moduleIntroStrings.js';
import { reportStringsFi } from './reportStrings.js';
import { foresightFi } from './foresightStrings.js';
import { foresightScenarioFi } from './foresightScenarioStrings.js';
import { foresightPathFi } from './foresightPathStrings.js';
import { foresightWildcardFi } from './foresightWildcardStrings.js';
import { futureReimaginedFi } from './futureReimaginedStrings.js';
import { negotiationLabFi } from './negotiationLabStrings.js';
import { kuusiKenttaaFi } from './kuusiKenttaaStrings.js';
import { bookletFi } from './bookletStrings.js';
import { pivotsV3Fi } from './pivotsV3Strings.js';
import { vipupisteFocusFi } from './vipupisteFocusStrings.js';
import { statisticsViewFi } from './statisticsViewStrings.js';
import { opinionDatasetsFi } from './opinionDatasetStrings.js';
import { knowledgeKindsFi, sourceTiersFi } from './knowledgeKindStrings.js';
import { instancePromptsFi } from './instancePromptsStrings.js';
import { solutionsV3Fi } from './solutionsV3Strings.js';
import { ongelmatV2Fi } from './ongelmatV2Strings.js';
import { ankkuritV2Fi } from './ankkuritV2Strings.js';
import { juurisyytV2Fi } from './juurisyytV2Strings.js';
import { ongelmakarttaV3Fi } from './ongelmakarttaV3Strings.js';
import { solutionsV4Fi } from './solutionsV4Strings.js';
import { futureReimaginedV2Fi } from './futureReimaginedV2Strings.js';
import { impactMapV2Fi } from './impactMapV2Strings.js';
import { pivotsV2Fi } from './pivotsV2Strings.js';
import { swotViewFi } from './swotViewStrings.js';

export const fi = {
  // Landing Page
  landing: {
    title: 'Tervetuloa Kuutioon.',
    subtitle: 'Valitse rooli päästäksesi eteenpäin',
    selectInstance: 'Valitse Kuutio-instanssi',
    loadingInstances: 'Ladataan instansseja...',
    noInstances: 'Ei instansseja saatavilla',
    sitraUser: 'Olen sitralainen',
    invited: 'Minut kutsuttiin',
    whatIsKuutio: '🤔 Mikä on Kuutio?',
    footer: 'Tämä näkymä näkyy kaikilla tietokoneilla Kuution käynnistyessä',
    infoModal: {
      title: 'Mikä on Kuutio?',
      paragraph1: 'Kuutio on Sitran kehittämä yhteiskehittämisen alusta, joka tuo yhteen kansalaiset, päättäjät ja asiantuntijat ratkaisemaan yhteiskunnan keskeisiä haasteita.',
      paragraph2: 'Alusta mahdollistaa interaktiivisen työskentelyn monilla näytöillä ja laitteilla. Osallistujat voivat rakentaa vaikutuspolkuja, jakaa ideoita ja visualisoida monimutkaisia syy-seuraussuhteita yhdessä reaaliajassa.',
      paragraph3: 'Kuution tavoitteena on tukea demokraattista päätöksentekoa ja yhteiskunnallista muutosta tarjoamalla työkalu, joka tekee monimutkaisista ilmiöistä ymmärrettäviä ja edistää systeemistä ajattelua.',
      contactButton: 'Ota yhteyttä'
    }
  },

  // Individual Impact Path
  individualImpactPath: {
    // Start Modal
    startModal: {
      title: '🌍 Nykytila: Ruokajärjestelmän haasteet',
      intro: 'Suomen ruokajärjestelmä on murroksessa.',
      introDetails: 'Ilmastonmuutos, geopoliittiset jännitteet ja väestön ikääntyminen haastavat perinteiset toimintatavat.',
      question: 'Miten varmistamme ruokaturvan, kun:',
      challenges: [
        'Tuontiriippuvuus on 80% monissa tuoteryhmissä',
        'Viljelijöiden keski-ikä ylittää 53 vuotta',
        'Sään ääri-ilmiöt lisääntyvät',
        'Ruoan hinta nousee nopeammin kuin ostovoima'
      ],
      task: 'Tehtäväsi:',
      taskDescription: 'Rakenna polku kohti kestävää ja omavaraisempaa ruokajärjestelmää. Aloita valitsemalla yksi keskeinen kysymys, johon haluat pureutua.',
      continueButton: 'Jatka'
    },
    
    // Question Selection Modal
    questionModal: {
      title: 'Valitse keskeisin kysymys',
      subtitle: 'Valitse yksi näistä keskeisistä kysymyksistä tutkittavaksi vaikutuspolussa:',
      cancelButton: 'Peruuta',
      selectButton: 'Valitse kysymys'
    },
    
    // Node Modal
    nodeModal: {
      addConsequence: 'Lisää seuraus',
      addRequirement: 'Lisää vaatimus',
      addComment: 'Lisää kommentti',
      generateWithAI: 'Luo AI:lla',
      removeNode: 'Poista solmu',
      close: 'Sulje'
    },
    
    // Placeholder nodes
    placeholders: {
      addQuestion: '+ Lisää kysymys',
      addNode: '+ Lisää solmu'
    },
    
    // View controls
    viewControls: {
      clustered: 'Ryhmitelty',
      individual: 'Yksilöllinen',
      showAll: 'Näytä kaikki',
      hideCompleted: 'Piilota valmiit'
    },
    
    // Settings panel
    settings: {
      title: 'Asetukset',
      viewMode: 'Näkymätila',
      clustering: 'Ryhmittely',
      aiComments: 'AI-kommentit',
      enabled: 'Käytössä',
      disabled: 'Pois käytöstä'
    }
  },
  
  activityLog: {
    exportFailed: 'Lataus epäonnistui: {{error}}',
  },
  knowledgeManager: {
    exportFailed: 'RAG-vienti epäonnistui: {{error}}',
  },

  // Common UI elements
  common: {
    save: 'Tallenna',
    cancel: 'Peruuta',
    confirm: 'Vahvista',
    ok: 'OK',
    delete: 'Poista',
    confirmDelete: 'Kyllä, poista',
    deleting: 'Poistetaan...',
    edit: 'Muokkaa',
    add: 'Lisää',
    close: 'Sulje',
    undo: 'Kumoa',
    redo: 'Tee uudelleen',
    continue: 'Jatka',
    back: 'Takaisin',
    next: 'Seuraava',
    yes: 'Kyllä',
    no: 'Ei',
    loading: 'Ladataan...',
    loadingContent: 'Ladataan sisältöä...',
    error: 'Virhe',
    success: 'Onnistui',
    unknownSource: 'Tuntematon lähde',
    showMoreSources: '+{{count}} lähdettä lisää',
    showFewerSources: 'Näytä vähemmän',
    sourceTitleFallback: 'Lähde',
    openSource: 'Avaa lähde',
    noSources: 'Ei lähteitä',
    errorBoundaryTitle: 'Jokin meni pieleen',
    errorBoundaryUnknown: 'Tuntematon virhe',
    errorBoundaryReload: 'Lataa uudelleen',
    unsavedTitle: 'Hylätäänkö tallentamattomat muutokset?',
    unsavedMessage: 'Muutoksiasi ei ole tallennettu. Ne menetetään, jos jatkat.',
    unsavedLeave: 'Sinulla on tallentamattomia muutoksia. Poistutaanko silti?',
    discardChanges: 'Hylkää muutokset',
  },

  login: {
    title: 'Kirjaudu sisään',
    subtitle: 'Kuutio-työpajan hallintapaneeli. Sitralaiset kirjautuvat Microsoft-tilillä.',
    microsoft: 'Kirjaudu Microsoft-tilillä',
    orEmail: 'Ulkopuolinen, jolle on annettu pääsy: kirjaudu sähköpostiin tulevalla koodilla',
    emailNote: 'Käytä osoitetta, jolle pääsy on annettu.',
    hint: 'Jos sinulla ei ole pääsyä, ota yhteyttä Kuutio-tiimiin. Kirjautumalla hyväksyt, että käyttöäsi voidaan auditoida työpajadatan eheyden varmistamiseksi.',
  },

  pinLogin: {
    title: 'Kuutio',
    chooseSubtitle: 'Miten kirjaudut sisään?',
    chooseEmail: 'Minulla on kutsu Kuutioon sähköpostiosoitteellani',
    choosePin: 'Osallistun Kuutio-työpajaan ja tiedän PIN-koodin',
    chooseStaff: 'Sitran Kuutio-henkilökunta',
    town: {
      title: 'Mistä kaupungista olet?',
      subtitle: 'Valinta tallentuu tälle laitteelle: tiimisi vastaukset ja edellytykset kirjataan sen nimiin. Voit vaihtaa tiimiä tiimisivulta.',
    },
    staffSignIn: 'Kirjaudu Microsoft-tunnuksella',
    back: 'Takaisin',
    denied: {
      signin: 'Kirjaudu sisään avataksesi linkin.',
      instance: 'Kirjautumisesi ei anna pääsyä tähän työpajaan.',
      expired: 'Istuntosi on päättynyt. Kirjaudu uudelleen.',
    },
    placeholder: 'PIN',
    submit: 'Kirjaudu',
    invalidPin: 'Virheellinen PIN-koodi',
    modalTitle: 'Anna PIN-koodi',
    modalText: 'Syötä saamasi 6-merkkinen PIN-koodi päästäksesi kuutioon.',
    emailPlaceholder: 'nimi@organisaatio.fi',
    sendCode: 'Lähetä koodi',
    sending: 'Lähetetään…',
    codeSentTo: 'Koodi lähetetty osoitteeseen',
    changeEmail: 'vaihda',
    signingIn: 'Kirjaudutaan…',
    resend: 'Lähetä uusi koodi',
    resendIn: 'Lähetä uusi koodi ({{s}} s)',
    codeResent: 'Uusi koodi lähetetty',
    invitedOnly: 'Koodi lähetetään vain kutsutuille osallistujille. Käytä osoitetta, jolla ilmoittauduit Kuutioon.',
    codeIfInvited: 'Jos osoite on kutsuttujen listalla, koodi on matkalla. Tarkista myös roskaposti.',
    connectionError: 'Yhteysvirhe. Yritä uudelleen.',
  },

  aiScorePanel: {
    researchSupport: 'Tietopohja',
    researchUnavailable: {
      searchFailed: 'Tutkimusaineistoa ei voitu käyttää: hakupalvelu ei vastannut. Arvio perustuu yleistietoon.',
      noDatasets: 'Tutkimusaineistoa ei voitu käyttää: työpajalle ei ole liitetty tutkimusaineistoa. Arvio perustuu yleistietoon.',
    },
    relevance: 'Osuvuus',
    attachments: 'Liitteet',
    attachmentsCount: 'Liitteet ({{count}})',
  },

  // Solution evaluation tags (IDs match @kuutio/shared/evaluationTags.js)
  evaluationTags: {
    ambitious: 'Kunnianhimoinen',
    feasible: 'Toteuttamiskelpoinen',
    innovative: 'Innovatiivinen',
    creative: 'Luova',
    research_backed: 'Tietopohjainen',
    systemic: 'Systeeminen',
    tested_elsewhere: 'Kokeiltu muualla',
    quick_to_implement: 'Nopea toteuttaa',
    uncharted: 'Kartoittamaton alue',
    expert_insight: 'Ammattitaidon oivallus',
    bold_hypothesis: 'Rohkea hypoteesi',
    empty: 'Ei vahvuustunnisteita.',
    contradicts_research: 'Ristiriidassa tietopohjan kanssa',
    sectionTitle: 'Tunnisteet',
    researchConflictTitle: 'Huomio tietopohjan näkökulmasta',
    researchStance: {
      supported: 'Tietopohja tukee',
      silent: 'Tietopohja ei käsittele tätä',
      silentHint: 'Ei heikkous — tavallista asiantuntija- ja uutuusideoille.',
      contradicted: 'Tietopohja on ristiriidassa',
    },
    moreTags: '+{{count}}',
    expandReason: 'Näytä perustelu',
    collapseReason: 'Piilota perustelu',
  },

  impactPath: {
    resetZoom: 'Näytä koko kartta',
    loadingWorkshop: 'Ladataan työpajaa...',
    loadingImpactPath: 'Ladataan vaikutuspolkua...',
    scenariosLoading: 'Ladataan skenaarioita...',
    pathwayLoading: 'Ladataan polkua...',
    minCharsHint: 'vähintään 3 merkkiä',
    selectWorkshop: 'Valitse työpaja',
    selectScenario: 'Valitse skenaario',
    scenarioCount: '{{count}} skenaariota',
    onlineBadge: 'Online',
    liveBadge: 'Live',
    initializingPaths: 'Ei polkuja — alustetaan...',
    chooseFutureFirst: 'Valitse ensin tulevaisuuskuva, niin vaikutuspolku alkaa sen muuttujista.',
    noStarterVariables: 'Skenaariolla ei ole muuttujia, joista vaikutuspolku voisi alkaa.',
    viewMode: {
      mineLabel: 'Omat',
      scenarioLabel: 'Skenaario',
      allLabel: 'Kaikki',
      mineTitle: 'Omat',
      scenarioTitle: 'Skenaario',
      allTitle: 'Kaikki',
      mineDescription: 'Vain omat ideasi tässä skenaariossa.',
      scenarioDescription: 'Kaikkien ideat tässä skenaariossa.',
      allDescription: 'Kaikkien ideat kaikista skenaarioista.',
      ownNodeLegend: 'Sininen reunus = oma idea',
      switchToMine: 'Vaihda Omiin',
      switchToAll: 'Vaihda Kaikkiin',
      introTitle: 'Karttanäkymien käyttö',
      introStepMineTitle: 'Omat',
      introStepMineBody: 'Käytä Omat-näkymää, kun lisäät ja muokkaat omia ideoitasi.',
      introStepAllTitle: 'Kaikki',
      introStepAllBody: 'Käytä Kaikki-näkymää, kun haluat nähdä koko työpajan kartan.',
      introStepKeepTitle: 'Ideat säilyvät',
      introStepKeepBody: 'Näkymän vaihtaminen ei poista lappujasi.',
      introConfirm: 'Selvä',
      bannerDismiss: 'Piilota'
    },
    // Valence (§4b): is this consequence one the room wants?
    valence: {
      label: 'Toivottavuus',
      byAi: 'AI:n arvio',
    },
    votes: { title: 'Onko tämä tärkeä?' },
    notes: { title: 'Huomiot', placeholder: 'Huomio tästä — syy, epäily, lähde…', add: 'Lisää' },
    // Route layout (settings.impactMapLayout = 'route'): goal and milestone cards.
    route: {
      goal: 'Tavoite',
      start: 'Lähtö',
      milestone: 'Virstanpylväs',
      status: { saavutettu: 'Saavutettu', osittain: 'Osittain', ei: 'Ei saavutettu', avoin: 'Avoin' },
      progress: 'Edistyminen',
      progressHint: 'Vain kaupungit, virstanpylväät ja tavoitteet. Pois päältä: koko kartta.',
    },
    // The map drawn from the scene (?scene=1): card kinds and connector words.
    scene: {
      loading: 'Ladataan karttaa…',
      error: 'Karttaa ei voitu ladata: {{message}}',
      empty: 'Kartalla ei ole vielä mitään.',
      kind: {
        mission: 'Lähtö', start: 'Lähtö', done: 'Valmis', goal: 'Tavoite', milestone: 'Virstanpylväs',
        blocker: 'Este', avoider: 'Keino välttää', input: 'Panos', output: 'Tuotos', outcome: 'Tulos',
        impact: 'Vaikuttavuus', consequence: 'Seuraus', condition: 'Edellytys', question: 'Kysymys', target: 'Muutostavoite', endState: 'Päämäärä',
      },
      doneGoals: '{{count}} tavoitetta',
      axis: {
        quarter: 'Q{{n}}', week: 'vk {{n}}', round: 'kierros {{n}}',
        report: 'Raportti {{date}}: {{count}} korttia',
        noDates: 'Näkyvillä korteilla ei ole päivämääriä',
        basis: { stated: '{{date}}', due: 'määräaika {{date}}', reported: 'viimeistään {{date}}' },
      },
      edge: {
        leads_to: 'johtaa', enables: 'mahdollistaa', blocks: 'estää', reinforces: 'vahvistaa', weakens: 'heikentää',
        delays: 'viivästyttää', relates_to: 'liittyy', is_same: 'sama asia', asks: 'kysyy',
      },
    },
    // Adding a blocker on an edge: stopping a wanted consequence, or avoiding an unwanted one.
    // The node modal's neighbourhood (impactmap/neighbourhood): what leads to a card and what follows
    proposedLink: {
      title: 'Ehdotettu yhteys', by: 'AI:n perustelu', accept: 'Hyväksy', reject: 'Hylkää', failed: 'Päätöstä ei tallennettu (HTTP {{status}}).',
    },
    neighbourhood: {
      into: 'Johtaa tähän', outOf: 'Tästä seuraa', none: 'Ei vielä mitään', start: 'Lähtö', avoids: 'välttää',
      error: 'Kartan yhteyksiä ei saatu ladattua.',
      source: { documents: 'Luonnos hankkeen omista raporteista', ai: 'AI:n ehdottama', person: 'Osallistujan kirjoittama' },
    },
    blockerDraft: {
      block: { label: 'Este pysäyttää tämän', title: 'Lisää este', subtitle: 'Mikä estää tämän toteutumisen?' },
      avoid: { label: 'Ei-toivottu seuraus, joka vältetään', title: 'Lisää keino välttää', subtitle: 'Miten tämä vältetään?' },
    },
    // A card drafted from the team's own documents, awaiting a person.
    proposed: {
      title: 'Ehdotus aineistostanne',
      tag: 'aineistosta',
      lead: 'Tämä on luonnos teidän omista raporteistanne. Pidä se, pehmennä omin sanoin tai hylkää.',
      provenanceTitle: 'Perustuu lauseeseen',
      keep: 'Pidä',
      soften: 'Pehmennä',
      softenSave: 'Tallenna pehmennetty',
      softenLabel: 'Kirjoita omin sanoin',
      reject: 'Hylkää',
      reasonPlaceholder: 'Perustelu (valinnainen)',
      decided: { keep: 'Pidetty', soften: 'Pehmennetty omin sanoin', reject: 'Hylätty' },
    },
    nodeModal: {
      headerTitle: 'Mitä tästä seuraa?',
      parentLabel: 'Edellinen',
      titleLabel: 'Otsikko',
      consequencePlaceholder: 'Kirjoita seuraus tähän...',
      thoughtTitlePlaceholder: 'Ajatuksen otsikko...',
      thoughtDescPlaceholder: 'Ajatuksen kuvaus...',
      aiStreaming: 'Kirjoittaa...',
      aiLoading: 'Ladataan...',
      completeLabel: 'Täydennä',
      closeTitle: 'Sulje',
      cancel: 'Peruuta',
      commentsTitle: 'Kommentit',
      addImpact: 'Lisää vaikutus',
      deleteWarning: 'Tämä poistaa myös kaikki {{count}} aliajatusta.',
      deleteBlocked: 'Solmulla on {{count}} muiden osallistujien lisäämää seuraussolmua. Poistaminen ei ole mahdollista.',
      saveFailed: 'Tallentaminen epäonnistui. Yritä uudelleen.',
      deleteFailed: 'Ajatuksen poistaminen epäonnistui. Yritä uudelleen.',
      describeConsequenceLabel: 'KUVAILE SEURAUS',
      titleFieldLabel: 'OTSIKKO',
      descriptionFieldLabel: 'KUVAUS',
      aiAnalyzingThought: 'AI analysoi ajatusta...',
      editButtonTitle: 'Muokkaa',
      editAdjust: 'Muokkaa',
      creating: 'Luodaan...',
      analyzing: 'Analysoidaan...',
      continue: 'Jatka',
      saving: 'Tallennetaan...',
      saveOrAnalyze: 'Arvioi & tallenna',
      defaultNodeTitle: 'Ajatus',
      researchBacked: 'Tutkimukseen perustuva',
      regenerate: 'Luo uudelleen',
      replaceAiTitle: 'Korvaa nykyisen AI-tekstin',
      completeAiTitle: 'Täydennä teksti AI:lla',
      deleteBlockedAlert: 'Ajatuksella on muiden osallistujien lisäämää sisältöä. Poistaminen ei ole mahdollista.',
      commentFailed: 'Kommentin lisääminen epäonnistui. Yritä uudelleen.',
    },
    aiAnalysis: {
      loadingTitle: '⏳ AI analysoi...',
      loadingDescription: 'Luodaan kolme näkökulmaa: este, mahdollisuus, kysymys',
      analysisFailedTitle: '❌ AI-analyysi epäonnistui',
      serviceUnavailable: 'AI-palvelu ei ole juuri nyt saatavilla',
      serviceOverloaded: 'AI-palvelu ylikuormitettu. Yritä hetken kuluttua uudelleen.',
      serviceInternalError: 'AI-palvelun sisäinen virhe. Yritä uudelleen.',
      researchSearchFailed: 'Seuraukset kirjoitettiin ilman tutkimusaineistoa: hakupalvelu ei vastannut.',
      researchNoDatasets: 'Seuraukset kirjoitettiin ilman tutkimusaineistoa: työpajalle ei ole liitetty tutkimusaineistoa.',
      generationErrorTitle: '❌ Virhe AI-analyysissä',
      generationErrorDescription: 'Tekninen virhe. Yritä uudelleen tai jatka ilman AI-apua.',
      academicQuestion: 'Analysoi vaikutuspolun vaihe "{{nodeText}}" ja anna kolme näkökulmaa: este, mahdollisuus, kysymys. Perustele tutkimukseen.',
    },
    consequenceFlow: {
      connectionAdded: 'Ajatus "{{node}}" lisätty seuraukseksi ajatukselle "{{parent}}"',
      connectionExists: 'Tämä yhteys on jo olemassa.',
      connectionFailed: 'Yhteyden luominen epäonnistui. Yritä uudelleen.',
      networkError: 'Verkkovirhe. Tarkista yhteys ja yritä uudelleen.',
      minCharsAlert: 'Kirjoita vähintään 3 merkkiä',
    },
    existingNodeSelector: {
      minCharsAlert: 'Kirjoita vähintään 3 merkkiä',
      title: 'Lisää seuraus',
      parentNodeLabel: 'Edellinen solmu',
      loadingSuggestions: 'Haetaan ehdotuksia...',
      instruction: 'Kirjoita seurauksen otsikko alle. Klikkaamalla "Jatka" haemme samankaltaisia solmuja ja AI-ehdotuksia.',
      titlePlaceholder: 'Kirjoita seurauksen otsikko...',
      relatedSources: 'Liittyviä lähteitä:',
      sourceFallback: 'Lähde',
    },
    nodeType: {
      scenario: 'Skenaario',
      variable: 'Muuttuja',
      consequence: 'Seuraus',
      start: 'START',
    },
    changeScenario: 'Vaihda skenaario',
    infoTab: 'Tietoa',
    infoPanel: {
      workshop: 'Työpaja',
      participants: '{{count}} osallistujaa',
      perspectiveLabel: 'Näkökulman rajaus',
      scenarios: 'Skenaariot ({{count}})',
      active: 'Aktiivinen',
    },
    settings: {
      userInfoSection: 'Käyttäjätiedot',
      userIdLabel: 'Käyttäjätunnus',
      userIdDesc: 'Nykyinen osallistujatunniste',
      notSet: 'Ei asetettu',
      consequenceSection: 'Seurauksen luonti',
      twoStepLabel: 'Kaksivaiheinen seurausvirta',
      twoStepDesc: 'Ohjaa käyttäjät luomaan seuraukset kahdessa vaiheessa: ensin teksti, sitten metatiedot.',
      aiSection: 'AI',
      aiAnalysisLabel: 'AI-analyysi solmuille',
      aiAnalysisDesc: 'Tutkimustuki- ja osuvuusarviot solmuille. Poista käytöstä jos palvelu on hidas.',
      beta: 'beta',
    },
    duplicateCheck: {
      title: 'Valitse vaikutus',
      older: 'Vanhempi',
      newer: 'Uusin',
      combined: 'Yhdistelmä',
      existingFallback: 'Olemassa oleva vaikutus',
      newFallback: 'Uusi vaikutus',
      combinedFallback: 'Yhdistetty vaikutus',
      cancel: 'Peruuta',
      accept: 'Hyväksy valittu',
    },
    addNode: {
      kindLabel: 'Mikä tämä on ketjussa?',
      title: 'Mitä tästä seuraa?',
      titleInstead: 'Mitä voisi tapahtua sen sijaan?',
      subtitle: 'Kirjoita omin sanoin. Solmu menee kartalle heti; AI tiivistää otsikon ja etsii samankaltaiset sen jälkeen.',
      save: 'Lisää kartalle',
      added: 'Lisätty: {{title}}',
    },
    createNode: {
      titleLabelOptional: 'Otsikko (valinnainen)',
      titleHintAi: 'Jätä tyhjäksi, niin AI tiivistää kuvauksesta',
      titlePlaceholderAi: 'AI tiivistää otsikon kuvauksesta',
      descriptionHintLong: 'Voit kirjoittaa pitkästikin',
      optional: 'Valinnainen',
      titleRequired: 'Otsikko on pakollinen',
      title: 'Luo uusi solmu',
      subtitle: 'Täytä solmun tiedot',
      parentLabel: 'Edellinen solmu',
      titleLabel: 'Otsikko *',
      titlePlaceholder: 'Esim. Ilmastonmuutos',
      descriptionLabel: 'Kuvaus',
      descriptionPlaceholder: 'Kuvaile tarkemmin mitä tämä tarkoittaa...',
      researchSources: 'Tutkimuslähteet ({{count}})',
      back: 'Takaisin',
      save: 'Tallenna',
    },
    aiConsequence: {
      title: 'AI ehdottaa seurauksia',
      subtitle: 'Valitse mitä lisätään',
      targetNode: 'Kohdesolmu:',
      loading: 'AI analysoi ja generoi ehdotuksia...',
      description: 'Tekoäly ehdottaa näitä seurauksia perustuen tutkimukseen ja kontekstiin. Voit muokata ehdotuksia ennen lisäämistä.',
      titlePlaceholder: 'Otsikko...',
      descriptionPlaceholder: 'Kuvaus...',
      aiGenerated: 'AI-generoitu',
      confidence: 'Luottamus: {{percent}}%',
      edited: '✏️ Muokattu',
      selectedOne: 'seuraus',
      selectedMany: 'seurausta',
      selectedPrefix: 'Valittu:',
      addSelected: 'Lisää valitut',
      empty: 'AI ei pystynyt generoimaan ehdotuksia.\nYritä uudelleen tai lisää seuraus manuaalisesti.',
    },
    painPointVote: {
      title: 'Kipupisteet: {{scenario}}',
      finish: 'Päätä äänestys ja muodosta muuttujat',
      finishing: 'Lasketaan ääniä…',
      finished: 'Äänestys päättyi: {{votes}} ääntä, {{count}} muuttujaa kartalle.',
      facilitatorOnly: 'Vain fasilitaattori voi päättää äänestyksen.',
    },
    didYouMean: {
      title: 'Ehdotuksia aiheesta',
      subtitle: 'Tekoäly analysoi tutkimuslähteitä',
      searching: 'Haet:',
      parentLabel: 'Edellinen solmu',
      loading: 'Haetaan tutkimuslähteitä ja luodaan ehdotuksia...',
      researchSources: 'Käytetyt tutkimuslähteet ({{count}})',
      aiSuggestions: 'Tekoälyn ehdotukset',
      moodPositive: '👍 Positiivinen',
      moodNegative: '👎 Negatiivinen',
      moodQuestion: '❓ Kysymys',
      moodNeutral: '➖ Neutraali',
      existingSimilar: 'Olemassa olevat samankaltaiset solmut',
      similarity: '{{percent}}% samankaltainen',
      empty: 'Ei löytynyt samankaltaisia solmuja tai ehdotuksia.\nLuo uusi solmu alla.',
      createNew: 'Luo oma solmu',
    },
    similarAfterAdd: {
      title: 'Samankaltaisia solmuja kartalla',
      intro: 'Onko lisäämäsi sama asia kuin jokin näistä? Valitse, niin ne merkitään samaksi. Solmusi jää kartalle joka tapauksessa.',
      notSame: 'Ei sama asia',
      found: '{{count}} samankaltaista solmua kartalla: "{{title}}"',
      show: 'Näytä',
      dismiss: 'Ohita',
      similarity: '{{percent}}% samankaltainen',
    },
    consequenceSelect: {
      title: 'Valitse seuraukset',
      subtitle: 'Liitä nykyiseen solmuun: {{text}}',
      existingSection: 'Olemassa olevat solmut',
      existingDesc: 'Löysimme näitä samankaltaisia solmuja puusta. Voit linkittää niihin ja lisätä kommentin.',
      existingBadge: 'Olemassa oleva',
      depth: 'Syvyys: {{depth}}',
      aiSection: 'AI-ehdotukset',
      aiDesc: 'Tekoäly ehdottaa näitä uusia seurauksia perustuen tutkimukseen ja kontekstiin.',
      aiGenerated: 'AI-generoitu',
      confidence: 'Luottamus: {{percent}}%',
      empty: 'Ei ehdotuksia saatavilla. Yritä uudelleen tai lisää seuraus manuaalisesti.',
      loading: 'Ladataan ehdotuksia...',
      selectedOne: 'seuraus',
      selectedMany: 'seurausta',
      selectedPrefix: 'Valittu:',
      addSelected: 'Lisää valitut',
    },
    academicReview: {
      fillAll: 'Täytä otsikko ja kuvaus kaikille kolmelle näkökulmalle.',
      title: 'Tarkista AI-näkökulmat',
      subtitle: 'Muokkaa tekstejä tarvittaessa ennen tallennusta. Otsikon enimmäispituus on {{max}} merkkiä.',
      labelBlocker: 'Este (blocker)',
      labelPossibility: 'Mahdollisuus (possibility)',
      labelQuestion: 'Kysymys (question)',
      titleLabel: 'Otsikko',
      descriptionLabel: 'Kuvaus',
      cancel: 'Peruuta',
      saveNodes: 'Tallenna solmut',
    },
  },

  futureReimagined: futureReimaginedFi,
  negotiationLab: negotiationLabFi,
  kuusiKenttaa: kuusiKenttaaFi,
  booklet: bookletFi,
  pivotsV3: pivotsV3Fi,
  vipupisteFocus: vipupisteFocusFi,
  statisticsView: statisticsViewFi,
  opinionDatasets: opinionDatasetsFi,
  knowledgeKinds: knowledgeKindsFi,
  sourceTiers: sourceTiersFi,
  instancePrompts: instancePromptsFi,
  solutionsV3: solutionsV3Fi,
  ongelmatV2: ongelmatV2Fi,
  ankkuritV2: ankkuritV2Fi,
  juurisyytV2: juurisyytV2Fi,
  ongelmakarttaV3: ongelmakarttaV3Fi,
  ratkaisutV4: solutionsV4Fi,
  futureV2: futureReimaginedV2Fi,
  impactMapV2: impactMapV2Fi,
  pivotsV2: pivotsV2Fi,
  swotView: swotViewFi,
  ratkaisutV2: {
    views: { analysis: "Analyysi" },
    analysisTitle: "Ratkaisut ja niiden arviot",
    analysisIntro: "Kaikki työpajan ratkaisut, niiden yhteisvaikutus ja tekoälyn arvio siitä, mitä kukin tekisi kartan vipupisteille.",
    noProblem: "Ei ongelmaa",
    work: {
      title: "Mihin vipupisteeseen tartutte?",
      hint: "Valitse vipupiste: suunta, johon asian pitää muuttua. Kartta näyttää juurisyyt, joita se kantaa, ja ongelmat, joihin ne kytkeytyvät, ja sen jälkeen keskustelu auttaa kirjoittamaan ratkaisun, joka liikuttaa sitä.",
      pivotMeta: "Ongelmia: {{problems}} · Ratkaisuja: {{solutions}}",
      focused: "Vipupisteiden valinta on lukittu: tarjolla ovat valitut vipupisteet.",
      empty: "Kartalla ei ole vielä vipupisteitä.",
      focusHint: "Vipupisteen juurisyyt, muutoksen esteet ja ongelmat kartalla. Napauta jatkaaksesi.",
      pivotLabel: "Vipupiste",
      allPivots: "Kaikki vipupisteet…",
      leaveDraft: "Ratkaisuluonnos jää kesken. Vaihdetaanko silti?",
    },
    effects: {
      title: "Mahdolliset vaikutukset",
      hint: "Mitä luonnos voisi tehdä tämän kartan osan vipupisteille. Tallennuksen jälkeen ratkaisu arvioidaan kaikkia vipupisteitä vasten.",
      empty: "Keskustelu nostaa vaikutukset esiin, kun ratkaisu alkaa hahmottua.",
      intended: "Tavoitellut vaikutukset",
      side_effect: "Mahdolliset sivuvaikutukset",
      worsens: "väärään suuntaan",
    },
    setAnalysis: {
      title: 'Ratkaisut kokonaisuutena',
      intro: 'Tekoäly lukee ratkaisut yhdessä: missä ne vetävät toisiaan, intressejä tai tutkimusta vastaan, mitä ne jättävät käsittelemättä ja onko vastaavaa kokeiltu muualla. Jokaisella havainnolla on omat lähteensä.',
      needsSolutions: 'Kirjatkaa ensin ratkaisuja, niin ne voi analysoida kokonaisuutena.',
      waiting: 'Kokonaisanalyysia ei ole vielä ajettu. Fasilitaattori käynnistää sen, ja tulos näkyy tässä, kun se valmistuu.',
      stale: 'Ratkaisut ovat muuttuneet tämän analyysin jälkeen. Luenta koskee aiempaa tilannetta.',
      unaddressed: 'Vipupisteet, joihin mikään ratkaisu ei tartu',
      allAddressed: 'Jokaiseen vipupisteeseen tarttuu ainakin yksi ratkaisu.',
      recommended: 'Kartta-analyysin suosittelema',
      triedElsewhere: 'Kokeiltu muualla',
      newsOnly: 'Perustuu vain uutislähteeseen — ei tutkittua tietoa.',
      outcome: { worked: 'Toimi', mixed: 'Vaihtelevasti', failed: 'Ei toiminut', unclear: 'Epäselvä' },
    },
    portfolioTitle: "Mitä ratkaisut yhdessä liikuttavat",
    portfolioHint: "{{count}} ratkaisua kartan vipupisteitä vasten. Punainen nuoli tarkoittaa, että ratkaisu vie mittaria huonompaan suuntaan.",
    contested: "Ristiriita",
    untouched: "Näihin ei ole vielä kohdistettu yhtään ratkaisua ({{count}})",
    chartMeasured: "Suhteellinen muutos — mittarilla on tilastosarja",
    chartProposed: "Suuntakuva — ehdotettu mittari, ei mittausdataa",
    today: "Tänään",
    yearsOn: "vuoden päästä",
    range: "Vaihteluväli",
    midpoint: "Keskiarvio",
    chartLegend: "Tämä ei ole ennuste vaan skenaario: katkoviiva on arvio, varjostus sen epävarmuus. Mitä kauemmas mennään, sitä leveämpi se on.",
    tagDerived: "Laskettu vaikutusarviosta",
    tags: {
      marginal: "Vaatimaton vaikutus",
      displaces_problem: "Siirtää ongelmaa",
      slow_burn: "Hidas vaikutus",
      wide_reach: "Laaja kattavuus",
      breaks_a_loop: "Osuu silmukkaan",
      no_way_in: "Ei sisäänkäyntiä",
      already_tried: "Kokeiltu jo",
      depends_on_unlikely: "Epävarman varassa",
      research_backed: "Tutkimustukea",
      tested_elsewhere: "Toimii muualla",
      systemic: "Rakenteellinen",
      creative: "Luova",
    },
    scoresTitle: "Arviointi",
    ambitionUnreachable: "Kunnianhimoinen mutta ilman sisäänkäyntiä: yksikään polun askel ei ole aloitettavissa nykyisillä toimijoilla ja valtuuksilla. Se ei tee ratkaisusta huonoa, mutta ensimmäinen askel puuttuu.",
    pathwayMissing: "Polkua ei ole kuvattu. Ilman askeleita ja toimijoita ratkaisua ei voi aloittaa mistään.",
    pathwayTitle: "Polku",
    reasoningTitle: "Perustelu",
    stepCount: "{{count}} askelta",
    blockersTitle: "Esteet",
    now: "Nyt",
    precondition: "Edellyttää",
    couldRemove: "Voisi poistaa",
    score: { feasibility: "Toteutettavuus", ambition: "Kunnianhimo", effectiveness: "Vaikuttavuus" },
    scoreHint: { feasibility: "Voisiko työ alkaa tänä vuonna nykyisillä toimijoilla?", ambition: "Kuinka perustavaa muutosta tämä on?", effectiveness: "Kuinka paljon tämä liikuttaa karttaa?" },
    improve: {
      title: "Paranna ratkaisua",
      intro: "Kysy, haasta arvio tai ehdota muutosta. Kun keskustelusta syntyy parempi versio, se ehdotetaan teille. Hyväksytty parannus arvioidaan uudelleen, ja vanha versio säilyy.",
      placeholder: "Vastaa, kysy tai ehdota muutosta…",
      readAssessment: "Lue arvio",
      writeNew: "Kirjoita uusi ratkaisu",
      versionAccepted: "Versio {{version}} hyväksytty",
      stale: "Luvut ovat edellisestä versiosta.",
    },
    previousScore: "v{{version}}: {{value}}",
    tagNew: "uusi",
    tagsRemoved: "Poistui:",
    versions: { title: "Versiot", current: "nykyinen" },
    wall: {
      title: "Ratkaisut",
      lead: "Arvio päivittyy jokaisen hyväksytyn parannuksen jälkeen.",
      justImproved: "Juuri parannettu",
      next: "Seuraavaksi: Tulevaisuustestaus. Valitsemme yhdessä, mitkä ratkaisut viedään simulaatioon.",
      empty: "Ratkaisuja ei ole vielä kirjoitettu.",
    },
    movesLabel: "Mitä ratkaisu liikuttaa",
    noPivot: "Ei vipupistettä",
    problemsReached: {
      title: "Ongelmat, joihin ratkaisu tarttuu",
      solves: "ratkaisee",
      touches: "tarttuu",
      none: "Arvion mukaan ratkaisu ei tartu yhteenkään työpajan ongelmaan.",
    },
    proposedEdit: "Ehdotus ratkaisun muokkaamiseksi",
    acceptEdit: "Hyväksy muokkaus ja arvioi uudelleen",
    accepting: "Arvioidaan uudelleen…",
    back: "Takaisin ratkaisuihin",
    edit: "Muokkaa",
    showAll: "Näytä koko teksti",
    showLess: "Näytä vähemmän",
    running: "Arvioidaan…",
    runningHint: "Tekoäly käy läpi jokaisen vipupisteen. Arvio valmistuu muutamassa minuutissa, vaikka poistuisit sivulta.",
    notEvaluated: "Vaikutuksia ei ole vielä arvioitu.",
    moves: "Vaikuttaa {{count}} mittariin",
    key: "↑ mittari kasvaa · ↓ mittari laskee · punainen kortti: muutos huonompaan suuntaan",
    figuresExplained: "Mitä luvut tarkoittavat?",
    figuresHelp: "Luku on tekoälyn arvio siitä, kuinka monta prosenttia mittari muuttuisi viidessä vuodessa, jos ratkaisu toteutuisi; suluissa vaihteluväli. Perusta kertoo, nojaako arvio tutkimukseen, vertailukohtaan muualta vai päättelyyn. Avaa kortti nähdäksesi mekanismin, muut vuodet ja riskit.",
    whyAndWhen: "Miksi ja milloin",
    risks: "{{count}} riskiä",
    unchanged: "Ei vaikutusta ({{count}})",
    worsens: "Huonontaa",
    intended: "Tavoiteltu",
    sideEffect: "Sivuvaikutus",
    year: "{{n}} v",
    revisedFrom: "Versio {{from}} → {{to}}",
    noEffect: "ei vaikutusta",
    wasBefore: "aiemmin {{value}}",
    revisedHint: "Luvut tulevat uudesta arviosta, joka ajettiin muokatulle ratkaisulle. Keskustelu ei aseta niitä.",
    lag: "viive {{months}} kk",
    watchFor: "Varhainen merkki",
    threatDelays: "Viivästyttää",
    threatReduces: "Vaimentaa",
    threatBlocks: "Estää",
    basis: { research: "Tutkimus", analogue: "Verrokki", reasoned: "Päätelty" },
    basisSplit: "Perusteet: tutkimus {{research}} · verrokki {{analogue}} · päätelty {{reasoned}}",
    adverseFound: "Todennäköisin haitta",
    adverseNone: "Haittavaikutusta ei löytynyt",
    title: "Ratkaisut",
    intro: "Kirjoita ratkaisuehdotus. Analyysi arvioi sen jokaista kartan vipupistettä vasten — myös niitä joita ette ajatelleet.",
    write: "Kirjoita ratkaisu",
    contextTitle: "Kartan vipupisteet",
    contextHint: "Nämä mittarit työpajanne löysi. Ratkaisua arvioidaan niitä kaikkia vasten.",
    noVipupisteet: "Vipupisteitä ei ole vielä johdettu. Aja vipupisteanalyysi ongelmakartalla ensin.",
    listTitle: "Ratkaisut ({{count}})",
    empty: "Ei vielä ratkaisuja.",
    compose: {
      intro: "Kertokaa ratkaisunne omin sanoin. Kuutio kysyy yhden asian kerrallaan sitä, mitä analyysi tarvitsee arvioidakseen sen reilusti, ja kirjoittaa luonnosta — ehdotus pysyy teidän.",
      startPlaceholder: "Mitä te haluaisitte tehdä?",
      start: "Aloita",
      replyPlaceholder: "Vastaa tähän…",
      send: "Lähetä",
      thinking: "Mietitään…",
      summaryTitle: "Ehdotus ja arvio",
      yourProposal: "Ehdotuksenne",
      yourProposalEmpty: "Tähän kootaan se, mitä te ehdotatte — teidän sanoillanne.",
      draft: "Luonnos",
      draftHint: "Voitte muokata luonnosta suoraan. Muokkaukset menevät mukaan seuraavaan vuoroon.",
      missing: "Analyysiltä vielä puuttuu",
      missingNone: "Ratkaisussa on kaikki, mitä analyysi tarvitsee.",
      suggestions: "Kuution ehdotuksia — napauttamalla lisäätte sen vastaukseenne",
      takeSuggestion: "Otetaan mukaan: {{s}}",
    },
    modalTitle: "Ratkaisuehdotus",
    modalIntro: "Kirjoita omin sanoin. Seuraavassa vaiheessa tekoäly arvioi, mihin mittareihin tämä vaikuttaisi ja kuinka paljon.",
    titleLabel: "Otsikko",
    titlePlaceholder: "Lyhyt nimi ratkaisulle",
    bodyLabel: "Ratkaisu",
    bodyPlaceholder: "Mitä tehdään, kuka tekee ja mikä muuttuu?",
    save: "Tallenna ratkaisu",
  },
  systemicMapV2: {
    whatIsThis: "Mitä tämä on?",
    bindTitle: "Tilastosidos",
    bindIntro: "Tämä on ehdotettu mittari. Etsi sille todellinen tilastosarja työpajan tilastoaineistoista, jolloin projektiot piirtyvät oikealta lähtötasolta.",
    bindSearch: "Etsi tilastosarja",
    bindSearching: "Haetaan…",
    bindSearchingLong: "Haetaan tilastoista… {{elapsed}} s. Haku käy läpi tilastoluettelon ja voi kestää minuutin.",
    bindFailed: "Jokin meni pieleen. Yritä hetken päästä uudelleen.",
    bindNoDataset: "Tähän kuutioon ei ole liitetty tilastoja, joten tilastosarjoja ei haeta. Ne liitetään kohdassa Valmistelu → Tietopohja.",
    bindConfirm: "Vahvista tämä sarja",
    binding: "Sidotaan…",
    bindPoints: "{{count}} havaintoa",
    bindNone: {
      no_topic: "Tilastokeskuksen luettelosta ei löytynyt aihetta, joka mittaisi tätä. Mittari jää ehdotetuksi; sitä voi silti käyttää keskustelussa.",
      no_tables: "Aiheesta ei löytynyt tilastotauluja. Mittari jää ehdotetuksi; sitä voi silti käyttää keskustelussa.",
      no_table_match: "Työpajan tilastoaineistoista ei löytynyt taulua, joka mittaisi tätä. Mittari jää ehdotetuksi; sitä voi silti käyttää keskustelussa.",
      unpinned_dimensions: "Tilastoja löytyi, mutta mikään ei vastannut tätä mittaria tarkasti, joten mitään ei sidottu arvaamalla. Mittari jää ehdotetuksi.",
      no_series: "Tilastosarjaa ei saatu haettua juuri nyt. Voit yrittää hetken päästä uudelleen.",
    },
    statfiReview: {
      waiting: "{{count}} odottaa",
      title: "Tilastot mittareille",
      intro: "Haku etsii jokaiselle ehdotetulle mittarille sarjan työpajan tilastoaineistoista: omista tauluista ja Tilastokeskuksesta. Mitään ei sidota ilman vahvistusta: katso taulun nimi, mitä sarja mittaa ja viimeiset arvot, ja vahvista tai ohita.",
      preparing: "Valmistellaan hakua…",
      progress: "{{stage}} · {{searched}} / {{metrics}} mittaria valmiina",
      stages: {
        file: "Etsitään työpajan omista tilastoista",
        catalogue: "Tarkistetaan luetteloa",
        triage: "Valitaan aiheita",
        tables: "Valitaan tauluja",
        metadata: "Haetaan taulujen tietoja",
        filters: "Rajataan kyselyitä",
        series: "Haetaan sarjoja",
        stewards: "Ehdotetaan mittaajia",
      },
      summary: "{{measured}} sidottu · {{review}} odottaa tarkistusta · {{none}} ilman sopivaa sarjaa · {{skipped}} ohitettu · {{errors}} virhettä · {{pending}} hakematta",
      skip: "Ohita mittari",
    },
    statfiSource: {
      label: "Lähde:",
      provider: "Tilastokeskus",
      table: "taulu {{table}}",
      open: "Avaa taulu",
    },
    steward: {
      noDataset: "Tilastokeskukselta ei löytynyt aineistoa tälle mittarille.",
      title: "Kuka voisi mitata tämän?",
      practice: "Käytännössä",
      responsible: "Vastuu tilastoinnista",
      basis: "Tekoälyn päättelemä ehdotus, ei lähdettä.",
      pending: "Ehdotus siitä, kuka voisi mitata tämän, kirjoitetaan seuraavassa tilastohaussa.",
    },
    loopsTitle: "Silmukat",
    loopsIntro: "Silmukka syntyy kun vipupiste vaikuttaa takaisin juurisyyhyn. Nämä ovat kartan ainoat päätellyt kaaret — kaikki muu on olemassa siksi, että joku kirjoitti solmun toisen alle. Siksi kynnys on korkea ja tyhjä tulos on kelvollinen vastaus.",
    noLoops: "Silmukoita ei ole. Se ei ole vika: aineistossa ei toistaiseksi ole kahta vipupistettä, joiden juurisyyt vaikuttaisivat toisiinsa riittävän varmasti.",
    reinforcing: "Vahvistava kierre",
    balancing: "Tasapainottava",
    conditional: "Ehdollinen",
    conditionalHint: "Silmukassa on edellytys. Se pyörii vain niin kauan kuin edellytys on voimassa.",
    measuresLink: "mittari",
    effectTypes: {
      leads_to: "johtaa",
      reinforces: "vahvistaa",
      weakens: "heikentää",
      nullifies: "kumoaa",
      enables: "mahdollistaa",
      blocks: "estää",
      requires: "edellyttää",
      delays: "viivästyttää",
      relates_to: "liittyy",
      is_same: "sama asia",
    },
    loopSteps: "{{count}} askelta",
    noNodeReasoning: 'Tälle solmulle ei ole kirjattu omaa perustelua.',
    carousel: {
      clear: 'Tyhjennä valinta',
      causes: "Syyt",
      effects: "Seuraukset",
      lateral: "Liittyvät",
      back: "Takaisin",
    },
    legend: {
      title: "Yhteyksien värit",
      toggle: "Näytä tai piilota selite",
      families: {
        amplify: "Vahvistaa",
        dampen: "Heikentää",
        enabling: "Mahdollistaa",
        neutral: "Liittyy",
      },
      untyped: "Ei tyyppiä vielä",
    },
    lists: {
      title: 'Kartan listat',
      all: 'Kaikki',
      nodes: 'Solmut',
      edges: 'Yhteydet',
      loops: 'Silmukat',
      search: 'Hae…',
      none: 'Ei osumia.',
      noLoops: 'Kartalla ei ole vielä silmukoita.',
      nodeTypes: { ongelma: 'Ongelma', este: 'Muutoksen este', juurisyy: 'Juurisyy', vipupiste: 'Vipupiste' },
      edgeTypes: { petal: 'Este → ongelma', mechanism: 'Juurisyy → este', measures: 'Vipupiste', causal: 'Takaisinkytkentä' },
      strength: { strong: 'vahva', weak: 'heikko' },
      open: 'Avaa',
      loopKinds: { conditional: 'Ehdollinen', reinforcing: 'Vahvistava', balancing: 'Tasapainottava' },
    },
    edge: {
      details: 'Lisätiedot',
      nature: 'Yhteyden luonne',
      reasoning: 'Perustelu',
      loopPath: 'Silmukan reitti',
      metric: 'Mittari',
      noReasoning: 'Tälle yhteydelle ei ole kirjattu perustelua.',
      kinds: { petal: 'Muutoksen este pitää ongelmaa paikallaan: niin kauan kuin este on voimassa, ongelma ei hellitä.', mechanism: 'Juurisyy pitää estettä yllä: se on syy, jonka takia este on voimassa.', measures: 'Vipupiste kertoo, mihin suuntaan juurisyyn taustalla olevan asian pitää muuttua, ja sen mittari, millä juurisyyn tasoa voi seurata. Yhteys ei väitä vaikutusta.', causal: 'Takaisinkytkentä: kun vipupiste liikkuu, kohde muuttuu. Tämän yhteyden päätteli tekoäly kartan pohjalta.' },
      sign: { '+': 'Kun syy kasvaa, seuraus kasvaa.', '-': 'Kun syy kasvaa, seuraus heikkenee.' },
      title: 'Yhteys',
      from: 'Syy',
      to: 'Seuraus',
      kind: 'Yhteyden laji',
      relation: 'Mekanismi',
      assumption: 'Oletus',
      testQuestion: 'Testikysymys',
      counterArgument: 'Vastaväite',
      confidence: 'Varmuus',
      aiMade: 'Tekoälyn päättelemä yhteys',
    },
    analysisTitle: "Työpajan analyysi",
    analysisIntro: "Raskas luenta koko aineistosta: kaikki ongelmat, muutoksen esteet, juurisyyt ja niiden arviot kerralla. Erottelee mitä työpaja on osoittanut, mitä siitä seuraa ja mitä ei tiedetä.",
    analysisWaiting: "Analyysia ei ole vielä ajettu. Fasilitaattori käynnistää sen, ja tulos näkyy tässä, kun se valmistuu.",
    staleWarning: "Kartta on muuttunut tämän analyysin jälkeen. Luenta koskee aiempaa tilannetta.",
    overview: "Kokonaiskuva",
    patternTitle: "Kokonaisuuden muoto",
    contradictions: "Ristiriidat",
    gaps: "Aukot ja ohuet kohdat",
    tensions: "Jännitteet ja erimielisyydet",
    blindSpots: "Sokeat pisteet",
    reasoningOnly: "Analyysin oma päättely — lähteet eivät riitä osoittamaan erimielisyyttä",
    tensionKind: { room: "Ryhmässä", interests: "Intressit", research: "Tutkimus", room_vs_research: "Ryhmä vs. tutkimus", solutions_conflict: "Ratkaisujen välillä" },
    blindSpotKind: { research_not_on_map: "Tutkimuksessa, ei kartalla", unaddressed_dimension: "Käsittelemättä", alternative_frame: "Toinen näkökulma", unaddressed_lever: "Vipupiste ilman ratkaisua", research_not_addressed: "Tutkimuksessa, ei ratkaisuissa", alternative_approach: "Toinen lähestymistapa" },
    webSearchFailed: "Verkkohaku ei onnistunut, joten analyysi perustuu vain työpajan aineistoon.",
    recommendation: "Mistä seuraavaksi",
    generatedAt: "Analyysi ajettu {{when}}",
    whyTitle: "Miksi tämä nousi",
    established: "Aineisto osoittaa",
    follows: "Tästä seuraa",
    notKnown: "Tätä ei tiedetä",
    noAnalysisForNode: "Analyysia ei ole vielä ajettu. Aja se kartan alta saadaksesi perustelun.",
    reachTitle: "Kattavuus",
    metricsTitle: "Vipupisteet",
    verdictsTitle: "Ryhmän arviot",
    verdictsHint: "{{count}} arviota. Luku on osallistujamäärä, ei yksimielisyys.",
    carriesTitle: "Juurisyyt, joihin tämä vipupiste vaikuttaa",
    lever: { what: 'Mikä vipupiste on', why: 'Miksi tähän suuntaan', how: 'Miten sitä voi mitata', metric: 'Mittari: {{label}}', details: 'Miksi tähän suuntaan ja miten mitataan', pending: 'Tätä vipupistettä ei ole vielä muotoiltu. Fasilitaattori käynnistää muotoilun; sitä ennen näkyy mittari, jolla sitä seurataan.' },
    introGraph: 'Sama työpaja koko verkkona: ongelmat, muutoksen esteet, juurisyyt ja niiden mittaamat vipupisteet. Raahaa, zoomaa ja käännä. Vipupisteet ovat vihreitä.',
    views: { 'analysis': 'Analyysi', '2d': '2D-kartta', 'sphere': '3D-pallo', 'galaxy': 'Galaksi' },
    map3dFailed: { title: 'Kolmiulotteinen näkymä ei käynnisty', hint: 'Selaimesi ei antanut 3D-näkymälle WebGL-yhteyttä (näytönohjain tai laitteistokiihdytys pois päältä?). 2D-kartta ja listat toimivat ilman.', back: 'Takaisin 2D-karttaan' },
    title: 'Ongelmakartta',
    intro: 'Työpajan tulos yhtenä kuvana. Ongelmat kehällä, niiden juurisyyt ympärillä, ja keskellä vipupisteet — suureet joita useampi juurisyy liikuttaa. Mitä useampaan ongelmaan vipupiste yltää, sitä lähempänä keskustaa se on.',
    vipupisteetTitle: 'Vipupisteet',
    vipupisteetHint: 'Järjestetty sen mukaan, moneenko ongelmaan suure yltää. Useaan ongelmaan yltävä vipupiste on se, jota liikuttamalla vaikutus tuntuu useammassa kohdassa.',
    noVipupisteet: 'Kartalla ei ole vielä yhteisiä vipupisteitä. Vipupiste nousee kartalle, kun usea juurisyy jakaa sen.',
    reach: '{{juurisyyt}} juurisyytä · {{ongelmat}} ongelmaa',
    carries: 'Kantaa {{count}} juurisyytä:',
    legendApproved: 'Hyväksytty juurisyy',
    legendRejected: 'Hylätty',
    legendUnjudged: 'Arvioimatta',
    legendApproval: 'Juurisyyn väri: hyväksyntä 0 % (punainen) – 100 % (vihreä), harmaa = ei ääniä',
    sources: {
      fold: 'Lähteet ({{count}})',
      web: 'Verkkolähteet',
      webNote: 'Haettu verkosta, rajattu tarkistettuihin julkaisijoihin.',
      openPage: 'Avaa sivu',
      answered: 'Vastasi kysymykseen',
      pageAge: 'Julkaistu',
      credibility: { research: 'Tutkimus', official: 'Viranomainen', organisation: 'Järjestö', interest: 'Etujärjestö', news: 'Uutinen' },
      unavailable: 'Lähdepalvelu ei vastannut — perusteluja ei voitu tarkistaa aineistosta.',
      none: 'Ei lähdettä työpajan aineistossa.',
      workshop: 'Työpajan aineisto',
    },
    review: {
      noVotes: 'ei ääniä',
      approval: '{{pct}} % · {{votes}} ääntä',
      earlierVersion: 'v{{version}}: {{approve}}/{{votes}} hyväksyi, tarkennettu',
    },
    admin: {
      summary: '{{cards}} juurisyytä · {{voted}} äänestetty · {{kept}} pidetty · {{revised}} muokattu · {{toDelete}} poistetaan · {{culled}} poistettu · {{open}} käsittelemättä',
      openHint: 'Arviot ovat auki. Lukitse ne vuonohjauksen painikkeella, kun keskustelu on käyty.',
      lockedBy: 'Lukittu {{at}} ({{by}})',
      unlock: 'Avaa lukitus',
      unlockReason: 'Miksi lukitus avataan? Syy tallennetaan.',
      swipeTab: 'Pyyhkäisy',
      discussionTab: 'Keskustelu',
      deckTally: '{{cards}} korttia · {{voted}} äänestetty · {{votes}} ääntä',
      tally: '👍 {{approve}} · 👎 {{reject}} · ✎ {{refine}}',
      splitSelf: 'Tekijät 👍 {{approve}} · 👎 {{reject}} · ✎ {{refine}}',
      splitOutside: 'Muut 👍 {{approve}} · 👎 {{reject}} · ✎ {{refine}}',
      onWall: 'Näytä seinällä',
      offWall: 'Pois seinältä',
      keep: 'Pidä',
      edit: 'Muokkaa',
      reject: 'Hylkää',
      undoReject: 'Peru hylkäys',
      askAi: 'Kysy tekoälyltä',
      notePlaceholder: 'Mitä huone sanoo? (tekoäly käyttää tätä)',
      saveVersion: 'Tallenna uusi versio (hyväksytty)',
      culled: 'Poistettu kartalta',
      wallEmpty: 'Keskusteltava juurisyy näkyy tässä, kun fasilitaattori nostaa sen seinälle.',
      outcomes: { keep: 'Pidetty', revise: 'Muokattu', reject: 'Poistetaan' },
      moderatePrompt: 'Huone äänesti tästä juurisyystä: {{approve}} hyväksyi, {{reject}} hylkäsi, {{refine}} pyysi tarkennusta. Huone sanoo: {{note}}. Nimeä lyhyesti, mistä erimielisyys näyttää johtuvan, ja ehdota tarkempaa muotoilua.',
    },
    legendMeasured: 'Mitattu vipupiste',
    legendProposed: 'Ehdotettu vipupiste',
    legendLateral: 'Yltää useaan ongelmaan',
  },
  juurisyyV2: {
    generation: {
      loading: 'Ladataan…',
      neverRun: 'Juurisyiden generointia ei ole käynnistetty vielä. Fasilitaattori käynnistää sen.',
      running: 'Generoidaan juurisyitä… {{done}} / {{total}} estettä',
      connecting: 'Yhdistetään juurisyitä ja vipupisteitä…',
      building: 'Kartta rakentuu…',
      failed: 'Kaikkea ei saatu generoitua. Kartan voi silti avata.',
      doneTitle: 'Juurisyyt on generoitu',
      doneHint: 'Kartta on valmis arvioitavaksi.',
      open: 'Avaa kartta',
      openAnyway: 'Avaa kartta silti',
      fallback: '3D-kuvaa ei voi näyttää tällä laitteella.',
    },
    title: 'Juurisyyt',
    loading: 'Ladataan…',
    error: 'Jokin meni pieleen',
    card: {
      whyTitle: 'Miksi tämä juurisyy',
      metricsTitle: 'Vipupisteet ja mittarit',
      noMetrics: 'Juurisyyllä ei ole vielä vipupistettä.',
      shows: 'Mitä se kertoisi',
      latest: 'Viimeisin arvo: {{value}} ({{period}})',
      table: 'Tilastokeskus: {{table}}',
      sources: 'Lähteet ({{count}})',
    },
    map: {
      hint: "Napauta juurisyytä äänestääksesi. Napauta estettä ehdottaaksesi uuden juurisyyn.",
      all: "Kaikki",
      voteTitle: "Äänestä juurisyystä",
      proposeTitle: "Ehdota juurisyytä tälle esteelle",
      yourVote: "Äänesi",
      noVote: "Et ole vielä äänestänyt tästä",
      votes: "Äänet",
      earlier: "Aiemmat versiot",
      resetsVotes: "Muokkaus aloittaa uuden version: nykyiset {{count}} ääntä jäävät aiemmaksi versioksi ja huone äänestää uudelleen.",
      resetsNone: "Muokkaus aloittaa uuden version, josta huone äänestää uudelleen.",
      stale: "Juurisyytä muokattiin. Tämä on nykyinen versio: äänestä siitä.",
      lockedNote: "Arviot on lukittu: äänet eivät enää muutu.",
      proposed: "Ehdotus",
      loadFailed: "Juurisyyn lataus epäonnistui",
      counts: { approve: "Hyväksyi", reject: "Hylkäsi", refine: "Tarkentaisi" },
    },
    cardsLeft: 'Kortteja jäljellä: {{count}}',
    intro: {
      title: 'Näin tämä toimii',
      body: 'AI on johtanut juurisyyt teidän muutoksen esteistänne. Teidän tehtävänne on arvioida ne — ei kirjoittaa uusia.',
      approve: 'Hyväksy: tämä on todellinen syy meidän maailmassamme.',
      reject: 'Hylkää: tämä ei pidä paikkaansa. Kortti ei katoa, hylkäys jää muistiin.',
      refine: 'Tarkenna: tässä on jotain vialla. Kerrotte mikä, ja saatte uuden version arvioitavaksi.',
      swipeHint: 'Voit myös pyyhkäistä korttia: oikealle hyväksyt, vasemmalle hylkäät.',
      start: 'Aloita',
    },
    add: {
      open: 'Lisää puuttuva juurisyy',
      pickAnchor: 'Minkä esteen juurisyy tämä on?',
      pickAnchorHint: 'Valitse muutoksen este, jota tämä juurisyy pitää yllä.',
      noAnchors: 'Tällä ongelmalla ei ole vielä muutoksen esteitä.',
      writeTitle: 'Kirjoita juurisyy omin sanoin',
      writeHint: 'Kerro mikä syy pitää tätä estettä yllä. AI muotoilee sen kortiksi — se ei korvaa ajatustanne omallaan.',
      placeholder: 'Meidän mielestämme tämän takana on…',
      proposalLabel: 'Ehdotus kortiksi',
      duplicate: 'Tämä on jo pinossa toisin sanoin:',
      save: 'Tallenna kartalle',
      saved: 'Tallennettu',
      changeAnchor: 'Vaihda estettä',
      cancel: 'Peruuta',
    },
    approve: 'Hyväksy',
    reject: 'Hylkää',
    refine: 'Tarkenna',
    metricMeasured: 'Mitattu',
    metricMeasurable: 'Ehdotettu mittari — tilastoitavissa',
    metricCount: '{{count}} mittaria',
    metricProposed: 'Ehdotettu mittari — ei mittausdataa',
    refineTitle: 'Mikä tässä on vialla?',
    refinePlaceholder: 'Kertokaa omin sanoin…',
    send: 'Lähetä',
    thinking: 'Mietitään…',
    newVersion: 'Uusi versio',
    acceptVersion: 'Arvioi tämä versio',
    cancelRefine: 'Palaa korttiin',
    deckDone: 'Pakka on käyty läpi.',
    locked: 'Arviot on lukittu',
    lockedHint: 'Fasilitaattori on lukinnut juurisyiden arviot. Äänestys on päättynyt.',
    why: {
      title: 'Miksi tämä kortti?',
      falsifier: 'Väärä, jos:',
      ownReasoning: 'Tarkoituksella päättelyä:',
      more: 'Mikä kumoaisi tämän, ja päättelyn perusta',
      unverified: 'Tutkimustarkistus ei valmistunut tälle kortille.',
      unverifiedRefined: 'Ryhmän tarkentama sanamuoto: sitä ei ole vielä tarkistettu tutkimusta vasten.',
      basis: { research: 'Tutkimus', analogue: 'Vertailukohta', reasoned: 'Päättely' },
    },
    links: {
      title: 'Yhteydet',
      shared: 'Jaettu {{count}} muun juurisyyn kanssa (ongelmat: {{ongelmat}})',
      alone: 'Ei vielä muiden juurisyiden kanssa jaettu',
      vipupiste: 'Kartalla vipupisteenä',
      show: 'näytä',
      hide: 'piilota',
      inLoop: 'Osa takaisinkytkentäsilmukkaa',
    },
    notFound: 'Eikö keskeinen juurisyy löytynyt?',
    notFoundHint: 'Jos jotain olennaista puuttuu, kertokaa siitä.',
    backToDecks: 'Takaisin pakkoihin',
    decks: {
      title: 'Pakkasi',
      hint: 'Arvioi juurisyyt kortti kerrallaan: pyyhkäise oikealle hyväksyäksesi, vasemmalle hylätäksesi, tai pyydä tarkennusta.',
      own: 'Omat muutoksen esteesi',
      ownHint: 'Tekoäly johti nämä juurisyyt teidän kirjaamistanne esteistä. Osuiko se?',
      others: 'Muiden esteet',
      othersHint: 'Ulkopuolinen katse muiden kirjaamiin esteisiin.',
      left: '{{count}} / {{total}} jäljellä',
      done: 'Valmis',
      allDone: 'Kaikki pakkasi on käyty läpi. Kiitos!',
      more: 'Arvioi lisää',
      noMore: 'Kaikki muutoksen esteet on jo jaettu arvioitaviksi.',
      none: 'Sinulle ei ole vielä pakkoja: juurisyitä ei ole vielä johdettu, tai ne on jo käsitelty.',
      nextDeck: 'Seuraava pakka',
    },
    version: 'versio {{n}}',
  },
  ongelmaV2: {
    title: 'Ongelmat',
    intro: 'Minkä ongelman kohtaat työssäsi tai olet tunnistanut tässä aiheessa? Kirjoita yksi asia kerrallaan omin sanoin.',
    hint: 'Kirjoittakaa niin monta konkreettista asiaa kuin haluatte.',
    placeholder: 'Yksi konkreettinen ongelma tai havainto…',
    start: 'Aloita',
    thinking: 'Mietitään…',
    reply: 'Vastaa…',
    send: 'Lähetä',
    refinedTitle: 'Ehdotus muotoiluksi',
    useRefined: 'Käytä tätä',
    keepMine: 'Pidä oma muotoiluni',
    save: 'Tallenna ongelma',
    saved: 'Tallennettu',
    saving: 'Tallennetaan…',
    yours: 'Sinun ongelmasi',
    none: 'Et ole vielä tallentanut ongelmia.',
    another: 'Kirjoita toinen ongelma',
    current: 'Työn alla',
    discard: 'Hylkää',
    error: 'Jokin meni pieleen',
  },
  systemicV2: {
    title: 'Ongelmakartta',
    subtitle: 'Muutoksen esteet linssi kerrallaan',
    loading: 'Ladataan…',
    error: 'Jokin meni pieleen',
    retry: 'Yritä uudelleen',
    back: 'Takaisin',
    steps: {
      ongelma: 'Ongelma',
      lens: 'Linssi',
      dialogue: 'Keskustelu',
    },
    crumbs: { label: 'Vaiheet', pending: 'valitse…' },
    ongelmaPicker: {
      title: 'Mihin ongelmaan tartutaan?',
      subtitle: 'Valitse se, jonka parissa ryhmäsi työskentelee.',
      empty: 'Tälle työpajalle ei ole vielä ongelmia.',
      anchorCount: 'Muutoksen esteitä: {{count}}',
    },
    ongelmaRail: {
      change: 'Vaihda ongelmaa',
      changeLens: 'Vaihda linssiä',
    },
    lensPicker: {
      title: 'Minkä linssin läpi katsot?',
      subtitle: 'Linssi rajaa sen, millaisia muutoksen esteitä etsit.',
      empty: 'Tälle työpajalle ei ole määritelty linssejä.',
    },
    dialogue: {
      close: 'Sulje keskustelu',
      title: 'Mikä pitää tätä paikallaan?',
      opening: 'Voit kertoa omin sanoin, tai lähteä liikkeelle jostakin näistä.',
      ownWords: 'Kerron omin sanoin',
      suggestionsTitle: 'Tai aloita tästä',
      placeholder: 'Kirjoita tähän…',
      send: 'Lähetä',
      thinking: 'Mietitään…',
      anchorsTitle: 'Löydetyt muutoksen esteet',
      anchorsEmpty: 'Ei vielä esteitä — keskustelu tuottaa ne.',
      accept: 'Tallenna muutoksen esteeksi',
      accepted: 'Tallennettu',
      remove: 'Poista este',
      removeConfirm: 'Poistetaanko este ja siitä johdetut juurisyyt?',
      removeYes: 'Poista',
      removeNo: 'Peruuta',
      removeJudged: 'Estettä ei voi enää poistaa: ryhmä on jo arvioinut sen juurisyitä.',
      finish: 'Valmis tämän esteen osalta',
      finishHint: 'Kun tämä este on valmis, voit vaihtaa linssiä tai ongelmaa.',
    },
    swapGuard: {
      title: 'Vaihdetaanko kesken keskustelun?',
      bodyLens: 'Keskustelu tästä esteestä jää kesken. Uusi linssi aloittaa uuden keskustelun.',
      bodyOngelma: 'Keskustelu tästä esteestä jää kesken. Uusi ongelma aloittaa uuden keskustelun.',
      confirm: 'Vaihda silti',
      cancel: 'Jatka keskustelua',
    },
    chain: {
      holds: 'pitää paikallaan',
      seenThrough: 'nähtynä linssin läpi',
    },
  },
  systemicMap: {
    title: 'Systeemikartta',
    nodeTypes: {
      v1: { ongelma: 'Kipupiste', este: 'Este', juurisyy: 'Ilmiö', vipupiste: 'Vipupiste' },
      v2: { ongelma: 'Ongelma', este: 'Muutoksen este', juurisyy: 'Juurisyy', vipupiste: 'Vipupiste' },
    },
    loading: 'Ladataan…',
    refresh: 'Päivitä',
    stages: {
      map: 'Kartta',
      kipupisteet: 'Kipupisteet',
      blockers: 'Esteet',
      esteet: 'Esteet',
      loops: 'Silmukat',
    },
    empty: {
      title: 'Kartta on tyhjä',
      body: 'Aloita lisäämällä kipupiste — epätoivottu tila, jonka asiantuntijat tunnistavat.',
      cta: 'Lisää ensimmäinen kipupiste',
    },
    deepen: {
      title: 'Syvennä estettä',
      subtitle: 'Keskustele AI:n kanssa kohti konkreettisia ilmiöitä',
      placeholder: 'Vastaa tai tarkenna…',
      send: 'Lähetä',
      start: 'Aloita syventäminen',
      loading: 'AI miettii…',
      candidates: 'Ehdokassolmut',
      accept: 'Lisää karttaan',
      editTitle: 'Muokkaa otsikkoa',
      agency: 'Toimijuus',
      close: 'Sulje',
      doneHint: 'Tämä este vaikuttaa riittävän syvältä — voit sulkea tai jatkaa.',
      openFromNode: 'Syvennä AI:lla',
      error: 'Syventäminen epäonnistui',
    },
    addKipupiste: 'Lisää kipupiste',
    flowerList: {
      title: 'Kipupisteet',
      orphans: 'Muut solmut',
      noPetals: 'Ei esteitä vielä',
    },
    errors: {
      noInstance: 'Valitse työpajainstanssi (kid) avataksesi systeemikartan.',
      loadFailed: 'Systeemikartan lataus epäonnistui.',
      esteEsteForbidden: 'Kahta estettä ei voi yhdistää suoraan — lisää ilmiö niiden väliin.',
    },
    edgeModal: {
      title: 'Yhteys',
      proposed: 'AI-ehdotus — vahvista tai muokkaa',
      confirmed: 'Vahvistettu',
      contested: 'Kiistanalainen',
      aiSuggested: 'AI',
      polarity: 'Vaikutus',
      strengthens: '+ Vahvistaa',
      weakens: '− Heikentää',
      strength: 'Vahvuus',
      strengthWeak: 'Heikko',
      strengthStrong: 'Vahva',
      rationale: 'Perustelu',
      rationalePlaceholder: 'Miksi tämä yhteys toimii näin?',
      counterArgument: 'Vaihtoehtoinen polku',
      answerTest: 'Vastauksesi testikysymykseen (valinnainen)',
      answerTestPlaceholder: 'Miten testaisit tätä?',
      save: 'Tallenna',
      confirm: 'Vahvista ehdotus',
      reject: 'Poista yhteys',
      close: 'Sulje',
      spineHint: 'Tämä on layout-yhteys. Tallennus luo sen päälle tyypitetyn kausaalisen yhteyden.',
      saveSpine: 'Luo tyypitetty yhteys',
      addBlocker: 'Lisää este tälle yhteydelle',
    },
    loops: {
      title: 'Takaisinkytkentäsilmukat',
      empty: 'Ei vahvistettuja silmukoita vielä. Vahvista yhteyksien polariteetit, jotta vahvistavat (R) ja tasapainottavat (B) silmukat löytyvät.',
      reinforcing: 'R',
      balancing: 'B',
      nodes: 'solmua',
      nameWithAi: 'Nimeä AI:lla',
      naming: 'Nimetään…',
      leverageWithAi: 'Vipukohdat AI:lla',
      leverageLoading: 'Etsitään vipukohtia…',
      leverageTitle: 'Mahdolliset vipukohdat',
    },
    list: {
      title: 'Lista',
      nodes: 'Solmut',
      connections: 'Yhteydet',
      loops: 'Silmukat',
      nodesEmpty: 'Kartalla ei ole vielä tekijöitä.',
      connectionsEmpty: 'Yhteyksiä ei ole vielä.',
      filtersLabel: 'Suodata solmutyypin mukaan',
    },
    duplicates: {
      title: 'Vastaava tekijä löytyi',
      subtitle: '„{{existing}}” näyttää samalta kuin uusi „{{neu}}”. Haluatko käyttää olemassa olevaa?',
      useExisting: 'Käytä olemassa olevaa',
      keepBoth: 'Pidä molemmat',
    },
    assumption: {
      reveal: 'Avaa oletus AI:lla',
      loading: 'Avataan oletusta…',
      label: 'Oletus',
      testQuestion: 'Testikysymys',
    },
    critique: {
      title: 'Karttakritiikki',
      run: 'Karttakritiikki',
      loading: 'Analysoidaan…',
      empty: 'Ei kysymyksiä tällä kertaa.',
      close: 'Sulje',
      check: 'Tarkista AI:lla',
      checking: 'Kriittinen AI miettii…',
      errorTimeout: 'Tarkistus kesti liian kauan. Voit yrittää uudelleen tai lisätä silti.',
      errorFailed: 'Tarkistus epäonnistui. Voit yrittää uudelleen tai lisätä silti.',
      dialogHint: 'Kirjoita tekijä ja paina Tarkista — AI haastaa muodon, mekanismin ja uskottavuuden ennen tallennusta.',
      checkFirstHint: 'Tallennus avautuu tarkistuksen jälkeen. Virhetilanteessa voit silti lisätä.',
      verdictReady: 'Valmis kartalle',
      verdictRefine: 'Kannattaa vielä miettiä',
      mechanism: 'Mekanismi',
      relevance: 'Relevanssi',
      plausibility: 'Uskottavuus',
      suggestedRewrite: 'Ehdotettu muotoilu',
      applyRewrite: 'Käytä ehdotusta',
      applyRewriteAndAdd: 'Lisää tällä muodolla',
      possibleDuplicate: 'Mahdollinen kaksoiskappale: „{{title}}”',
      replyLabel: 'Vastauksesi AI:lle',
      replyPlaceholder: 'Perustele tai tarkenna…',
      sendReply: 'Lähetä vastaus',
      edit: 'Muokkaa',
      addAnyway: 'Lisää silti',
      openQuestion: 'Avoin kysymys',
      replyNow: 'Vastaa nyt',
      dialogueTitle: 'Kriittinen dialogi',
      contestedFilter: 'Kiistanalaiset',
      contestedEmpty: 'Ei kiistanalaisia solmuja tai yhteyksiä.',
      categories: {
        gap: 'Aukko',
        hub: 'Keskitin',
        loop: 'Silmukka',
        contested: 'Kiistanalainen',
        rationale: 'Perustelu',
        dialogue: 'Dialogi',
        other: 'Muu',
      },
    },
    blockers: {
      title: 'Esteet (vastustavat muutosta)',
      suggestAi: 'Ehdota esteitä AI:lla',
      loading: 'Kysytään AI:lta…',
      empty: 'Ei ehdotuksia vielä. Aja AI-ehdotus tai lisää este käsin.',
      weakens: 'Heikentää',
      accept: 'Lisää karttaan',
      dismiss: 'Hylkää',
      manualTitle: 'Lisää este käsin',
      fieldTitle: 'Este',
      fieldDescription: 'Kuvaus',
      fieldTarget: 'Mitä se heikentää?',
      pickTarget: 'Valitse kipupiste…',
      pickKipupiste: 'Valitse ensin kipupiste, johon este liittyy.',
      add: 'Lisää este',
      proposedTitle: 'Vahvistamattomat esteet',
      confirm: 'Vahvista',
      reject: 'Hylkää yhteys',
      scopeLabel: 'Voimmeko vaikuttaa tähän?',
      scopeEndogenous: 'Voimme vaikuttaa tähän',
      scopeExogenous: 'Emme voi vaikuttaa — reunaehto',
      fromEdgeHint: 'Este kytketään valittuun yhteyteen (heikentää yhteyden kohdesolmua).',
      votes: '{{count}} ääntä',
      vote: 'Äänestä',
      unvote: 'Poista ääni',
    },
    addNode: {
      title: 'Lisää solmu',
      kipupisteTitle: 'Lisää kipupiste',
      esteTitle: 'Lisää este',
      ilmioTitle: 'Lisää ilmiö',
      from: 'Vanhempi',
      text: 'Otsikko',
      description: 'Kuvaus (valinnainen)',
      save: 'Tallenna',
      saveReady: 'Lisää karttaan',
      cancel: 'Peruuta',
    },
    suggestConnections: {
      title: 'Ehdotetut yhteydet',
      subtitle: 'AI löysi mahdollisia linkkejä solmulle „{{node}}”. Hyväksy vain jos perustelu pitää.',
      loading: 'Tarkistetaan mahdollisia yhteyksiä…',
      empty: 'AI ei löytänyt uusia yhteysehdotuksia tälle solmulle.',
      linkMeta: '{{polarity}} · luottamus {{confidence}}%',
      bridgeVia: 'Esteiden väliin tarvitaan ilmiö: „{{title}}”',
      accept: 'Lisää ehdotuksena',
      acceptBridge: 'Lisää ilmiö + yhteydet',
      dismiss: 'Hylkää',
      close: 'Sulje',
    },
    nodeModal: {
      title: 'Muokkaa solmua',
      text: 'Teksti',
      description: 'Kuvaus',
      relations: 'Yhteydet (klikkaa muokataksesi)',
      noRelations: 'Ei yhteyksiä vielä. Lisää seuraus, yhdistä olemassa olevaan tai klikkaa viivaa kartalla.',
      spine: 'layout',
      starterHint: 'Skenaarion juurisolmu — tekstiä voi muokata, poisto ei ole sallittu.',
      save: 'Tallenna',
      addChild: 'Lisää seuraus',
      addEste: 'Lisää este',
      addIlmio: 'Lisää ilmiö',
      addConnection: 'Yhdistä olemassa olevaan',
      suggestConnections: 'Ehdota yhteyksiä (AI)',
      linkOther: 'Toinen tekijä',
      linkPick: 'Valitse solmu…',
      linkDirection: 'Suunta',
      linkFromHere: 'Tästä → toiseen',
      linkToHere: 'Toisesta → tähän',
      linkPolarity: 'Vaikutus',
      linkSave: 'Luo yhteys',
      linkCancel: 'Peruuta',
      linkNoneLeft: 'Kaikki muut solmut on jo yhdistetty tähän.',
      delete: 'Poista solmu',
      close: 'Sulje',
      scopeLabel: 'Esteen luonne',
      votes: '{{count}} ääntä',
      vote: 'Äänestä',
      unvote: 'Poista ääni',
    },
    layout: {
      arrange: 'Järjestä',
      arrangeHint: 'Järjestää kartan uudelleen',
    },
    view: {
      flat: '2D',
      sphere: '3D',
      galaxy: 'Galaksi',
    },
    pan: {
      label: 'Siirrä kameran fokususta',
      forward: 'Siirrä eteen',
      back: 'Siirrä taakse',
      left: 'Siirrä vasemmalle',
      right: 'Siirrä oikealle',
      up: 'Siirrä ylös',
      down: 'Siirrä alas',
      recenter: 'Keskitä origoon',
    },
    guide: {
      title: 'Näin käytät systeemikarttaa',
      dismiss: 'Selvä',
      mouse: {
        open: 'Vie hiiri solmun päälle esikatseluun, klikkaa avataksesi.',
        loops: 'Vie hiiri silmukan päälle korostaaksesi sen kartalla, klikkaa valitaksesi.',
        navigate: 'Vieritä zoomataksesi, raahaa siirtääksesi karttaa.',
      },
      touch: {
        open: 'Napauta tekijää korostaaksesi sen, napauta uudelleen avataksesi.',
        loops: 'Napauta silmukkaa paneelissa korostaaksesi sen kartalla.',
        navigate: 'Raahaa siirtääksesi, nipistä zoomataksesi.',
      },
    },
    legend: {
      title: 'Selite',
      starter: 'Skenaarion juuri',
      factor: 'Tekijä',
      blocker: 'Este',
      ongelma: 'Kipupiste',
      este: 'Este',
      ilmio: 'Ilmiö',
      strengthens: '+ Vahvistaa',
      weakens: '− Heikentää (katkoviiva)',
      strengthWeak: 'Heikko yhteys (ohut)',
      strengthStrong: 'Vahva yhteys (paksu)',
      proposed: 'AI-ehdotus (katkoviiva)',
      loop: 'Silmukka (liikkuva hehku)',
    },
  },

  painPoints: {
    title: 'Kipupisteiden keruu',
    loading: 'Ladataan…',
    quickfireHint: 'Kirjoittakaa nopeasti niin monta konkreettista asiaa kuin haluatte.',
    inputPlaceholder: 'Yksi kipukohta tai ongelma…',
    add: 'Lisää',
    allInputs: 'Kaikki syötteet',
    yours: 'Sinun',
    noInputs: 'Ei syötteitä vielä.',
    clusters: 'Ehdotetut kipupisteet',
    runCluster: 'Klusteroi AI:lla',
    clustering: 'Klusteroidaan…',
    promote: 'Luo kipupisteet kartalle',
    noClusters: 'Ei klustereita — kerää syötteitä ja klusteroi.',
    members: 'jäsentä',
    drop: 'Poista',
    restore: 'Palauta',
    editPrompt: 'Muokkaa kehotetta',
    savePrompt: 'Tallenna',
    cancel: 'Peruuta',
    suggestWording: 'Ehdota muotoilua',
  },

  manualInputs: {
    saving: 'Tallennetaan…',
    locked: 'Työpaja on lukittu. Avaa lukitus ennen kuin syötät tietoja käsin.',
    loading: 'Ladataan…',
    staticPivots: {
      title: 'Vipupisteet valmiista listasta',
      intro: 'Kirjoita tai liitä vipupisteet, yksi riviä kohden. Kuvauksen voi lisätä pystyviivan jälkeen: Otsikko | kuvaus. Tallennus tekee juuri näistä listan vipupisteet; aiemmat listan vipupisteet eivät enää ole vipupisteitä, mutta niitä ei poisteta.',
      current: 'Instanssissa on nyt {{count}} vipupistettä.',
      placeholder: 'Energian hinta | Miten hinta ohjaa valintoja\nJulkinen liikenne',
      save: 'Tallenna {{count}} vipupistettä',
      saved: 'Tallennettu {{count}} vipupistettä.',
    },
    hmw: {
      title: 'Mitä jos -kysymykset käsin',
      intro: 'Kirjoita kysymykset, yksi riviä kohden. Tallennus korvaa nykyisen listan.',
      placeholder: 'Mitä jos…?',
      save: 'Tallenna {{count}} kysymystä',
      saved: 'Tallennettu {{count}} kysymystä.',
    },
    lensItems: {
      title: 'Esteet ja mahdollisuudet käsin',
      intro: 'Lisää este tai mahdollisuus vipupisteeseen jonkin kuuden linssin kautta. Muokkaus ja poisto tehdään Esteet ja mahdollisuudet -näkymässä.',
      noPivots: 'Instanssissa ei ole vielä vipupisteitä. Syötä ne ensin.',
      pivot: 'Vipupiste',
      lens: 'Linssi',
      type: 'Tyyppi',
      obstacle: 'Este',
      opportunity: 'Mahdollisuus',
      itemTitle: 'Otsikko',
      add: 'Lisää',
      count: 'Esteitä ja mahdollisuuksia yhteensä: {{count}}',
    },
  },

  navigation: {
    results: 'TULOKSET',
    impactPath: 'Vaikutuskartta',
    systemicMap: 'Systeemikartta',
    painPoints: 'Kipupisteiden keruu',
    v2Ongelmat: 'Ongelmat',
    v2Ankkurit: 'Muutoksen esteet',
    v2Juurisyyt: 'Juurisyyt',
    impactPathScenarios: 'Skenaariot',
    impactPathMap: 'Vaikutuskartta',
    pivotPoints: 'Vipupisteet',
    ragSourceMap: 'Tietopohja',
    ragSourceMapV2: 'Tietopohja (v2)',
    dashboard: 'Tilannekuva',
    lenses: 'Esteet ja mahdollisuudet',
    solutions: 'Ratkaisut',
    report: 'AI-yhteenveto',
    backToInstances: 'Takaisin instanssivalintaan',
    home: 'Etusivu',
    userSettings: 'Käyttäjäasetukset',
    signOut: 'Kirjaudu ulos / vaihda käyttäjää',
    signOutShort: 'Kirjaudu ulos',
    locked: 'Lukittu',
    moduleLocked: 'Työpaja ei ole vielä edennyt tähän',
    menuUnavailable: 'Valikkoa ei voitu ladata: {{error}}',
    phasesOpen: 'Avaa vaiheet',
    phasesClose: 'Sulje vaiheet',
    phasesHeading: 'Kuution vaiheet',
    leaveWorkshopConfirm: 'Poistutaanko työpajasta?',
  },

  drawer: {
    chat: 'Chat',
    settings: 'Asetukset',
    widthMode: {
      label: 'Panelin leveys',
      normal: 'Normaali',
      wide: 'Leveä',
      full: 'Täysleveä',
      next: 'Vaihda leveyttä: {{mode}}',
    },
  },

  tooltip: {
    dismissSession: 'Älä näytä uudelleen',
    close: 'Sulje',
  },

  reportsList: {
    loading: 'Ladataan raportteja...',
    pageTitle: 'Kuutio-raportit',
    subtitle: 'Tulevaisuustyöpajojen tulokset — skenaariot, vaikutuspolut, ratkaisut ja AI-analyysit',
    empty: 'Ei julkaistuja raportteja.',
    solutionsCount: '{{count}} ratkaisua',
    transcriptsCount: '{{count}} puheenvuoroa',
    participantsCount: '{{count}} osallistujaa',
  },

  screenClient: {
    loading: 'Ladataan...',
    selectDisplay: 'Valitse näyttö',
    selectInstanceAndDisplay: 'Valitse instanssi ja näyttö',
    selectInstancePlaceholder: 'Valitse instanssi...',
    changeInstance: 'Vaihda instanssia',
    selectInstanceFirstHint: '☝️ Valitse ensin instanssi ylhäältä',
    displaysSection: 'Näytöt',
    ipadsSection: 'iPadit',
    wallRow: 'Seinä {{id}} ({{name}})',
    wallNorth: 'Pohjoinen',
    wallEast: 'Itä',
    wallSouth: 'Etelä',
    wallWest: 'Länsi',
    screenTakeoverConfirm: 'Näyttö {{code}} on jo käytössä. Otetaanko haltuun?',
  },

  workshopControls: {
    selectInstanceTitle: 'Valitse ensin instanssi',
    selectInstanceBody: 'Siirry Admin-etusivulle valitaksesi instanssin.',
    adminHome: 'Admin-etusivu',
    pageTitle: 'Työpajan ohjaus',
    pageDescription:
      'Valitse kullekin skenaariolle, mitä tulevaisuuskuvaa osallistujat käyttävät Impact Path -näkymässä. "Oma tulevaisuuskuva" tarkoittaa, että osallistujat aloittavat tyhjältä pöydältä ilman ennalta määriteltyjä muuttujia.',
    noScenariosTitle: 'Ei skenaarioita',
    noScenariosBody: 'Tällä instanssilla ei ole vielä skenaarioita.',
    futuresAvailable: '{{count}} tulevaisuuskuvaa saatavilla',
    activeFutureLabel: 'Aktiivinen tulevaisuuskuva',
    customFuture: 'Oma tulevaisuuskuva',
    freeBadge: 'Vapaa',
    saving: 'Tallennetaan...',
    saved: 'Tallennettu',
    noFuturesForScenario: 'Tälle skenaariolle ei ole määritelty tulevaisuuskuvia',
    topicFocusTitle: 'Aiheen rajaus',
    topicFocusDescription:
      'Valitse työpajan fokus. Valittu näkökulma näytetään Impact Path -näkymässä ja ohjaa tekoälyn analyysiä kaikissa vaikutuspolun kyselyissä.',
    selectedPerspectiveLabel: 'Valittu näkökulma',
    noPerspectiveAll: 'Ei valittu – kaikki näkökulmat',
    noFocusTitle: 'Ei rajausta',
    noFocusDescription: 'Kaikki näkökulmat ovat samanarvoisia – ei fokusaluetta',
  },

  workshopReport: {
    reportTitle: 'Raportti',
    workshopReportTitle: 'Työpajan raportti',
    selectInstanceFirst: 'Valitse ensin instanssi Admin Hubista nähdäksesi raportin.',
    backToAdmin: '← Takaisin Admin Hubiin',
    errorTitle: 'Virhe',
    retry: 'Yritä uudelleen',
    pageToolbarTitle: 'Raportti',
    generating: 'Generoidaan...',
    refreshReport: 'Päivitä',
    generateReport: 'Generoi raportti',
    noReportYet: 'Ei raporttia vielä',
    noReportHint: 'Klikkaa "Generoi raportti" luodaksesi yhteenvedon tästä työpajasta.',
    generateBig: 'Generoi raportti',
    generatingReport: 'Generoidaan raporttia...',
    summarySection: 'Tiivistelmä',
    statParticipants: 'Osallistujaa',
    statSuggestions: 'Ehdotusta',
    statScenarios: 'Skenaariota',
    moodDistribution: 'Tunnelmajakauma',
    moodPositive: 'Positiivinen',
    moodNeutral: 'Neutraali',
    moodConcerned: 'Huolestunut',
    chartsSection: 'Kuvaajat',
    chartScenarioActivity: 'Skenaarioiden aktiivisuus',
    noData: 'Ei dataa',
    footerPlatform: 'Kuutio Workshop Platform',
    footerGenerated: 'Raportti generoitu {{date}}',
    loadError: 'Virhe ladattaessa dataa: {{message}}',
    unknownScenario: 'Tuntematon',
  },

  lenses: {
    pivotLabel: 'Vipupiste',
    stepLenses: 'Esteet ja mahdollisuudet',
    navLenses: 'Linssit',
    navOverview: 'Yhteenveto',
    navPivot: 'Vipupiste',
    navEM: 'E&M',
    noInstance: 'Ei instanssia valittuna. Lisää ?kid= tai ?instance= URL-parametri.',
    loadingData: 'Ladataan esteitä ja mahdollisuuksia...',
    loadErrorTitle: 'Virhe datan latauksessa',
    pivotSummaryNeedPivot: 'Valitse vipupiste ennen yhteenvetoa.',
    pivotSummaryLoadFailed: 'Yhteenvedon lataus epäonnistui. Yritä uudelleen.',
    pivotReportFailed: 'Raportin luonti epäonnistui. Yritä uudelleen.',
    pivotSummaryBtn: 'Tiivistelmä ja analyysi',

    // Dashboard tabs & chrome
    tabSummary: 'Yhteenveto',
    tabPivots: 'Vipupisteet ({{count}})',
    tabBrief: 'Tiivistelmä',
    tabInnovations: 'Innovaatiot',
    tabListing: 'Listaus',
    itemsCount: '{{count}} kohdetta',
    obstacleOne: 'este',
    obstacleOther: 'estettä',
    opportunityOne: 'mahdollisuus',
    opportunityOther: 'mahdollisuutta',
    manualCount: '{{count}} manuaalista',
    aiCount: '{{count}} AI',
    ragCount: '{{count}} RAG',
    evaluatedTags: 'Arvioitu (tunnisteet) {{count}}',
    qualityScore: 'Osuvuus {{score}}',
    researchSupport: 'Tietopohja {{score}}',
    pivotPointsSection: 'Vipupisteet ({{count}})',
    emptyItems: 'Ei vielä kohteita. Lisää esteitä ja mahdollisuuksia linssien kautta.',
    noInstanceBrief: 'Ei instanssia — tiivistelmää ei voi ladata.',
    noInstanceInnov: 'Ei instanssia — innovaatioita ei voi ladata.',
    unknownPivot: 'Tuntematon vipupiste',
    briefFailed: 'Tiivistelmä epäonnistui ({{status}})',
    innovFailed: 'Innovaatiot epäonnistuivat ({{status}})',

    // Pivot summary
    formingPivotSummary: 'Muodostetaan vipupisteen yhteenvetoa...',
    lensCountsTitle: 'Linssikohtaiset määrät',
    obstaclesCountShort: '{{count}} estettä',
    opportunitiesCountShort: '{{count}} mahdollisuutta',
    viewClusters: 'Klusterit',
    viewLenses: 'Linssit',
    refreshClusters: 'Päivitä klusterit',
    refreshClusterAnalysis: 'Päivitä klusterianalyysi',
    clustersStaleHint: 'Kohteita on muokattu — fasilitaattori voi päivittää klusterianalyysin.',
    formingClusters: 'Muodostetaan klustereita...',
    clusterFetchFailed: 'Klusterihaku epäonnistui ({{status}})',
    clustersFetchFailed: 'Klusterien haku epäonnistui',
    noItems: 'Ei kohteita',
    obstacleClustersTitle: 'Esteklusterit',
    opportunityClustersTitle: 'Mahdollisuusklusterit',
    clusterDefaultTitle: 'Klusteri',
    unnamedItem: 'Nimetön kohde',
    obstacles: 'Esteet',
    opportunities: 'Mahdollisuudet',
    pivotAnalysis: 'Vipupisteanalyysi',
    membersCount: '{{count}} jäsentä',
    severityOptimism: 'Vakavuus {{severity}} / 5 · Toiveikkuus {{optimism}} / 5',
    report: 'Raportti',
    reportNotCreated: 'Raporttia ei ole vielä luotu tälle vipupisteelle.',
    creating: 'Luodaan...',
    createReport: 'Luo raportti',
    recreating: 'Luodaan uudelleen...',
    recreate: 'Luo uudelleen',

    // Simple / innovative / listing summaries
    formingBrief: 'Muodostetaan tiivistelmää...',
    tryAgain: 'Yritä uudelleen',
    noItemsToSummarize: 'Ei vielä linssikohteita tiivistettäväksi.',
    refresh: 'Päivitä',
    keyFindings: 'Keskeiset löydökset',
    notableBlockersOpps: 'Huomioitavat esteet ja mahdollisuudet',
    fromCache: 'Välimuistista (sisältö vastaa nykyisiä kohteita).',
    pickingInnovations: 'Poimitaan innovatiivisia näkökulmia...',
    noItemsToAnalyze: 'Ei vielä linssikohteita analysoitavaksi.',
    innovationsTitle: 'Innovaatiot ja yllätykset',
    noHighlights: 'Ei kohokohtia palautettu.',
    related: 'Liittyy:',
    fromCacheShort: 'Välimuistista.',
    listing: 'Listaus',
    noItemsToList: 'Ei kohteita listattavaksi.',
    groupByLens: 'Ryhmittäin linssin mukaan',
    groupByType: 'Ryhmittäin tyypin mukaan',
    obstacle: 'Este',
    opportunity: 'Mahdollisuus',

    // Item modal
    editObstacle: 'Muokkaa estettä',
    editOpportunity: 'Muokkaa mahdollisuutta',
    addObstacle: 'Lisää este',
    addOpportunity: 'Lisää mahdollisuus',
    obstaclePrompt: 'Mikä estää tai hidastaa vipupisteen "{{title}}" toteutumista{{lensSuffix}}?',
    opportunityPrompt: 'Mikä mahdollisuus avautuu vipupisteessä "{{title}}"{{lensSuffix}}?',
    lensSuffix: ' {{lens}}-näkökulmasta',
    writeObstacle: 'Kirjoita este...',
    writeOpportunity: 'Kirjoita mahdollisuus...',
    saveLocked: 'Työpaja on lukittu, joten tätä ei voi nyt tallentaa. Tekstisi on tallessa tässä ikkunassa.',
    saveFailed: 'Tallennus epäonnistui: {{error}}. Tekstisi on tallessa tässä ikkunassa.',
    findObstaclesOpps: 'Löydetään esteet ja mahdollisuudet',
    eachLensPerspective: 'Jokainen linssi nostaa esiin oman näkökulmansa',
    letsStart: 'Aloitetaan!',

    // Pivot curation (post–Let's go)
    curation: {
      title: 'Tiimien vipupisteet',
      empty: 'Ei vipupisteitä',
      add: 'Lisää vipupiste',
      selectTitle: 'Valitse tämä vipupiste',
      selectionHint: 'Valitse vipupisteet, joita työstetään seuraavissa vaiheissa · {{selected}}/{{total}} valittu',
    },
    editModal: {
      createTitle: 'Lisää vipupiste',
      editTitle: 'Muokkaa vipupistettä',
      titleLabel: 'Otsikko',
      titlePlaceholder: 'Vipupisteen otsikko...',
      descriptionLabel: 'Kuvaus',
      descriptionPlaceholderCreate: 'Lyhyt kuvaus vipupisteestä...',
      descriptionPlaceholderEdit: 'Kuvaus...',
      generateAi: 'Generoi AI',
      generating: 'Generoidaan...',
      regenerate: 'Luo uudelleen',
      generateTitle: 'Generoi kuvaus tekoälyllä',
      replaceTitle: 'Korvaa nykyisen AI-tekstin',
      aiHint: 'AI-generoitu — muokkaa vapaasti',
    },
    pivotPointsNav: 'Vipupisteet',
    lensFallback: 'Linssi',
    aiObstacles: 'AI esteet',
    aiOpportunities: 'AI mahdollisuudet',
    emptyLensDetail: 'Lisää esteitä ja mahdollisuuksia vipupisteelle linssin "{{lens}}" näkökulmasta.',
    emptyLensDetailAi: 'Tai anna AI:n ehdottaa niitä tutkimustiedon perusteella.',
    emptyNoItemsYet: 'Ei vielä esteitä tai mahdollisuuksia',
    aiSuggestionsTitle: 'AI: {{type}}',
    aiAnalyzingResearch: 'Analysoidaan tutkimusaineistoa...',
    aiAnalyzingHint: 'Tämä kestää hetken — AI käy läpi tutkimustietokantaa',
    aiSuggestFailed: 'AI-ehdotusten luominen epäonnistui.',
    noSuggestions: 'Ei ehdotuksia saatavilla.',
    suggestMore: 'Ehdota lisää',
    adding: 'Lisätään...',
    addSelected: 'Lisää valitut ({{count}})',
    aiSuggestsObstacles: 'AI ehdottaa esteitä',
    aiSuggestsOpportunities: 'AI ehdottaa mahdollisuuksia',
    editBeforeAdd: 'Muokkaa tarvittaessa ennen lisäämistä',
    selectAndEditBeforeAdd: 'Valitse ja muokkaa ennen lisäämistä',
    aiAnalyzingGenerating: 'AI analysoi ja generoi ehdotuksia...',
    aiCouldNotGenerate: 'AI ei pystynyt generoimaan ehdotuksia.',
    tryAgainOrManual: 'Yritä uudelleen tai lisää manuaalisesti.',
    aiSelectorHint: 'AI-ehdotukset perustuvat tutkimustietoon. Valitse säilytettävät, muokkaa tarvittaessa ja lisää.',
    descriptionPlaceholder: 'Kuvaus...',
    edited: 'muokattu',
    confidence: 'Luottamus: {{pct}}%',
    selectedCount: 'Valittu: {{selected}} / {{total}}',
    sourceManual: 'Manuaalinen',
    sourceAiGenerated: 'AI-generoitu',
    sourceResearch: 'Tutkimusaineisto',
    tabDetails: 'Tiedot',
    tabConnections: 'Yhteydet ({{count}})',
    tabSources: 'Lähteet ({{count}})',
    metadata: 'Metatiedot',
    aiConfidence: 'AI-luottamus',
    addedBy: 'Lisääjä',
    relatedItems: 'Liittyvät esteet ja mahdollisuudet',
    noRelatedItems: 'Ei liittyviä kohteita.',
    own: 'Oma',
    aiAnalyzing: 'AI analysoi...',
    untitled: 'Nimetön',
    requestFailed: 'Pyyntö epäonnistui',
    clustersRefreshFailed: 'Klusterien päivitys epäonnistui',
    deleteItemTitle: 'Poista kohde',
    deletePivotTitle: 'Poista vipupiste',
    deleteConfirm: 'Poistetaanko "{{title}}"? Tätä ei voi perua.',
    matrixTitle: 'Vipupiste × Linssi -matriisi',
    totalShort: 'Yht.',
    total: 'Yhteensä',
    lensDistribution: 'Linssijakauma',
  },

  solutionAnalysis: {
    title: 'Analyysi ja arviointi',
    swot: {
      strengths: 'Vahvuudet',
      weaknesses: 'Heikkoudet',
      opportunities: 'Mahdollisuudet',
      threats: 'Uhat',
    },
    swotTitle: 'SWOT-analyysi',
    nextSteps: {
      title: 'Näin jatketaan',
      universal: 'Kaikille kaupungeille',
      town: 'Teille · {{town}}',
    },
    lensesTitle: 'Linssit',
    lensesAssessed: '{{count}} linssiä arvioitu',
    coverageTitle: 'Linssipeitto',
    coverageAddressed: '{{count}} katettu',
    coverageAnswered: '{{count}} estettä vastattu',
    coverageOpen: '{{count}} avointa estettä',
    eval: {
      impact: "Vaikuttavuus",
      feasibility: "Toteutettavuus",
      innovation: "Innovaatio",
      evidence: "Tutkimusnäyttö",
    },
    solutionsTitle: "Ratkaisut",
    solutionsIntro: "Työpajan ryhmät kehittivät {{count}} ratkaisuehdotusta tutkimuskysymykseen.",
    hybridTitle: "Yhdistelmäratkaisut",
    hybridIntro: "Tekoäly analysoi työpajan {{count}} ratkaisuehdotusta ja tunnisti yhdistelmäratkaisuja, joissa usean ryhmän ehdotukset täydentävät toisiaan.",
  },
  instanceSettingsModal: {
    modalTitle: 'Instanssin asetukset',
    modalSubtitle: 'Muokkaa Kuutio-instanssin tietoja ja hallitse sen tilaa.',
    successSaved: 'Muutokset tallennettu onnistuneesti!',
    statsHeading: 'Tilastot',
    statParticipants: 'Osallistujaa',
    statPatterns: 'Malleja',
    statDays: 'Päivää',
    labelName: 'Nimi',
    labelDescription: 'Kuvaus',
    labelWorkshopGoal: 'Työpajan tavoite',
    placeholderWorkshopGoal: 'Esim. Mitä pitää tehdä, jotta työnantajat palkkaisivat nuoria?',
    helpWorkshopGoal: 'Kysymys, johon työpaja hakee vastausta. AI ohjataan etsimään vipupisteitä ja arvioimaan ratkaisuja tämän tavoitteen suhteen. Pakollinen kenttä.',
    workshopGoalRequired: 'Työpajan tavoite on pakollinen — kysymys, johon työpaja hakee vastausta.',
    labelAiContextDescription: 'AI-kontekstikuvaus',
    helpAiContextDescription: 'Kuvaus Kuutiosta ja tästä työpajasta, joka liitetään AI-promptteihin. Voit muokata oletustekstiä suoraan. Jos jätät sen ennallaan, käytetään jaettua oletusta.',
    langFi: 'Suomi',
    langEn: 'English',
    langSv: 'Svenska (sv-FI)',
    labelStatus: 'Tila',
    labelType: 'Tyyppi',
    typeLive: 'Live — fyysinen työpaja (iPadit)',
    typeOnline: 'Online — etäosallistujat',
    googleSlidesLabel: 'Google Slides -esitys',
    googleSlidesHelp: 'Liitä Google Slides URL tai ID. Käytetään työpajan diaesityksiin.',
    slideImagesLabel: 'Diakuvat',
    syncImages: 'Synkronoi kuvat',
    syncingImages: 'Synkronoidaan...',
    imagesSyncedProgress: '{{synced}}/{{total}} kuvaa synkronoitu',
    syncedCount: '{{count}} synkronoitu',
    skippedCount: '{{count}} ohitettu',
    errorsCount: '{{count}} virhe',
    sheetSyncLabel: 'Synkronoi Google Sheetistä',
    sheetSyncHelp: 'Tuo skenaariot, muuttujat ja flow-vaiheet Google Sheetistä.',
    loading: 'Ladataan...',
    preview: 'Esikatselu',
    sync: 'Synkronoi',
    syncing: 'Synkronoidaan...',
    previewBoxTitle: 'Esikatselu',
    sheetInstance: 'Instanssi:',
    sheetScenarios: 'Skenaariot:',
    sheetVariables: 'Muuttujat:',
    replaceConfigWarning: 'Tämä korvaa nykyisen konfiguraation',
    aiSuggestLabel: 'AI-ehdotukset (esteet/mahdollisuudet)',
    aiSuggestHint: 'Montako AI-ehdotusta luodaan per linssi (oletus 1)',
    testModeLabel: 'Testikäyttö',
    openPinTitle: 'Avoin PIN-koodi',
    openPinDesc: 'Mikä tahansa PIN-koodi hyväksytään (testaus/demot)',
    lockLabel: 'Lukitus',
    lockTitle: 'Lukitse instanssi',
    lockDesc: 'Estä muokkaukset kaikissa näkymissä (vaikutuspolku, vipupisteet, linssit)',
    reportVisibilityLabel: 'Raportin näkyvyys',
    implementationTitle: 'Näytä "Miten aloitamme?" -osiot',
    implementationDesc:
      'AI:n tuottamat 12 kuukauden toimeenpanosuunnitelmat näkyvät ratkaisujen yhteydessä raportissa',
    scenariosHeading: 'Skenaariot',
    scenarioNamePlaceholder: 'Skenaarion nimi',
    scenarioDescPlaceholder: 'Kuvaus (valinnainen)',
    hideScenario: 'Piilota',
    showScenario: 'Näytä',
    deleteScenario: 'Poista',
    deleteScenarioContent: 'Skenaarion vaikutuspolulla on {{count}} osallistujien lisäämää solmua tai estettä. Ne poistetaan skenaarion mukana, kun tallennat.',
    addScenario: 'Lisää uusi skenaario',
    clearDataTooltip: 'Tyhjennä kaikki osallistujien syötteet (säilyttää instanssin)',
    clearData: 'Tyhjennä data',
    deleteInstance: 'Poista instanssi',
    saveChanges: 'Tallenna muutokset',
    savingChanges: 'Tallennetaan...',
    clearConfirmTitle: 'Vahvista datan tyhjennys',
    clearConfirmP1: 'Haluatko varmasti tyhjentää kaikki osallistujien syötteet instanssista "{{title}}"?',
    clearConfirmP2:
      'Tämä poistaa työpajassa syntyneen sisällön, äänet ja AI:n tuotokset sekä työpajan omat RAG-palaset, ja kulku palaa alkuun. Säilyy: skenaariot, muuttujat, linssit, asetukset, PIN-koodit, osallistujat, tietopohja (tutkimusaineisto) ja osallistujien ennakkotehtävät.',
    clearPreviewHeading: 'Poistetaan {{count}} riviä:',
    clearPreviewNothing: 'Ei poistettavaa dataa.',
    clearPreviewFailed: 'Esikatselu epäonnistui: {{error}}',
    clearing: 'Tyhjennetään...',
    deleteConfirmTitle: 'Vahvista poistaminen',
    deleteConfirmP1:
      'Haluatko varmasti poistaa instanssin "{{title}}"? Tämä toiminto poistaa kaikki instanssiin liittyvät tiedot pysyvästi.',
    deleting: 'Poistetaan...',
    deletePermanently: 'Poista lopullisesti',
    errorSyncFailed: 'Synkronointi epäonnistui',
    errorPreviewFailed: 'Esikatselu epäonnistui',
    errorSheetSyncFailed: 'Synkronointi epäonnistui',
    confirmSheetReplace: 'Tämä korvaa kaikki nykyiset skenaariot, muuttujat ja flow-vaiheet. Jatketaanko?',
    syncDoneAlert:
      'Synkronoitu! {{scenarios}} skenaariota, {{variables}} muuttujaa',
    syncStart: 'Aloitetaan...',
    syncSyncingImages: 'Synkronoidaan {{total}} kuvaa...',
    syncLoadingImage: 'Ladataan kuvaa {{current}}/{{total}}',
    syncRetryRound: 'Uudelleenyritys {{round}}/{{maxRounds}} ({{failedCount}} epäonnistunutta)',
    syncRetryingSlide: 'Yritetään uudelleen {{slideIndex}}/{{total}} (kierros {{round}})',
    timeJustNow: 'juuri äsken',
    timeMinutesAgo: '{{count}} min sitten',
    timeHoursAgo: '{{count}} h sitten',
    timeDaysAgo: '{{count}} pv sitten',
    newScenarioTitle: 'Uusi skenaario',
    statusReadOnlyHint: 'Muuta Työpaja-näkymässä',
    pinLabel: 'Instanssin PIN-koodi',
    pinHelp: 'Osallistujat kirjautuvat tällä PIN-koodilla suoraan tähän instanssiin.',
    lensesSectionLabel: 'Linssit (esteet & mahdollisuudet)',
    lensDescriptionTitle: 'Luo myös kuvaus',
    lensDescriptionDesc: 'AI luo otsikon lisäksi kuvaustekstin esteille ja mahdollisuuksille.',
    devSectionLabel: 'Kehitys',
    qaToggleTitle: 'QA-testaus',
    qaToggleDesc: 'Näyttää QA-testauspaneelin kaikissa admin-näkymissä. Tallentuu tähän laitteeseen.',
  },

  flowBuilder: {
    title: 'Työpajan kulku',
    subtitle: '{{instance}} · koostaja',
    save: 'Tallenna',
    cancel: 'Peruuta',
    unsaved: 'Muutoksia tallentamatta',
    allSaved: 'Kaikki tallennettu',
    fromTemplate: 'Aloita pohjasta…',
    fromInstance: 'Kopioi instanssista…',
    liveBanner: 'Muokkaat käynnissä olevaa työpajaa',
    liveNow: 'Käynnissä nyt: {{module}}. Tallennetut muutokset näkyvät osallistujille heti.',
    readinessOk: 'Valmius: kaikki tarvittava saatavilla',
    readinessManual: '{{count}} syötettävä käsin',
    readinessOrder: '{{count}} järjestysvaroitus',
    readinessYellow: '{{count}} käsin tai valinnainen',
    readiness: 'Valmius',
    palette: 'Moduulit',
    paletteHint: 'Vedä kulkuun tai napsauta nähdäksesi kuvauksen.',
    inChain: 'Kulussa',
    producesAlready: 'Päällekkäinen moduuli: {{module}}',
    chain: 'Kulku',
    tieto: 'Tieto',
    alwaysAvailable: 'Aina saatavilla',
    reportFixed: 'Aina viimeisenä',
    noInputs: 'Ei edellytä aiempia tietoja',
    optional: 'valinnainen',
    statusUpstream: 'saatavilla',
    statusSatisfied: 'saatavilla',
    statusPreseeded: 'käsin',
    statusOrder: 'liian myöhään',
    statusManual: 'puuttuu',
    statusOptional: 'ei saatavilla',
    enterByHand: 'Syötä käsin',
    unsavedTag: 'Tallentamatta',
    liveTag: 'Käynnissä',
    contentTag: 'Sisältöä',
    moveUp: 'Siirrä ylös',
    moveDown: 'Siirrä alas',
    remove: 'Poista kulusta',
    removeNote: 'Poistaminen ei poista tietoja – moduulin sisältö vain lakkaa näkymästä. Muutos tallentuu vasta Tallenna-napista.',
    addToChain: 'Lisää kulkuun',
    swapVersion: 'Vaihda tähän versioon',
    showInChain: 'Näytä kulussa',
    conflictSameFamily: '{{other}} on jo kulussa ja tuottaa saman tiedon. Kulussa voi olla vain yksi versio.',
    conflictOther: '{{other}} tuottaa jo tiedon {{handoff}}. Valitse toinen niistä.',
    needs: 'Tarvitsee',
    canUse: 'Käyttää, jos on',
    produces: 'Tuottaa',
    facilitationTitle: 'Fasilitaattorille',
    facilitationWhat: 'Mitä?',
    facilitationWhy: 'Miksi?',
    facilitationHow: 'Miten?',
    facilitationEmpty: 'Ei vielä kirjattu',
    participantModule: 'Osallistujat',
    facilitatorOnly: 'Vain fasilitaattori',
    openInWorkshop: 'Avaa työpajan ohjauksessa',
    enterOnContent: 'Syötetään Valmistelun Sisältö-sivulla →',
    prepareSettings: 'Valmisteluvaiheen asetukset',
    liveSettings: 'Toteutusvaiheen asetukset',
    noSettings: 'Ei asetuksia',
    liveSwitches: 'Kytkimet',
    liveActions: 'Toiminnot',
    livePanel: 'Ohjauspaneeli',
    prepareAfterAdd: 'Muokattavissa, kun moduuli on lisätty kulkuun.',
    tietoPreseeded: 'Esitäytetty käsin',
    tietoMissing: 'Puuttuu – syötetään käsin',
    tietoOptionalMissing: 'Ei saatavilla – valinnainen',
    tietoUnused: 'Ei käyttäjiä kulussa',
    consumers: 'Käyttävät: {{list}}',
    hasContent: 'Sisältöä on',
    noContent: 'Ei vielä sisältöä',
    storage: 'Tallennuspaikka',
    producer: 'Tuottaa',
    status: 'Tila',
    content: 'Sisältö nyt',
    noProducer: 'Ei yksikään moduuli kulussa',
    editorsTitle: 'Syötä käsin',
    editorsBlocked: 'Tallenna ensin kulun muutokset – käsin syötetyt tiedot tallentuvat heti eivätkä ole osa luonnosta.',
    editorWarnDestructive: 'Korvaa nykyisen sisällön',
    editorsNote: 'Käsin syötetty tieto voi esitäyttää myös tiedon, jonka myöhempi moduuli tuottaa – moduuli jatkaa siitä.',
    editorsOpenInWorkshop: 'Editorit avautuvat työpajan ohjauksessa kyseisen moduulin kohdalla.',
    templatesTitle: 'Aloita pohjasta',
    templatesNote: 'Pohja korvaa luonnoksen kulun. Mitään ei tallenneta ennen Tallenna-nappia, eikä tietoja poisteta.',
    templateSuggests: 'Ehdottaa käsin syötettäväksi: {{list}}',
    copyTitle: 'Kopioi instanssista',
    copyNote: 'Valitun instanssin kulku tulee luonnokseen. Mitään ei tallenneta ennen Tallenna-nappia.',
    confirmTitle: 'Tallennetaanko kulun muutokset?',
    confirmLive: 'Työpaja on käynnissä ({{module}}). Muutokset näkyvät osallistujille heti tallennuksen jälkeen.',
    confirmStarted: 'Työpaja on jo aloitettu.',
    confirmRemoved: 'Poistetaan kulusta: {{module}}.',
    confirmRemovedContent: 'Poistetaan kulusta: {{module}} – sisältö säilyy, se vain lakkaa näkymästä.',
    confirmRemovedLive: 'Käynnissä oleva moduuli {{module}} poistuu – kulku siirtyy seuraavaan moduuliin.',
    confirmAdded: 'Lisätään kulkuun: {{module}}.',
    confirmReordered: 'Järjestys muuttuu.',
    confirmLiveMoved: 'Käynnissä oleva moduuli siirtyy.',
    confirmSave: 'Tallenna muutokset',
    confirmBack: 'Palaa muokkaamaan',
    leaveConfirm: 'Sinulla on tallentamattomia muutoksia kulkuun. Poistutaanko silti?',
    saved: 'Tallennettu.',
    saveFailed: 'Tallennus epäonnistui: {{error}}',
    stale: 'Joku muu tallensi kulun välissä. Lataa uudelleen – luonnoksesi muutokset menetetään.',
    reload: 'Lataa uudelleen',
    close: 'Sulje',
    shortcuts: 'Näppäimet: ↑ / ↓ siirtää valittua moduulia · Delete poistaa · Ctrl+S tallentaa · Esc sulkee ikkunan',
    loadFailed: 'Kulun lataus epäonnistui: {{error}}',
    noInstance: 'Valitse ensin instanssi.',
    openBuilder: 'Muokkaa kulkua',
    drag: 'Vedä siirtääksesi',
    view: 'Näkymä',
    viewStatic: 'Kaavio',
    viewDynamic: 'Dynaaminen',
    viewTimeline: 'Aikajana',
    groupSocial: 'Sosiaaliset',
    addAgain: 'Lisää uudelleen',
    timelineStart: 'Kuutio alkaa',
    timelineTotal: 'Yhteensä {{hours}} h {{minutes}} min',
    timelineSavedOnly: 'Aikajana näyttää tallennetun kulun — tallenna muutokset nähdäksesi ne tässä.',
    timelineDay: 'Päivä {{day}}',
    timelineMin: 'min',
    timelineDayBreak: 'Aloita uusi päivä tästä vaiheesta',
    timelineAnchor: 'Aseta tarkka alkuaika',
    timelineAnchorHint: 'Vaihe alkaa täsmälleen:',
    timelineAnchorClear: 'Poista alkuaika',
    timelineNoStart: 'Aseta Kuution alkamisaika, niin vaiheille lasketaan kellonajat.',
    timelineEnd: 'Kuutio päättyy',
    legendIn: 'Syöte',
    legendOut: 'Tuotos',
    reportUsesThis: 'Raportti käyttää tätä',
    reportUsesCount: 'Raportti käyttää {{count}} tietoa',
    reportSections: 'Raportin osiot',
    groupStart: 'Tulevaisuus',
    groupMapping: 'Kartoitus',
    groupPivots: 'Vipupisteet',
    groupWork: 'Linssit ja ratkaisut',
    groupSystemicV2: 'Ongelmakartta',
    groupForesight: 'Skenaariot',
  },
  moduleFacilitation: {
    title: 'Fasilitointi',
    lead: 'Moduulien yhteiset fasilitointitekstit – pohja, josta jokaisen Kuution käsikirjoitus alkaa. Muutokset koskevat kaikkia Kuutioita ja tallentuvat versioina. Kuutiokohtaiset muokkaukset tehdään Kuution käsikirjoituksessa.',
    search: 'Hae moduulia',
    selectModule: 'Valitse moduuli vasemmalta',
    noMatches: 'Ei osumia.',
    loadFailed: 'Lataus epäonnistui: {{error}}',
    group: { work: 'Työvaiheet', social: 'Sosiaaliset' },
    minutes: '{{count}} min',
    editedBadge: 'Muokattu · v{{version}}',
    manifestBadge: 'Alkuperäinen',
    finnishOnly: 'Muokkaat suomenkielisiä tekstejä. Käännökset säilyvät ennallaan.',
    field: {
      what: 'Mitä',
      why: 'Miksi',
      how: 'Miten',
      intro: 'Alustus (apusanoitus)',
      technicalSetup: 'Tekninen setup',
      recommendedDuration: 'Suositeltu kesto (min)',
      steps: 'Juoksutus',
    },
    stepsTotal: 'Vaiheet yhteensä {{minutes}} min',
    stepTitle: 'Otsikko',
    stepMinutes: 'Min',
    stepText: 'Mitä tapahtuu',
    addStep: 'Lisää vaihe',
    removeStep: 'Poista vaihe',
    moveUp: 'Siirrä ylös',
    moveDown: 'Siirrä alas',
    versionName: 'Version nimi',
    versionNameHint: 'esim. K9:n jälkeen',
    changeNote: 'Muutoksen kuvaus',
    save: 'Tallenna',
    cancel: 'Peru',
    saved: 'Tallennettu versioksi {{version}}.',
    saveFailed: 'Tallennus epäonnistui: {{error}}',
    history: 'Versiohistoria',
    liveVersion: 'Nykyinen · v{{version}}',
    manifestLive: 'Nykyinen · alkuperäinen teksti',
    manifestVersion: 'alkuperäinen teksti',
    noVersions: 'Ei aiempia versioita.',
    preview: 'Näytä',
    rename: 'Nimeä',
    restore: 'Palauta',
    restoreTitle: 'Palautetaanko versio {{version}}?',
    restoreMessage: 'Versio palautetaan uudeksi nykyiseksi versioksi. Mitään ei menetetä: nykyinen teksti jää versiohistoriaan.',
    restoredNote: 'Palautettu versio {{version}}',
    restored: 'Versio {{version}} palautettiin; nykyinen on nyt v{{live}}.',
    emptyText: 'Ei tekstiä.',
  },
  scriptView: {
    title: 'Käsikirjoitus',
    hint: 'Kuution kaikki vaiheet ja niiden fasilitointitekstit. Muokkaukset koskevat vain tätä Kuutiota; moduulien yhteinen pohja kehittyy erikseen.',
    edit: 'Muokkaa tälle Kuutiolle',
    noInstance: 'Valitse ensin Kuutio.',
    loadFailed: 'Kulun lataus epäonnistui: {{error}}',
    print: 'Tulosta',
    editTimes: 'Muokkaa aikoja (Kulku)',
    noStart: 'Kuution alkamisaikaa ei ole asetettu — kellonajat puuttuvat. Aseta se Kulun aikajanalla.',
    day: 'Päivä {{day}}',
    minutes: '{{count}} min',
    what: 'Mitä',
    why: 'Miksi',
    intro: 'Alustus',
    technicalSetup: 'Tekninen setup',
    how: 'Miten',
    runOfPlay: 'Juoksutus',
    notes: 'Muistiinpanot',
    customized: 'tälle Kuutiolle',
    noContent: 'Fasilitointisisältöä ei ole vielä kirjattu.',
    end: 'Kuutio päättyy',
  },
  facilitationPanel: {
    title: 'Fasilitointi',
    customizedCount: '{{count}} muokattu tälle Kuutiolle',
    hint: 'Harmaa teksti on moduulin yhteinen pohja. Kirjoita tähän, kun tämä Kuutio tarvitsee omansa — pohja ei muutu, eikä muutos näy muissa Kuutioissa.',
    what: 'Mitä',
    why: 'Miksi',
    intro: 'Alustus (apusanoitus)',
    how: 'Miten',
    technicalSetup: 'Tekninen setup',
    notes: 'Omat muistiinpanot',
    customized: 'muokattu tälle Kuutiolle',
    reset: 'Palauta pohja',
    noBase: 'Pohjaa ei ole vielä kirjattu.',
    steps: 'Juoksutus',
    customizeSteps: 'Muokkaa juoksutusta tälle Kuutiolle',
    noBaseSteps: 'Pohjassa ei ole juoksutusta.',
    stepsTotal: 'Vaiheet yhteensä {{minutes}} min',
    stepTitle: 'Otsikko',
    stepMinutes: 'Min',
    stepText: 'Mitä tapahtuu',
    addStep: 'Lisää vaihe',
    removeStep: 'Poista vaihe',
    moveUp: 'Siirrä ylös',
    moveDown: 'Siirrä alas',
  },
  facilitationChat: {
    title: 'Paranna tekoälyn kanssa',
    close: 'Sulje keskustelu',
    hintBase: 'Tekoäly arvioi tekstit ja ehdottaa parannuksia. Hyväksytty ehdotus siirtyy kenttään; tallenna versio kuten tavallisesti. Keskustelu ei tallennu, ja se katoaa, kun vaihdat moduulia.',
    hintInstance: 'Tekoäly ehdottaa parannuksia tämän Kuution teksteihin. Hyväksytty ehdotus tallentuu heti tälle Kuutiolle; pohja ei muutu. Keskustelu ei tallennu.',
    emptyHint: 'Voit jättää kentän tyhjäksi: silloin tekoäly arvioi tekstit ja ehdottaa yleisiä parannuksia.',
    generalRequest: 'Yleiset parannusehdotukset, kiitos.',
    original: 'Alkuperäinen',
    originalEmpty: '(tyhjä)',
    originalNoSteps: '(ei vaiheita)',
    placeholder: 'Kerro, mitä haluat parantaa…',
    send: 'Lähetä',
    progress: {
      reading: 'Tekoäly lukee tekstit…',
      thinking: 'Tekoäly miettii parannuksia…',
      writing: 'Tekoäly kirjoittaa ehdotuksia…',
    },
    proposalsTitle: 'Ehdotukset',
    proposalsEmpty: 'Ei ehdotuksia vielä.',
    accept: 'Hyväksy',
    accepted: 'Hyväksytty',
    stepsProposal: 'Ehdotettu juoksutus',
    stepsReplace: 'Hyväksyminen korvaa koko juoksutuksen.',
    stepsWipeTranslations: 'Vaiheiden käännökset (en/sv) tyhjenevät.',
    minutes: '{{count}} min',
    error: 'Keskustelu epäonnistui: {{error}}',
    cutOff: 'Vastaus katkesi kesken.',
    lockedNote: 'Kuutio on lukittu, joten ehdotuksia ei voi hyväksyä.',
  },
  workshopOrchestrator: {
    screenStateDeleteConfirm: 'Poistetaanko tämä näyttötila?',
    pathwayImportReplaceConfirm: 'Kartalla on jo {{count}} solmua. Tuonti korvaa instanssin trendit, muuttujat ja koko vaikutuskartan sisällön tämän JSONin mukaan. Jatketaanko?',
    controlLockedReached: 'Lukittu: työpaja on jo edennyt tähän vaiheeseen, joten valintaa ei voi enää muuttaa.',
    loading: 'Ladataan…',
    selectInstanceTitle: 'Valitse ensin instanssi',
    selectInstanceBody: 'Siirry Admin-etusivulle valitaksesi instanssin.',
    adminHome: 'Admin-etusivu',
    tabContent: 'Sisältö',
    tabScreens: 'Näytöt',
    lockedBar: 'Työpaja lukittu — muokkaukset estetty kunnes avaat lukituksen.',
    unlockedBar: 'Työpaja muokattavissa. Lukitse, kun haluat estää tahattomat muutokset.',
    lock: 'Lukitse',
    unlock: 'Avaa lukitus',
    lockFailed: 'Lukituksen päivitys epäonnistui: {{error}}',
    unlockTitle: 'Avaa työpajan lukitus?',
    unlockMessage: 'Tämä mahdollistaa muokkaukset uudelleen. Lukitse takaisin heti, kun olet valmis, jotta tahattomat muutokset eivät pääse läpi.',
    notStartedTitle: 'Työpaja ei ole käynnissä',
    notStartedBody: 'Voit valmistella moduulit jo nyt. Käynnistä, kun huone on valmis: seinät näyttävät ensin Kuution.',
    start: 'Käynnistä työpaja',
    startFailed: 'Käynnistys epäonnistui: {{error}}',
    chainMissing: 'Tällä instanssilla ei ole työpajan kulkua.',
    chainLoadFailed: 'Työpajan kulun lataus epäonnistui: {{error}}',
    manualNeededBar: 'Syötettävä käsin ennen aloitusta: {{items}}',
    orderWarningBar: 'Järjestysvaroitus: {{items}} tuotetaan vasta myöhemmin kulussa.',
    navAria: 'Moduulit',
    setup: 'Valmistelu',
    stepOf: 'Moduuli {{current}} / {{total}}',
    gate: {
      ok: 'Tarkistukset kunnossa',
      unmet: '{{count}} kesken',
      open: 'Avaa vaiheen ohjaimet',
    },
    moduleActions: {
      neverRun: 'Ei vielä ajettu',
      running: 'Käynnissä',
      done: 'Valmis',
      failed: 'Epäonnistui',
      errors: '{{count}} virhettä',
      leaveTitle: 'Ennen kuin jatkat',
      continueAnyway: 'Jatka silti',
      cancel: 'Peruuta',
      checkUnreadable: 'Tarkistusta ei voitu lukea: {{detail}}',
      signin: 'Moduulin toiminnot vaativat kirjautumisen Sitran tunnuksella.',
    },
    previous: 'Edellinen',
    next: 'Seuraava',
    pause: 'Tauko',
    resume: 'Jatka',
    timerPlus: 'Lisää 5 minuuttia',
    timerMinus: 'Vähennä 5 minuuttia',
    stop: 'Lopeta työpaja',
    live: 'LIVE',
    state: {
      ready: 'Tuotos valmis',
      missing: 'Tuotos puuttuu',
      checksOk: 'Tarkistukset kunnossa',
    },
    noSettingsTitle: 'Ei ohjaajan asetuksia',
    noSettingsBody: 'Tämä moduuli ei tarvitse ohjaajalta erillisiä asetuksia.',
    manualTitle: 'Syötetään käsin',
    manualBody: 'Tämä moduuli tarvitsee tiedon, jota mikään aiempi moduuli ei tuota. Syötä se käsin ennen kuin moduuli alkaa.',
    manualDone: 'syötetty käsin',
    orderWarning: '{{handoff}} tuotetaan vasta myöhemmin ({{producer}}).',
    noEditor: 'Tälle tiedolle ei ole vielä editoria.',
    openEditor: 'Syötä käsin',
    closeEditor: 'Sulje',
    enterOnContent: 'Syötä Sisältö-sivulla',
    blockedUntil: 'Moduulin sisältö avautuu, kun {{items}} on syötetty.',
    settingsTitle: 'Näytöt ja ajoitus',
    duration: 'Kesto (min)',
    slideStart: 'Ensimmäinen dia',
    slideEnd: 'Viimeinen dia',
    access: 'Osallistujat',
    accessAuto: 'Avautuu, kun kulku saavuttaa moduulin',
    accessOpen: 'Aina auki',
    accessLocked: 'Lukittu',
    screenStates: 'Näyttötiloja: {{count}}',
    editScreens: 'Muokkaa näyttöjä',
    saved: 'Tallennettu',
    saveFailed: 'Tallennus epäonnistui: {{error}}',
    chainTitle: 'Työpajan kulku',
    chainHint: 'Tämän instanssin moduulit järjestyksessä. Moduuleja ja järjestystä muokataan koostajassa; valmistelu, ajoitus ja käsin syötettävät tiedot: Työpajan ohjaus.',
    openOrchestrator: 'Avaa työpajan ohjaus',
  },
  adminHome: {
    stage_prepare: 'Valmistelu',
    stage_run: 'Toteutus',
    stage_results: 'Tulokset',
    currentStage: 'Nyt',
    nextStep: 'Seuraava askel',
    moveTo_run: 'Siirry toteutukseen',
    moveTo_results: 'Siirry tuloksiin',
    stageDone: 'Kaikki tehty.',
    allViews: 'Kaikki näkymät',
    legacy: 'vanha',
    health: 'Palveluiden tila',
    backend: 'Taustapalvelu',
    database: 'Tietokanta',
    rag: 'Tietopohjahaku',
    view_impactPath: 'Vaikutuskartta',
    view_pivotPoints: 'Vipupisteet',
    view_lenses: 'Esteet ja mahdollisuudet',
    view_solutions: 'Ratkaisut',
    view_report: 'Julkinen raportti',
    view_impactMachine: 'Impact Machine',
    view_statmap: 'Tilastokartta',
  },
  stageStatus: {
    goal: 'Työpajan tavoite kirjattu',
    language: 'Kieli: {{language}}',
    flow: 'Kulku koottu: {{modules}} moduulia',
    inputs: 'Moduulien esitiedot: {{missing}} puuttuu',
    scenarios: 'Skenaariot: {{count}}',
    access: 'Pääsy: työpajan PIN tai {{count}} henkilökohtaista koodia',
    datasets: 'Tietopohja: {{count}} aineistoa, {{pending}} odottaa tarkistusta',
    slides: 'Diaesitys liitetty',
    organisations: 'Organisaatiot tuotu: {{count}}',
    started: 'Työpaja käynnistetty',
    progress: 'Kulussa: vaihe {{current}}/{{total}}',
    devices: 'Laitteiden yhteydet',
    report: 'Raportti luotu',
    translations: 'Käännökset: {{languages}}',
    transcripts: 'Litteraatit: {{count}}',
    whatif: 'Mitä jos? -tekstit: {{count}}',
    summary: 'Johdon tiivistelmä',
    export: 'Vienti ja arkistointi',
    optional: 'valinnainen',
    byScript: 'skriptillä',
  },
  stageRow: {
    live: 'Työpaja käynnissä',
    stillRunning: 'Työpaja jatkuu, näytöt pysyvät vaiheessa',
    step: 'vaihe {{current}}/{{total}}',
    backToWorkshop: 'Palaa Työpajaan',
  },
  prep: {
    title: 'Moduulien esitiedot',
    beforeTitle: 'Ennen Kuutiota',
    duringTitle: 'Päätetään Kuution aikana (Työpaja)',
    required: 'tarvitaan',
    optional: 'valinnainen',
    sameAsAbove: 'Sama tieto kuin ylempänä.',
    preparedAbove: 'Skenaariot ja muuttujat, ylimpänä tällä sivulla',
    knowledge: 'Tietopohja-sivulla',
    system: 'Luodaan automaattisesti',
    workshop: 'Syntyy Kuution aikana moduulissa {{module}}',
    none: 'Ei syötettävissä etukäteen.',
    noneRequired: 'Tarvitaan, mutta tälle ei ole syöttötapaa etukäteen: vain skriptillä tai tietokantaan. Lisää kulkuun moduuli, joka tuottaa sen.',
    noInputs: 'Ei esitietoja.',
    noDecisions: 'Ei ohjaajan päätöksiä Kuution aikana.',
    panel: 'Moduulin oma ohjaajapaneeli',
    noChain: 'Kulkuun ei ole vielä valittu moduuleja.',
    openFlow: 'Kokoa kulku',
  },
  scenarioVariables: {
    noFuture: 'Ilman tulevaisuuskuvaa',
    groupCount: '{{count}} muuttujaa',
    sectionTitle: 'Skenaariot ja muuttujat ({{count}})',
    title: 'Muuttujat ({{count}})',
    name: 'Muuttuja',
    description: 'Kuvaus',
    future: 'Tulevaisuuskuva',
    add: 'Lisää muuttuja',
    delete: 'Poista muuttuja',
    deleteConfirm: 'Poistetaanko muuttuja {{name}}?',
    newName: 'Uusi muuttuja',
    toggle: 'Muuttujat',
    saveFirst: 'Tallenna skenaario ensin, niin voit lisätä muuttujia.',
  },
  scenarioCopy: {
    label: 'Kopioi toisesta Kuutiosta:',
    pick: 'Valitse Kuutio…',
    count: '{{count}} skenaariota',
    button: 'Kopioi skenaariot ja muuttujat',
    done: 'Kopioitu {{scenarios}} skenaariota ja {{variables}} muuttujaa.',
    confirmReplace: 'Tässä Kuutiossa on jo {{count}} vaikutuskartan solmua. Kopiointi korvaa samannimisten skenaarioiden muuttujat ja piilottaa muut skenaariot. Jatketaanko?',
  },
  instanceList: {
    title: 'Instanssien hallinta',
    lead: 'Kaikki Kuutiot. Avaa-painike vie Kuution yleiskuvaan, josta löytyvät sen vaiheet ja asetukset.',
    create: 'Luo uusi Kuutio',
    search: 'Hae nimellä tai kuvauksella',
    filter_archived: 'Arkistoidut',
    filter_all: 'Kaikki',
    loadFailed: 'Instanssien haku epäonnistui: {{error}}',
    retry: 'Yritä uudelleen',
    empty: 'Ei vielä yhtään Kuutiota. Luo ensimmäinen.',
    noMatches: 'Ei hakua vastaavia Kuutioita.',
    participants: 'Osallistujat',
    participantCount: '{{count}} osallistujaa',
    workshopDate: 'Työpajan päivä',
    open: 'Avaa',
    filter_current: 'Nykyiset',
    archive: 'Arkistoi',
    archiveHint: 'Arkistoitu Kuutio poistuu kaikista valikoista ja näkyy vain Instanssit-sivun Arkistoidut-suodattimella. Sen voi palauttaa.',
    archivedHelp: 'Tämä Kuutio on arkistoitu: se ei näy valikoissa. Palauta tuo sen takaisin.',
    archivedOn: 'Arkistoitu {{date}}',
    restore: 'Palauta',
    archived: '"{{title}}" arkistoitiin.',
    restored: '"{{title}}" palautettiin.',
    deleted: '"{{title}}" poistettiin ({{count}} riviä).',
  },
  instanceLabels: {
    title: 'Tunnisteet',
    help: 'Valitse vähintään yksi. Tunnisteilla Instanssit-lista suodatetaan.',
    required: 'Valitse Kuutiolle vähintään yksi tunniste.',
    filterBy: 'Tunniste:',
    none: 'Ei tunnistetta',
    edit: 'Muokkaa tunnisteita',
    kuutio: 'Kuutio',
    kuutio_hint: 'Oikea työpaja oikeilla osallistujilla',
    demo: 'Demo',
    demo_hint: 'Esittelyyn vieraille',
    simulation: 'Simulaatio',
    simulation_hint: 'AI-persoonilla ajettu simulaatio',
    test: 'Testi',
    test_hint: 'Tekninen testi tai kertakäyttöinen kopio',
    lab: 'Lab',
    lab_hint: 'Uuden moduulin kokeilu oikealla aineistolla tai tilaisuudella',
    event: 'Tilaisuus',
    event_hint: 'Yksittäinen tilaisuus, ei kokonainen Kuutio',
  },
  instanceDelete: {
    title: 'Poista Kuutio lopullisesti',
    lead: 'Kuutio "{{title}}" ja kaikki siihen kuuluva data poistetaan pysyvästi. Tätä ei voi perua.',
    previewHeading: 'Poistetaan {{count}} riviä:',
    previewFailed: 'Esikatselu epäonnistui: {{error}}',
    typeTitle: 'Vahvista kirjoittamalla Kuution nimi: {{title}}',
  },
  settingsPages: {
    keyActorsTitle: 'Keskeisimmät toimijat',
    keyActorsLead: 'Tahot, joihin tämä työpaja ulottuu: ketkä ovat paikalla tai heidän kauttaan tavoitettavissa.',
    keyActorsLabel: 'Yksi toimija riville',
    keyActorsPlaceholder: 'Esim. ministeriö, kunnanvaltuusto tai järjestö',
    keyActorsHelp: 'Ongelmakartan vipupisteet lukevat listan työpajan kuvauksen ohella: kun instrumentin voi muuttaa jokin näistä, se on työpajan mandaatissa. Tyhjänä tekoäly päättelee mandaatin kuvauksesta.',
    keyActorsSave: 'Tallenna toimijat',
    keyActorsSaved: 'Toimijat tallennettu',
    webSearchTitle: 'Verkkohaku',
    webSearchLead: 'Kooste-analyysit voivat hakea tietoa myös verkosta, tarkistetuilta julkaisijoilta.',
    webSearchLabel: 'Verkkohaku kooste-analyyseihin',
    webSearchHelp: 'Ongelmakartan ja ratkaisujen kooste-analyysit hakevat verkosta esimerkiksi, onko vastaavaa kokeiltu muualla. Vain tarkistettujen julkaisijoiden sivut näytetään, eriteltyinä tutkimusaineistosta ja luokiteltuina (tutkimus, viranomainen, järjestö, etujärjestö, uutinen). Hakukysymykset sisältävät vipupisteiden ja ratkaisujen otsikot.',
    personAddTitle: 'Lisää osallistuja',
    personTitle: 'Titteli',
    personOrganisation: 'Organisaatio',
    personAdded: '{{who}} lisätty listaan. Kutsu lähtee, kun painat Lähetä kutsut.',
    peopleInvitedCol: 'Kutsuttu',
    peopleNotInvited: 'ei kutsuttu',
    peopleSignedIn: 'kirjautunut {{date}}',
    peopleSelectAll: 'Valitse kaikki',
    peopleResendOne: 'Lähetä uudelleen',
    peopleSendOne: 'Lähetä kutsu',
    peopleSendInvites: 'Lähetä kutsut ({{count}})',
    peopleSendHint: 'Tervetuloviesti valituille. Kutsun voi lähettää uudelleen.',
    peopleInviteConfirm: 'Lähetetäänkö tervetuloviesti {{count}} osallistujalle?',
    peopleInvitedDone: 'Kutsu lähetetty {{count}} osallistujalle.',
    peopleInviteFailed: 'Lähetetty {{sent}}, epäonnistui {{failed}}: {{error}}',
    personAdd: 'Lisää osallistuja',
    personAlreadyIn: '{{who}} oli jo listalla.',
    peopleFromFile: 'Lisää tiedostosta',
    peopleFileHint: 'Excel (.xlsx) tai CSV. Otsikkorivi: nimi, titteli, organisaatio, sähköposti — tai pelkkä osoitelista.',
    peopleFileAdded: 'Tiedostossa {{rows}} riviä: {{added}} lisätty, {{alreadyIn}} oli jo, {{skipped}} ohitettu (ei osoitetta).',
    peopleSendInvitesTitle: 'Lähetetäänkö kutsut?',
    peopleSendInvitesShort: 'Lähetä',
    peopleInvitedOn: 'Kutsuttu {{date}}',
    peopleTitle: 'Kuution osallistujat',
    peopleLead: 'Tämä lista on Kuution osallistujat: he näkevät Kuution omalla sivullaan (/me) ja saavat Viestit-sivun osallistujaviestit.',
    peopleEmpty: 'Ei vielä osallistujia. Liitä osoitteet alle tai tuo Lyytin ilmoittautuneet.',
    peopleName: 'Nimi',
    peopleEmail: 'Sähköposti',
    peopleRole: 'Rooli',
    peopleLastLogin: 'Kirjautunut',
    peopleNeverSignedIn: 'ei vielä',
    peopleRemove: 'Poista Kuutiosta',
    peopleRemoveConfirm: 'Poistetaanko {{who}} tämän Kuution osallistujista? Tili säilyy.',
    peopleRemoved: '{{who}} poistettu Kuutiosta.',
    peopleImportLyyti: 'Tuo Lyytin ilmoittautuneet',
    peopleNoLyyti: 'Kuutiolla ei ole Lyyti-tapahtumaa.',
    peopleFromLyyti: 'Lyytissä {{registrants}} ilmoittautunutta, {{added}} lisätty.',
    role_participant: 'osallistuja',
    role_facilitator: 'fasilitaattori',
    role_admin: 'ylläpitäjä',
    role_owner: 'omistaja',
    importTitle: 'Osallistujalista',
    importLead: 'Ilmoittautuneet (Lyyti) ja heidän organisaationsa tuodaan skriptillä. Ne näkyvät raportin Osallistujat-osiossa.',
    selectInstance: 'Valitse instanssi yläpalkin valikosta.',
    loading: 'Ladataan…',
    loadFailed: 'Lataus epäonnistui: {{error}}',
    saveFailed: 'Tallennus epäonnistui: {{error}}',
    basicPageTitle: 'Perustiedot',
    basicPageLead: 'Kuution nimi, kieli ja tavoite, sen tila sekä tietojen tyhjennys ja poisto.',
    basicTitle: 'Perustiedot',
    basicLead: 'Kieli ohjaa sekä käyttöliittymää että tekoälyn tuottamaa tekstiä.',
    kuutioNumber: 'Kuution numero',
    kuutioNumberHelp: 'Näkyy raportin otsikossa (KUUTIO N) ja raportin osoitteessa (K<N>-…). Osallistujalista ja raportin kuvat haetaan sen mukaan. Vain pääkäyttäjä ja pääfasilitaattori voivat muuttaa sitä.',
    kuutioNumberInvalid: 'Kuution numeron pitää olla positiivinen kokonaisluku.',
    kuutioNumberTaken: 'Tallennettu, mutta numero {{number}} on jo käytössä: {{titles}}.',
    statusTitle: 'Tila',
    statusLead: 'Tila siirtyy yleensä vaiheiden mukana (Siirry toteutukseen, Siirry tuloksiin). Aseta se käsin vain poikkeustapauksissa.',
    statusHelp: 'Luonnos ja Arkistoitu piilottavat Kuution osallistujilta.',
    dangerTitle: 'Vaarallinen alue',
    dangerLead: 'Tyhjennys poistaa osallistujien ja tekoälyn tuotokset mutta säilyttää valmistelun. Poisto poistaa koko Kuution.',
    cleared: 'Tyhjennetty: {{count}} riviä.',
    contentPageTitle: 'Sisältö',
    contentPageLead: 'Kaikki ennen Kuutiota tiedossa oleva: skenaariot ja muuttujat sekä kulun jokaisen moduulin esitiedot. Kuution aikana tehtävät päätökset tehdään Työpajassa.',
    scenariosLead: 'Nimi, kuvaus, tunnus ja väri. Muuttujat avautuvat skenaarion omasta painikkeesta; niistä tulee vaikutuskartan lähtösolmut.',
    participantsPageTitle: 'Osallistujat',
    participantsPageLead: 'Miten osallistujat ja laitteet pääsevät Kuutioon.',
    accessTitle: 'Pääsy',
    accessLead: 'Työpajan PIN on koodi, jolla tila kirjautuu. Se näkyy toteutusnauhassa työpajan aikana.',
    openPinHelp: 'Testitila: mikä tahansa PIN avaa tämän Kuution. Pidä pois päältä oikeassa työpajassa.',
    remoteEntryLabel: 'Työpajaan pääsee omalta sivulta',
    remoteEntryHelp: 'Näyttää osallistujille Siirry työpajaan -painikkeen omalla sivulla (/me). Oletuksena pois; kytke päälle, kun työpaja alkaa.',
    datasetsPageTitle: 'Tietopohja',
    datasetsPageLead: 'Mitä tutkimusaineistoa tämän Kuution tekoäly voi hakea.',
    datasetsLead: 'Perusaineisto on kaikkien käytössä, ellei sitä rajata pois. Muut aineistot liitetään tähän Kuutioon erikseen.',
    prepareTitle: 'Tietopohjien valmistelu',
    prepareLead: "Kuution tutkimusaineisto kootaan ja tarkistetaan Aineistot → Tietopohjat -sivulla, ennen kuin tietopohja liitetään tähän instanssiin.",
    openPrepare: 'Avaa Tietopohjat',
  },
  datasetPanel: {
    title: 'RAG-tietopohjat',
    base: 'perus',
    excluded: 'rajattu pois',
    includeBase: 'Ota perusaineisto mukaan',
    excludeBase: 'Rajaa perusaineisto pois',
    include: 'Ota mukaan',
    exclude: 'Rajaa pois',
    detach: 'Irrota',
    attach: 'Liitä',
    newIdPlaceholder: 'uuden-aineiston-tunnus',
    namePlaceholder: 'Nimi',
    createAttach: 'Luo ja liitä',
  },
  exportPage: {
    title: 'Vienti',
    lead: 'Työpajan vieminen ulos Kuutiosta: koko sisältö, tutkimusaineisto ja kopiot.',
    workshopTitle: 'Työpaja JSON-tiedostona',
    workshopLead: 'Skenaariot, muuttujat, polut, vipupisteet, linssit, ratkaisut, litteraatit, raportti ja kulku. Henkilötiedot poistetaan.',
    workshopButton: 'Lataa työpaja (JSON)',
    ragTitle: 'Tutkimusaineisto',
    ragLead: 'Tämän Kuution RAG-aineisto JSON-tiedostona.',
    ragButton: 'Lataa aineisto (JSON)',
    cloneTitle: 'Kloonaus ja vienti',
    cloneLead: 'Kopio tästä Kuutiosta uudella nimellä: tälle palvelimelle tai kloonipakettina toiseen ympäristöön. Mitään olemassa olevaa ei korvata.',
    archiveTitle: 'Arkistointi',
    archiveLead: 'Arkistoitu Kuutio piiloutuu osallistujilta, mutta raportti ja tiedot säilyvät.',
    archiveButton: 'Aseta tila Perustiedoissa',
    downloading: 'Ladataan…',
    failed: 'Lataus epäonnistui: {{error}}',
  },
  clone: {
    nameLabel: 'Kloonin nimi',
    namePlaceholder: 'Uusi nimi, esim. TESTI: {{name}}',
    nameFree: 'Nimi on vapaa.',
    nameTaken: 'Nimi on jo käytössä: {{name}}',
    nameInvalid: 'Anna nimi, jossa on kirjaimia tai numeroita.',
    checking: 'Tarkistetaan…',
    modeLabel: 'Mitä kopioidaan',
    modePrepared: 'Vain valmisteltu sisältö',
    modePreparedHelp: 'Asetukset, skenaariot ja muuttujat, linssit, työpajan kulku, näytöt, organisaatiot ja liitetyt tietopohjat.',
    modeEverything: 'Kaikki',
    modeEverythingHelp: 'Lisäksi osallistujien ja tekoälyn tuotokset: polut, linssien sisältö, vipupisteet, ratkaisut, litteraatit ja raportti.',
    neverCopied: 'PIN-koodeja, osallistujia, ääniä, chatteja ja lokeja ei kopioida koskaan. Kloonille luodaan omat PIN-koodit.',
    includeFiles: 'Mukaan alkuperäiset tiedostot (PDF:t)',
    includeFilesHelp: 'Ilman tiedostoja paketti on pienempi, mutta lähteitä ei voi muuntaa uudelleen.',
    sameServerTitle: 'Kloonaa tälle palvelimelle',
    cloneButton: 'Kloonaa',
    cloning: 'Kloonataan…',
    cloned: 'Valmis: {{name}}',
    openClone: 'Avaa klooni',
    exportInstance: 'Vie Kuutio',
    exportDataset: 'Vie tietoaineisto',
    exportHelpInstance: 'Lataa kloonipaketin (.zip). Tuo se toisessa ympäristössä: Instanssit → Tuo Kuutio.',
    exportHelpDataset: 'Lataa kloonipaketin (.zip). Tuo se toisessa ympäristössä: Aineistot → Tietopohjat → Tuo tietoaineisto.',
    exporting: 'Pakataan…',
    importInstance: 'Tuo Kuutio',
    importDataset: 'Tuo tietoaineisto',
    importLeadInstance: 'Kloonipaketti (.zip) toisesta ympäristöstä tai tältä palvelimelta. Kuutio saa uuden nimen, eikä mitään olemassa olevaa korvata.',
    importLeadDataset: 'Tietoaineiston kloonipaketti (.zip). Tietoaineisto saa uuden nimen, eikä mitään olemassa olevaa korvata.',
    datasetSectionTitle: 'Kloonaus ja vienti',
    fileLabel: 'Kloonipaketti',
    reading: 'Luetaan pakettia…',
    packageFrom: 'Ympäristö {{env}}, viety {{date}}',
    packageRows: '{{count}} riviä, {{tables}} taulua',
    modeIs: 'Sisältö: {{mode}}',
    schemaProblems: 'Tältä palvelimelta puuttuu osia, joita paketti tarvitsee. Päivitä palvelin ensin:',
    missingDatasets: 'Näitä tietopohjia ei ole tällä palvelimella, joten niitä ei liitetä: {{ids}}',
    importButton: 'Tuo',
    importing: 'Tuodaan…',
    failed: 'Epäonnistui: {{error}}',
    warningsTitle: 'Viittaukset, joita ei voitu säilyttää:',
    warningCleared: '{{table}}.{{column}}: {{rows}} viittausta tyhjennetty ({{refTable}} ei ole täällä)',
    warningDropped: '{{table}}: {{rows}} riviä jätetty pois ({{refTable}} ei ole täällä)',
    reindexStarted: 'Työpajan oma RAG-aineisto rakennetaan uudelleen taustalla.',
    reindexFailed: 'Työpajan RAG-aineiston uudelleenrakennus ei käynnistynyt: {{error}}',
  },
  scriptHint: {
    skill: 'Tehdään skriptillä. Ohje: taito {{skill}}.',
  },
  reportStatus: {
    title: 'Raportin aineisto',
  },
  reportSettings: {
    title: 'Raportin asetukset',
    implementationPlans: 'Näytä "Miten aloitamme?" -osiot',
    implementationPlansHelp: 'Toteutussuunnitelmat näkyvät raportin ratkaisuosiossa.',
    reportPin: 'Raportin PIN',
    reportPinHelp: 'Suojatuksi merkityt osiot avautuvat tällä koodilla. Tyhjä = ei suojattuja osioita.',
    sectionAccess: 'Osioiden näkyvyys (julkinen, suojattu, piilotettu) valitaan raportin muokkaustilassa.',
    openEditor: 'Avaa raportti',
  },
  reportStep: {
    intro: 'Raportin luonti, kuvat ja tiivistelmä ovat tämän osion toimintoja; tässä aineisto, käännökset, asetukset ja rajaukset.',
    stage: 'Vaihe',
    inResults: 'Tulokset-vaiheessa',
    notInResults: 'Ei vielä Tulokset-vaiheessa (toiminto Siirry tuloksiin)',
    history: 'Raportin historia',
    loadFailed: 'Raportin tilan haku epäonnistui: {{error}}',
    created: 'Luotu',
    notCreated: 'Ei vielä luotu',
    translations: 'Käännökset',
    noTranslations: 'Ei käännöksiä',
    openReport: 'Siirry raporttiin',
    moveToResults: 'Siirry tuloksiin',
  },
  pivotsV2Step: {
    intro: 'Vipupisteet haetaan, hyväksytään ja hylätään vipupistenäkymässä.',
    loadFailed: 'Vipupisteiden haku epäonnistui: {{error}}',
    accepted: 'Hyväksytty',
    proposed: 'Ehdolla',
    dismissed: 'Hylätty',
    noRun: 'Vipupisteitä ei ole vielä haettu.',
    open: 'Avaa vipupisteet',
  },
  adminRunStrip: {
    pinLabel: 'PIN',
    instancePin: 'Työpajan PIN',
    pinTitle: 'Osallistujien PIN-koodit',
    copy: 'Kopioi',
    copied: 'Kopioitu',
    openParticipantView: 'Avaa osallistujanäkymä tällä PIN-koodilla uuteen ikkunaan',
    noPins: 'Ei PIN-koodeja. Lisää ne Valmistelu-vaiheen Osallistujat-sivulla.',
    pinsFailed: 'PIN-koodien haku epäonnistui: {{error}}',
    locked: 'Lukittu',
    open: 'Avoin',
  },
  screenContent: {
    title: 'Näyttösisältö',
    description: 'Mitä kukin näyttö näyttää kussakin vaiheessa. Suunnitellaan etukäteen; työpajan aikana laitteita ohjataan Laitteet-sivulta.',
    loadFailed: 'Kulun lataus epäonnistui: {{error}}',
  },
  workshopLiveControls: {
    title: 'Live-asetukset',
    statusLabel: 'Tila',
    openPinLabel: 'Avoin PIN (testi)',
    votingLabel: 'Ratkaisuäänestys',
    scoreLabel: 'Ratkaisupisteet',
    screenControlLabel: 'Näytönohjaus',
    screenControlHint: 'Kun päällä, /screen ohjaa seinänäyttöjä',
    saving: 'Tallennetaan…',
    saved: 'Tallennettu',
  },

  instanceSettings: {
    language: 'Työpajan kieli',
    languageHelp: 'Vaikuttaa käyttöliittymään ja tekoälyn vastauskieleen (FI / EN / SV).',
  },

  artifact: {
    collection: 'Kokoelma',
    collectionItems: 'Sivut ({{n}})',
    eyebrow: 'Kuutio-agentit',
    loading: 'Haetaan…',
    notFound: 'Sivua ei löydy',
    revoked: 'Tämä sivu on poistettu jaosta',
    needsSignIn: 'Tämä sivu vaatii kirjautumisen',
    failed: 'Sivua ei saatu haettua',
    summary: 'Yhteenveto chatissa',
    summaryLead: 'Se, mitä kysyjä näki chat-paneelissa säikeen sulkeuduttua.',
    noSummary: 'Ei erillistä yhteenvetoa.',
    report: 'Raportti',
    reportLead: 'Kirjoitettu puheenvuoroista ja niiden järjestyksestä, ei muusta.',
    history: 'Historia: miten vastaus syntyi',
    historyLead: 'Jokainen askel siinä järjestyksessä kuin se tapahtui. Jokainen ääni näkee vain oman pohjansa, oman tietopohjansa ja muiden viimeisen puheenvuoron.',
    sources: 'Lähteet',
    sourcesLead: 'Yksi numero on yksi lähde koko vastauksessa. Jokainen on haettu tai luettu äänen omasta Kuutiosta, ei muistettu.',
    asker: 'Kysyjä',
    assistant: 'Assistentti',
    turnSources: 'Lähteet, joihin tämä puheenvuoro viittasi ({{n}})',
    filterStep: 'Suodatin järjestää (ei ehdota, ei lisää)',
    synthesisStep: 'Synteesi kokoaa',
    reportStep: 'Raportti kirjoitetaan',
    reportStepNote: 'Puheenvuoroista ja järjestyksestä; luku 2 yllä.',
    summaryStep: 'yhteenveto chattiin',
    summaryStepNote: 'Luku 1 yllä.',
    noOrdering: 'Järjestystä ei tallennettu tässä ajossa.',
    agreed: 'Yhtä mieltä',
    disputed: 'Eri mieltä',
    open: 'Avoinna',
    findings: 'Löydökset',
    tensions: 'Jännitteet',
    gaps: 'Aukot',
    implications: 'Johtopäätökset',
    disclaimer: 'Äänet ovat menneiden Kuutioiden synteesejä, tämän työpajan omaa aineistoa tai synteettisiä kohderyhmäagentteja mielipideaineistosta, eivät osallistujia eivätkä organisaatioita. Kustannukset ovat hinnastosta laskettuja arvioita.',
    published: 'Julkaistu {{date}}',
  },
  chatAgent: {
    introTitle: 'Hei! Olen Kuution tekoälyavustaja.',
    introBody: 'Tunnen työpajan aineiston, tutkimustaustan ja osallistujien ideat. Kysy vapaasti — voin auttaa ymmärtämään taustoja, vertailemaan näkökulmia tai tiivistämään keskusteluja.',
    introDisclaimer: 'Älä ota kaikkea sanomaani absoluuttisena totuutena — olen tekoäly ja minulla on rajani.',
    tryTip: 'Kokeile Kuutio-apuria',
    inputPlaceholder: 'Kysy mitä tahansa...',
    askMeAnything: 'Kysy mitä tahansa',
    errorPrefix: 'Virhe: {{message}}',
    connectionError: 'Yhteysvirhe. Yritä uudelleen.',
    modelTitle: 'AI-malli',
    clearTitle: 'Tyhjennä keskustelu',
    clearConfirm: 'Tyhjennetäänkö keskustelu? Tätä ei voi perua.',
    clear: 'Tyhjennä',
    assistantTitle: 'Kuutio Assistant',
    assistantSubtitle: 'Research-powered insights',
    assistantSubtitleHeadai: 'HeadAI skills & semantics',
    selectModelTitle: 'Select AI model',
    closeChat: 'Close chat',
    jumpToLatest: 'Siirry uusimpaan',
    agentsRowTitle: 'Kuutio-agentit:',
    agentIncluded: 'Mukana keskustelussa — napauta jättääksesi pois',
    agentExcluded: 'Ei mukana — napauta ottaaksesi mukaan',
    agentsSelectLabel: 'Kuutio-agentit {{included}}/{{total}}',
    agentsSelectTitle: 'Valitse, ketkä Kuutio-agentit ovat mukana keskustelussa',
    agentInfoTitle: 'Tietoa agentista',
    agentInfoSynthesis: 'menneen Kuution asiantuntija-ääni',
    agentInfoTopic: 'Aihe',
    agentInfoNoPerspective: 'Näkökulmaa ei ole vielä kirjoitettu.',
    agentInfoDisclaimer: 'Puhuu oman Kuutionsa näkökulmasta: sen tulokset ja tietopohja ovat sen kokemus ja todisteet. Lähteillä merkityt kohdat ovat työpajan tuloksia, muu on agentin päättelyä tästä näkökulmasta. Se on työpajan ääni, ei yksittäinen henkilö eikä organisaatio.',
    askAgentPrefix: 'Kysy {{name}}:lta:',
    askAgentButton: 'Kysy {{name}}:lta',
    agentsTogether: 'Kuutio-agentit yhdessä',
    agentThin: 'ohut pohja',
    agentThick: 'vahva pohja',
    agentSynthetic: 'synteettinen',
    agentInfoOpinion: 'synteettinen kohderyhmäagentti mielipideaineistosta',
    agentInfoDisclaimerOpinion: 'Edustaa mielipideaineiston vastausjakaumaa: ryhmät ovat tilastollisia rekonstruktioita itse valikoituneesta verkkokeskustelusta, eivät ihmisiä eivätkä edustava otos. Jokainen väite nojaa aineiston väittämiin ja niiden ryhmäkohtaisiin lukuihin; muu on agentin päättelyä ryhmien profiileista. Se ei ole henkilö, eikä sitä lainata osallistujana.',
    agentDocumented: 'dokumentoitu kanta',
    agentInfoParty: 'puolueen dokumentoitu kanta julkisista asiakirjoista',
    agentInfoDisclaimerParty: 'Edustaa puolueen dokumentoitua kantaa yhdestä aiheesta: puolueohjelmat, puoluetta sitova hallitusohjelma ja eduskuntaryhmän päivätyt täysistuntopuheenvuorot, kaikki julkisia asiakirjoja. Se on ryhmä, ei koskaan henkilö; jokainen väite nojaa merkittyyn asiakirjaan, muu on agentin päättelyä. Rekonstruktio, jonka puolue itse voi lukea ja kiistää.',
    tools: {
      listAgents: 'Haetaan Kuutio-agentteja...',
      askKuutio: 'Kuutio-agentti vastaa...',
      bounce: 'Agentit pallottelevat kysymystä...',
      deepDive: 'Äänet analysoivat kysymystä syvältä...',
      headaiPlaybook: 'Ladataan HeadAI-opasta...',
      headaiAnalysis: 'Haetaan HeadAI-analyysiä...',
      searchResearch: 'Haetaan tutkimustietoa...',
      workshopData: 'Haetaan työpajan tietoja...',
      solutions: 'Haetaan ratkaisuja...',
      pivotPoints: 'Haetaan vipupisteitä...',
      lensAnalysis: 'Haetaan linssituloksia...',
      workshopNodes: 'Haetaan vaikutuskartan nodeja...',
      impactPath: 'Haetaan vaikutuspolkua...',
      organisations: 'Haetaan organisaatioita...',
      fallback: 'Haetaan tietoja...',
    },
    thread: {
      kind: {
        bounce: 'Pallottelu',
        deep_dive: 'Syväanalyysi',
      },
      findings: 'löydöksiä {{n}}',
      tensions: 'jännitteitä {{n}}',
      gaps: 'aukkoja {{n}}',
      turns: '{{n}} puheenvuoroa',
      rounds: '{{n}} kierrosta',
      running: '{{done}}/{{total}} puhuttu',
      writing: 'Agentit puhuvat, suodatin ja raportti kirjoitetaan…',
      agreed: 'yhtä mieltä {{n}}',
      disputed: 'eri mieltä {{n}}',
      open: 'avoinna {{n}}',
      converged: 'ei todellista erimielisyyttä',
      share: 'Jaa',
      shareCopied: 'Linkki kopioitu',
      shareTitle: 'Julkaise julkisena sivuna ja kopioi linkki',
      sharePublic: 'julkinen linkki',
      shareSignIn: 'Jakaminen vaatii kirjautumisen (ylläpito).',
      openReport: 'Avaa raportti',
      noReport: 'raporttia ei saatu kirjoitettua',
      reportTitle: 'Agenttien raportti',
      download: 'Lataa Markdown-tiedostona',
      close: 'Sulje',
      reportDisclaimer: 'Agentit ovat menneiden Kuutioiden ääniä, eivät osallistujia eivätkä organisaatioita. Lähdemerkinnät [n] vastaavat keskustelun lähdeluetteloa.',
    },
    split: {
      all: 'kaikki',
      note: 'Osuus niistä, jotka ottivat kantaa. Luvut kuvaavat itse valikoituneen verkkokeskustelun osallistujia, eivät väestöä; ryhmät ovat äänestyksistä laskettuja tilastollisia rekonstruktioita.',
    },
    usage: {
      calls: '{{n}} kutsua',
      tokens: '{{n}} tokenia',
      cost: '≈ {{usd}} $',
      costUnknown: 'hinta ei tiedossa',
    },
    deepDiveButton: 'Tee syväanalyysi',
    deepDivePrefix: 'Tee syväanalyysi:',
    reactions: {
      accept: 'Hyväksyn',
      reject: 'Hylkään',
      fix: 'Korjaan',
      acceptHint: 'Tämä pitää paikkansa',
      rejectHint: 'Tämä ei pidä paikkaansa tai ei sovi',
      fixHint: 'Oikeansuuntainen, mutta jokin on pielessä',
      why: 'Miksi?',
      reasons: {
        wrong_owner: 'väärä omistaja',
        impossible_mandate: 'mahdoton mandaatti',
        tried_already: 'kokeiltu jo',
        politically_dead: 'poliittisesti kuollut',
        wrong_scale: 'oikea mutta väärä mittakaava',
      },
    },
  },

  // Tilannekuva — live workshop dashboard (specs/workshop-dashboard.md)
  dashboard: {
    title: 'Tilannekuva',
    live: 'Live',
    stale: 'Ei yhteyttä dataan',
    noData: 'Ei vielä dataa',
    notStarted: 'Työpaja ei ole käynnissä',
    paused: 'Tauko',
    ragCounter: '{{total}} lähdettä · {{retrieved}} haettu',
    costToday: 'tänään {{count}} kutsua · ${{cost}}',
    chatToday: 'tänään {{count}}',
    estimatedEnd: 'Arvioitu lopetus {{time}}',
    close: 'Sulje',
    noInstance: 'Ei valittua työpajaa — avaa näkymä työpajan linkistä.',
    tiles: {
      flow: 'Työpajan kulku',
      progress: 'Vaiheen edistyminen',
      rag: 'Tietopohja',
      cost: 'AI-kustannukset',
      feed: 'Tapahtumat',
      schedule: 'Aikataulu',
      chat: 'Chat',
    },
    units: {
      notes: 'lappua',
      lensItems: 'havaintoa',
      solutions: 'ratkaisua',
      pivotPoints: 'vipupistettä',
      ongelmat: 'ongelmaa',
      ankkurit: 'muutoksen estettä',
      juurisyyt: 'juurisyytä',
      v2Nodes: 'solmua',
      scenarios: 'skenaariota',
      questions: 'kysymystä',
      futuresChosen: 'valittua tulevaisuuskuvaa',
      fieldAnswers: 'vastattua kenttää',
      votes: 'ääntä',
      painPoints: 'kipupistettä',
      drivers: 'hyväksyttyä muutosvoimaa',
      wildCards: 'villiä korttia',
      pathSteps: 'polun askelta',
      futuresApproved: 'hyväksyttyä tavoitetilaa',
      timelines: 'simuloitua aikajanaa',
      leveragePoints: 'vipupistettä',
      pivotThemes: 'teemaa',
    },
    selected: 'valittu',
    noPivot: 'Ei vipupistettä',
    openPivotSummary: 'Avaa vipupisteen yhteenveto',
  },

  ragSourceMap: {
    title: 'Tietopohja',
    loading: 'Ladataan lähteitä…',
    empty: 'Tälle työpajalle ei ole näkyviä lähteitä.',
    error: 'Lähdekartan lataaminen epäonnistui.',
    retrievals: 'hakukertaa',
    baseCluster: 'Perusaineisto',
    notRetrieved: 'Ei vielä haettu',
    counter: '{{total}} lähdettä · {{retrieved}} haettu',
    resetView: 'Palauta näkymä',
    voices: {
      valtio: 'Valtio',
      eduskunta: 'Eduskunta ja lakisääteiset arvioijat',
      kansainvaliset: 'Kansainväliset järjestöt',
      tutkimus: 'Tutkimus ja tiedepaneelit',
      ajatushautomot: 'Ajatushautomot',
      elinkeinoelama: 'Elinkeinoelämä ja konsultit',
      kunnat: 'Kunnat, palkansaajat ja järjestöt',
    },
    contexts: {
      node: 'Vaikutuskartta',
      lens: 'Esteet ja mahdollisuudet',
      solution: 'Ratkaisut',
      pivot: 'Vipupisteet',
      systemic: 'Systeeminen kartta',
      chat: 'Keskustelu',
      ai: 'Tekoälyavustaja',
      other: 'Muu',
    },
  },

  ragSourceMapV2: {
    title: 'Tietopohja (v2)',
    loading: 'Ladataan lähteitä…',
    empty: 'Tälle työpajalle ei ole näkyviä lähteitä.',
    error: 'Lähdekartan lataaminen epäonnistui.',
    perustietopohja: 'Perustietopohja',
    axis: {
      teema: 'ryhmitelty teeman mukaan',
      aani: 'ryhmitelty äänen mukaan',
    },
    teema: {
      teknologia: 'Teknologia',
      ilmasto: 'Ilmasto',
      demokratia: 'Demokratia',
      yhteiskunta: 'Yhteiskunta',
      governance: 'Governance',
    },
    voices: {
      valtio: 'Valtio',
      kansainvaliset: 'Kansainväliset',
      tiede_tutkimus: 'Tiede & tutkimus',
      ajatushautomot: 'Ajatushautomot',
      muut: 'Muut',
    },
    counter: '{{total}} lähdettä · {{retrieved}} haettu',
    counterTotal: '{{total}} lähdettä',
    defaultViewToggle: 'Oletusnäkymä',
    lockScale: 'Lukitse mittakaava',
    switcherLabel: 'Vaihda Kuutio',
    retrievals: 'hakukertaa',
    chunksLabel: 'katkelmaa',
    legendSizeUsage: 'Koko = hakukertoja',
    legendSizeDefault: 'Koko = katkelmia',
    tarkistettavaNote: '{{count}} tarkistettavaa (ei näytetä)',
    notRetrieved: 'Ei vielä haettu',
  },

  ragSourceMapV4: {
    pickInstance: 'Valitse tietopohja',
    modeLahteet: 'Lähteet',
    modeKaytto: 'Käyttö',
    breadthLabel: 'eri hakua',
    statsTitle: 'Käyttö klustereittain',
    vizCluster: 'Klusterinäkymä',
    vizList: 'Listanäkymä',
    vizBig: 'Suurennettu näkymä',
    listOrder: {
      theme: 'Teema',
      size: 'Koko',
      random: 'Satunnainen',
      cluster: 'Klusteri',
    },
    filters: {
      teknologia: 'Teknologia',
      ilmasto: 'Ilmasto',
      demokratia: 'Demokratia',
      yhteiskunta: 'Yhteiskunta',
      governance: 'Valtio',
    },
  },

  pivotPoints: {
    drawerTabLabel: 'Vipupisteet ({{count}})',
    loading: 'Ladataan vipupisteitä...',
    retry: 'Yritä uudelleen',
    errors: {
      accessDenied: 'Istuntosi on vanhentunut. Kirjaudu sisään uudelleen nähdäksesi vipupisteet.',
      clustersFailed: 'Vipupisteiden lataus epäonnistui.',
      loadFailed: 'Vipupisteiden tietojen lataus epäonnistui.',
      noInstance: 'Työpajaa ei ole valittu, joten vipupisteitä ei ole näytettävänä.',
    },
    viewMode: {
      all: 'Kaikki',
      impactPaths: 'Vaikutuspolut',
      clusters: 'Klusterit',
      pivotPoints: 'Vipupisteet',
      list: 'Listaus',
      allTitle: 'Näytä kaikki ajatukset muuttujittain',
      clustersTitle: 'Näytä vipupisteet (semanttiset klusterit) + yksittäiset ajatukset',
      listTitle: 'Selattava lista vipupisteistä',
    },
    method: {
      structural: 'Rakenteellinen',
      structuralTitle: 'Rakenneanalyysi (MICMAC) — vaikutus × riippuvuus vaikutuspolkujen verkostossa. Aina käytettävissä.',
      semantic: 'Semanttinen',
      semanticTitle: 'Semanttiset vipupisteet (AI-klusterit)',
      semanticTitleEmpty: 'Semanttiset vipupisteet — muodosta ensin AI-analyysillä',
    },
    common: {
      back: 'Takaisin',
      info: 'Tiedot',
      zoomIn: 'Lähennä',
      zoomOut: 'Loitonna',
      zoomReset: 'Palauta',
      previousPivot: 'Edellinen vipupiste',
      nextPivot: 'Seuraava vipupiste',
      level: 'Taso {{depth}}',
      membersCount: '{{count}} jäsentä',
      unknown: 'Tuntematon',
      pivotPoint: 'Vipupiste',
      cluster: 'Klusteri',
      human: 'Ihminen',
      more: '+{{count}} lisää',
      participant: 'Osallistuja: {{name}}',
      analysis: 'Analyysi',
      typeLabel: 'Tyyppi:',
      votesLabel: 'Ääniä:',
    },
    memberModal: {
      title: 'Ajatuksen tiedot',
    },
    list: {
      empty: 'Ei vipupisteitä vielä — käytä Klusterit-näkymää löytääksesi semanttisesti yhteen liittyviä ajatuksia.',
      voteHint: 'Napauta vipupistettä äänestääksesi sitä tärkeäksi',
      loginHint: 'Vipupisteet ({{count}} kpl) — kirjaudu sisään äänestääksesi',
      count: '{{count}} kpl',
      openDetails: 'Avaa vipupisteen tiedot',
      vote: 'Äänestä',
      unvote: 'Peruuta ääni',
    },
    branch: {
      tree: 'Puu',
      treeTitle: 'Vaihda puunäkymään',
      cardinal: 'Nelikenttä',
      cardinalTitle: 'Vaihda nelikenttänäkymään',
      snowflake: 'Lumihiutale',
      snowflakeTitle: 'Vaihda lumihiutalenäkymään',
    },
    detail: {
      noDescription: 'Ei kuvausta',
      tabInfo: 'Info',
      tabPaths: 'Polut ({{count}})',
      tabMap: 'Kartta',
      description: 'Kuvaus',
      sourceAi: 'AI-tunnistettu',
      sourceFacilitator: 'Fasilitaattorin luoma',
      confidence: '{{percent}}% varmuus',
      crossScenario: 'Poikkiskenaario',
      linkedPaths: 'Yhdistetyt polut ({{count}})',
      themes: 'Teemat',
      noMembers: 'Ei polkuja',
      createdAt: 'Luotu: {{date}}',
      severity: 'Haasteellisuus',
      optimism: 'Ratkaisuoptimismi',
      leverageActor: 'Kuka voi vaikuttaa',
      leverageEffect: 'Vaikutus työpajan tavoitteeseen',
      rootCause: 'Juurisyy — muuttamalla tätä tavoite liikkuu voimakkaasti',
    },
    drawer: {
      statsPivots: 'Vipupisteet',
      statsClustered: 'Klusteroidut',
      statsCrossScenario: 'Poikkiskenaario',
      analysisSettings: 'Analyysin asetukset',
      minParticipants: 'Min. osallistujia',
      dataParticipants: 'Datassa osallistujia',
      humanNodes: 'Ihmis-solmuja',
      minScenarios: 'Min. skenaarioita',
      maxResults: 'Max. tuloksia',
      minConfidence: 'Min. varmuus',
      similarity: 'Samankaltaisuus',
      sensitivityFallback: 'Keskitaso',
      belowThreshold: 'Datassa on vain {{count}} osallistuja(a), mutta kynnys on {{threshold}}. Analyysi laskee kynnystä automaattisesti, mutta tulokset voivat olla ohuita.',
      aiModel: 'AI-malli',
      autoReports: 'Luo raportit automaattisesti',
      autoReportsHint: 'AI-raportti jokaiselle vipupisteelle (kuluttaa tokeneita)',
      preview: 'Esikatselu',
      fullAnalysis: 'Täysi analyysi',
      progressHint: '{{elapsed}} — tämä kestää muutaman minuutin',
      empty: 'Ei vipupisteitä.',
      emptyStart: 'Ei vielä vipupisteitä.\nVipupisteet ajetaan työpajan hallinnasta (/admin/workshop).',
      presets: {
        conservative: { name: 'Tiukka', description: 'Vahvat yhteydet' },
        balanced: { name: 'Tasapainoinen', description: 'Oletus' },
        exploratory: { name: 'Laaja', description: 'Heikommatkin yhteydet' },
        discovery: { name: 'Löydökset', description: 'Vipupisteet, ristiriidat, yllätykset' },
      },
      sensitivity: {
        strict: 'Tiukka (identtiset)',
        moderate: 'Keskitaso (sama teema)',
        loose: 'Löysä (liittyvät)',
      },
      aiModels: {
        sonnet: { description: 'Nopea, hyvä laatu' },
        opus: { description: 'Paras laatu, hitaampi' },
      },
    },
    structural: {
      nodes: 'Solmua',
      edges: 'Yhteyttä',
      relays: 'Releetä (vipuvarsi)',
      convergences: 'Yhtymäkohtaa',
      candidatesTitle: 'Rakenteelliset vipupiste-ehdokkaat',
      showStarters: 'Näytä myös skenaariomuuttujat',
      hideStarters: 'Piilota skenaariomuuttujat',
      empty: 'Ei kytkettyjä solmuja vaikutuspoluissa.',
      influenceDep: 'vaik {{influence}} · riip {{dependence}}',
      loadingPathways: 'Ladataan vaikutuspolkuja…',
      loadFailed: 'Datan lataus epäonnistui: {{error}}',
      coverageMapTitle: 'Kattavuuskartta — vaikutus syvyyden mukaan',
      networkFooter: 'Sama rakenneanalyysi tulee vipupistenäkymään valittavana menetelmänä (Rakenteellinen / Semanttinen). Seuraavaksi: välillisyyskeskeisyys ja interaktiivinen verkkokuva.',
    },
    reachMap: {
      sizeLegend: '⬤ koko = alavirran kattavuus (vaikutus, max {{max}})',
      hint: 'Kaistat = syvyys causal-ketjussa (riippuvuus). Lehtisolmut (kattavuus 0) piilotettu.',
      nodeTitle: '{{label}}\nvaikutus {{influence}} · riippuvuus {{dependence}}',
    },
    quadrant: {
      driving: 'Ohjaavat',
      relay: 'Releet / kriittiset',
      dependent: 'Riippuvat',
      autonomous: 'Itsenäiset',
    },
    spatial: {
      back: '← Takaisin',
      noConnections: 'Ei yhteyksiä',
      noAnalysis: 'Ei analyysiä saatavilla',
      linkedVariables: 'Yhdistetyt muuttujat ({{count}})',
      noScenarioInfo: 'Ei skenaariotietoja',
    },
  },

  // Participant entry screens
  tablet: {
    subtitle: 'Osallistujan käyttöliittymä',
    selectType: 'Valitse tyyppi',
    typeIdea: 'Idea',
    typeConcern: 'Huoli',
    typeQuestion: 'Kysymys',
    typeScenario: 'Skenaario',
    inputLabel: 'Kirjoita ideasi, kysymyksesi tai huomiosi',
    placeholder: 'Kirjoita tähän...',
    clear: 'Tyhjennä',
    send: 'Lähetä',
    ownInputs: 'Omat syötteet',
  },

  welcome: {
    subtitle: 'Tervetuloa työpajaan',
  },

  scenarioSelector: {
    subtitle: 'Valitse tulevaisuuskuva, jonka pohjalta rakennat vaikutuspolkusi',
    noScenarios: 'Ei skenaarioita',
    noScenariosSubtitle: 'Tähän instanssiin ei ole määritelty skenaarioita',
    variableCount: 'Sisältää 6 muuttujaa valmiina lähtökohtana',
    initializing: 'Alustetaan...',
    startPathway: 'Aloita vaikutuspolku',
  },

  startNode: {
    defaultTitle: 'Nykytila',
    defaultDescription: 'Aloita rakentamaan polkuasi tulevaisuuteen. Valitse lähtöpiste ja luo ensimmäinen seuraus.',
  },

  scenarioWelcome: {
    missingInstance: 'Instanssi puuttuu URL:sta (?kid=...)',
  },

  // Solution Page
  solutionPage: {
    loading: 'Ladataan ratkaisua...',
    notFound: 'Ratkaisua ei löytynyt',
    unknownError: 'Tuntematon virhe',
    backToReport: 'Takaisin raporttiin',
    printPdf: 'Tulosta PDF',
    hybridBadge: 'Yhdistelmäratkaisu',
    scoreLabels: {
      impact: 'Vaikuttavuus',
      feasibility: 'Toteutettavuus',
      innovation: 'Uutuusarvo',
      evidence: 'Tutkimusnäyttö',
    },
    navTabs: {
      summary: 'Tiivistelmä',
      description: 'Kuvaus',
      context: 'Tausta ja resurssit',
      impact: 'Vaikutusalueet',
      analysis: 'AI-analyysi',
      plan: 'Toimeenpano',
    },
    workshopLabel: 'Kuutio — Ratkaisuehdotus',
    workshopLabelWithTitle: 'Kuutio — {{title}}',
    humanWritten: 'osallistujien kirjoittamaa',
    sourceSolutions: 'Yhdistetyt alkuperäisratkaisut',
    problemLabel: 'Minkä ongelman tämä ratkaisee?',
    resourcesLabel: 'Resurssit ja toimijat',
    futureLabel: 'Miksi tämä rakentaa parempaa tulevaisuutta?',
    impactLabels: {
      mindsets: 'Ajattelumallit',
      structures: 'Rakenteet',
      behavior: 'Käyttäytyminen',
    },
    showAiPlan: 'Näytä AI-generoitu toimeenpanosuunnitelma',
    hideAiPlan: 'Piilota AI-ehdotus',
    footer: 'Kuutio Workshop Platform — Ratkaisuehdotus',
    createdDate: 'Luotu {{date}}',
  },

  // Solutions List Page
  solutionsList: {
    loading: 'Ladataan ratkaisuja...',
    instanceMissingError: 'Instance ID puuttuu',
    addInstanceUrl: 'Lisää ?kid=... URL:iin',
    averageScore: '/ 5 keskiarvo (vanhat analyysit)',
    evidenceLabel: 'tunnisteilla arvioitua',
    total: 'yhteensä',
    groupSolutions: 'Ryhmien ratkaisut',
    hybridSolutions: 'Yhdistelmäratkaisut',
    hybridBadge: 'Yhdistelmä',
    footer: 'Kuutio Workshop Platform — Ratkaisuehdotukset',
  },

  reportGen: {
    movedToWorkshop: 'Raportin luonti, kuvat, tiivistelmä, käännökset, asetukset ja rajaukset ovat Työpajan raporttiosiossa.',
    openWorkshop: 'Avaa Työpaja',
    title: 'Raportti',
    description: 'Luo työpajan raportti, käännä se ja päätä, mitä julkinen raportti näyttää.',
    instanceFallback: 'Raportti',
    selectInstance: 'Valitse instanssi ylävalikosta',
    creating: 'Luodaan...',
    create: 'Luo raportti',
    openPublic: 'Avaa julkinen raportti',
    history: 'Historia',
    empty: 'Ei vielä raportteja',
    readers: {
      title: 'Raportin lukijat',
      lead: 'Kutsu lukemaan raportin suojattuja osioita ja keskustelemaan siitä Kuution kanssa ihmisiä, jotka eivät osallistuneet työpajaan. Osallistujat lukevat raporttia jo. Lukija saa sähköpostiinsa kutsun ja kirjautuu raporttiin kertakäyttöisellä koodilla.',
      emailPlaceholder: 'nimi@organisaatio.fi',
      add: 'Lisää ja kutsu',
      empty: 'Ei vielä lukijoita',
      invited: 'Kutsu lähetetty',
      inviteFailed: 'Lukija lisätty, mutta kutsun lähetys epäonnistui: {{error}}',
      alreadyParticipant: 'Tällä henkilöllä on jo pääsy tähän Kuutioon, joten hän lukee raporttia jo.',
      invitedOn: 'Kutsuttu {{date}}',
      notInvited: 'Ei kutsuttu',
      lastLogin: 'kirjautunut viimeksi {{date}}',
      resend: 'Lähetä kutsu uudelleen',
      remove: 'Poista lukija',
    },
    type: {
      full: 'Täysi raportti',
      summary: 'Tiivistelmä',
      pivotOnly: 'Vipupisteet',
      fallback: 'Raportti',
    },
    status: {
      lensSummariesRunning: 'AI-yhteenveto luotu — koostetaan linssien yhteenvedot...',
      plansRunning: 'Linssien yhteenvedot koostettu — generoidaan toimeenpanosuunnitelmia...',
      plansDone: 'AI-yhteenveto luotu, toimeenpanosuunnitelmat: {{generated}}/{{total}}',
      plansDoneExcluded: 'AI-yhteenveto luotu, toimeenpanosuunnitelmat: {{generated}}/{{total}}. {{excluded}} syötettä jätetty pois yhteenvedoista',
      plansFailed: 'AI-yhteenveto luotu, mutta toimeenpanosuunnitelmat epäonnistuivat',
      createFailed: 'Raportin luonti epäonnistui',
      deleteFailed: 'Poisto epäonnistui',
      translateRunning: 'Käännetään raporttia ({{langs}})...',
      translateDone: 'Käännös valmis: {{translated}} kenttää (ohitettiin {{skipped}})',
      translateFailed: 'Käännös epäonnistui',
      translatePartial: 'Käännös valmis osittain ({{failed}} erää epäonnistui)',
    },
    translate: {
      title: 'Käännä raportti',
      button: 'Käynnistä käännös',
      translating: 'Käännetään...',
      includeTranscripts: 'Sisällytä litteraatit',
      pickLanguage: 'Valitse vähintään yksi kohdekieli',
      original: 'Alkuperäinen: {{lang}}',
      targets: 'Kohdekielet:',
      existing: 'Tallennetut käännökset',
      existingEmpty: 'Ei tallennettuja käännöksiä',
      existingCount: '{{count}} kenttää',
      remove: 'Poista',
      removing: 'Poistetaan...',
      removeConfirm: 'Poistetaanko {{lang}}-käännös tältä raportilta? Tätä ei voi perua.',
      removeDone: '{{lang}}-käännös poistettu ({{deleted}} kenttää)',
      removeFailed: 'Käännöksen poisto epäonnistui',
      panelTitle: 'Käännökset',
      addLanguage: 'Lisää kieliä',
      update: 'Päivitä',
      updateTitle: 'Käännä muuttuneet tekstit uudelleen',
      latest: 'päivitetty {{date}}',
      translateCount: 'Käännä ({{count}})',
      uiNote: 'Muille kuin suomeksi, englanniksi ja ruotsiksi käännetään myös raportin otsikot ja painikkeet, kerran kullekin kielelle.',
    },
    meta: {
      participants: '{{count}} osallistujaa',
      nodes: ' / {{count}} nodea',
    },
    exclusions: {
      title: 'Virheelliset syötteet',
      hint: 'Nämä syötteet jätetään pois tekoälyn koostamista yhteenvedoista. Osallistujien kortit näkyvät raporteissa silti.',
      count: '{{count}} syötettä jätetty pois analyyseistä',
      empty: 'Ei virheellisiä syötteitä',
      loadFailed: 'Pois jätettyjen syötteiden lataus epäonnistui',
      includeAnyway: 'Sisällytä silti',
      included: 'Sisällytetty',
      forced: 'Fasilitaattori jätti pois',
      codes: {
        too_short: 'Liian lyhyt',
        garbled: 'Sotkuinen',
        test_data: 'Testidata',
      },
      stages: {
        impact_path_node: 'Vaikutuspolku',
        lens_item: 'Linssi',
        solution: 'Ratkaisu',
      },
    },
  },

  // Print Report
  printReport: {
    chromeOnly: 'Chrome-selain vaaditaan',
    useChromeMessage: 'Käytä Chrome-selainta tulostamista varten.',
    toolbarTitle: 'Kuutio #3 — Raportti (10 / 40 sivua)',
    downloadPdf: 'Lataa PDF',
  },

  formCheck: {
    pendingLabel: 'Tarkistetaan syötettä…',
    okLabel: 'Syöte näyttää hyvältä',
    warnLabel: 'Syötteessä on huomautuksia',
    dismiss: 'Piilota',
    suggestedLabel: 'Tarkoititko tätä?',
    acceptSuggestion: 'Käytä ehdotusta',
    pill: {
      advisory: 'Tekoälyn ehdotus',
      blocking: 'Tarkista teksti',
    },
    tidyBtn: 'Muotoile siistiksi',
    tidyFailed: 'Tekstin muotoilu epäonnistui. Yritä uudelleen.',
    a11y: {
      pending: 'Syötteen tarkistus käynnissä',
      ok: 'Syöte tarkistettu, ei huomautuksia',
      warn: 'Syötteessä on huomautuksia',
    },
    issues: {
      too_short: 'Kirjoita hieman pidempi teksti, jotta idea on ymmärrettävissä.',
      garbled: 'Tekstiä ei saatu luettua. Kokeile kirjoittaa uudelleen.',
      test_data: 'Tämä näyttää testisyötteeltä. Kirjoita työpajaan liittyvä idea.',
      off_topic: 'Tämä ei näytä liittyvän työpajan aiheeseen.',
      wrong_stage: 'Tämä idea sopisi paremmin toiseen työpajan vaiheeseen.',
      multiple_ideas: 'Tässä on useita ideoita. Jaa ne omiksi merkinnöikseen.',
    },
  },

  instanceAccess: {
    pageTitle: 'Käyttöoikeudet',
    pageLead: 'Ketkä saavat työskennellä tämän Kuution parissa. Osallistujat hallitaan Osallistujat-sivulla.',
    sectionTitle: 'Kuution tekijät',
    sectionLead: 'Hallinnoija muuttaa asetuksia, PIN-koodeja ja oikeuksia; fasilitaattori vetää työpajan ja muokkaa raporttia.',
    empty: 'Ei myönnettyjä oikeuksia. Pääkäyttäjät ja Kuution luoja pääsevät ilman erillistä oikeutta.',
    notAllowed: 'Tämän Kuution oikeuksia muuttaa sen hallinnoija tai pääkäyttäjä.',
    emailLabel: 'Sähköposti',
    emailPlaceholder: 'etunimi.sukunimi@esimerkki.fi',
    levelLabel: 'Taso',
    add: 'Lisää',
    remove: 'Poista',
    actions: { manage: 'Hallinnoija', facilitate: 'Fasilitaattori' },
  },
  usersScreen: {
    title: 'Käyttäjät',
    lead: 'Jokainen tili, sen rooli ja oikeudet. Uusi Sitra-tili syntyy ilman oikeuksia — rooli ja ensimmäiset oikeudet annetaan täältä.',
    tabUsers: 'Käyttäjät',
    tabLinks: 'Linkit',
    filterPlaceholder: 'Suodata nimellä tai osoitteella…',
    roleLabel: 'Rooli',
    roles: { owner: 'Omistaja', admin: 'Pääkäyttäjä', usermanager: 'Pääfasilitaattori', facilitator: 'Fasilitaattori', participant: 'Osallistuja' },
    lastLogin: 'Kirjautunut {{date}}',
    neverLoggedIn: 'Ei kirjautumisia',
    kuutio: 'Kuutio',
    dataset: 'Tietopohja',
    grantActions: { manage: 'hallinnoija', facilitate: 'fasilitaattori', participate: 'osallistuja', contribute: 'lisääjä', view: 'katsoja' },
    dropGrant: 'Poista oikeus',
    removeAccount: 'Poista tili',
    linksLead: 'Kaikki linkit, jotka päästävät sisään ilman kirjautumista. Linkki luodaan tietopohjan asetuksista.',
    noLinks: 'Ei linkkejä.',
    uses: '{{count}} käyttöä',
    revoke: 'Mitätöi',
    revoked: 'mitätöity',
  },
  datasetWorkspace: {
    tabDocuments: 'Dokumentit',
    tabDatasets: 'Tietopohjat',
    kind: 'Tyyppi',
    kinds: {
      all: 'Kaikki',
      fact: 'Fakta',
      policy: 'Linjaus',
      opinion: 'Mielipide',
      testimony: 'Kokemus',
      none: 'Ei tyyppiä',
    },
    searchLink: 'Verkkohaku',
    searchLinkHelp: 'PDF:ssä ei ollut julkaisun omaa verkko-osoitetta, joten linkki on verkkohaku nimellä ja julkaisijalla. Korvaa se oikealla osoitteella, kun löydät sen.',
    profileFailed: 'Nimeä, julkaisijaa ja tyyppiä ei saatu luettua tiedostosta: {{error}}. Täydennä ne muokkaamalla tai muunna lähde uudelleen.',
    pdfUpload: {
      title: 'Tuo PDF-tiedostot',
      lead: 'Yksi tai useampi PDF tai ZIP-paketti PDF:iä. Jokaisesta PDF:stä tulee oma lähde, joka lisätään tietopohjan muiden lähteiden joukkoon. Nimi, julkaisija, linkki ja tyyppi (fakta, linjaus, mielipide) luetaan tiedoston sisältä, ei tiedostonimestä.',
      drop: 'Pudota PDF- tai ZIP-tiedostot tähän tai valitse ne',
      picked: 'Valittu {{count}} tiedostoa',
      upload: 'Tuo ({{count}})',
      added: '{{count}} PDF:ää lisätty, muunnos alkaa.',
      skipped: 'Ohitettu, ei PDF:iä: {{files}}',
    },
    manual: {
      title: 'Ladattava käsin ({{count}})',
      lead: 'Näiden linkkien automaattinen lataus ei onnistunut, todennäköisesti sivuston botinesto. Avaa linkki, lataa PDF omalla selaimellasi ja tuo se riville. Nimi, julkaisija ja linkki säilyvät.',
    },
    listTitle: 'Tietopohjat',
    listLead: 'Kuution aiheaineisto kootaan ennen kuin instanssi on olemassa. Liitä valmis tietopohja instanssiin Valmistelu → Tietopohja -sivulla.',
    newDataset: 'Uusi tietopohja',
    nameLabel: 'Nimi',
    namePlaceholder: 'esim. Kuutio 9: Vesiturvallisuus',
    topicLabel: 'Aihe',
    topicPlaceholder: 'Mitä tulevan Kuution aihe koskee',
    languageLabel: 'Kieli',
    create: 'Luo tietopohja',
    open: 'Avaa',
    back: 'Kaikki tietopohjat',
    sourceCount: '{{count}} lähdettä työtilassa',
    indexCount: 'Haussa {{documents}} dokumenttia ({{chunks}} palaa)',
    cliDocs: {
      title: 'Indeksoitu komentoriviltä ({{count}})',
      lead: 'Nämä dokumentit on indeksoitu komentorivityökalulla ennen tietopohjien työtilaa. Ne ovat haussa ({{chunks}} palaa), mutta niiden tiedostoja ei ole tallennettu, joten niitä ei voi muuntaa tai indeksoida uudelleen täällä.',
      show: 'Näytä dokumentit',
      excluded: 'pois hausta',
    },
    attachedTo: 'Liitetty: {{instances}}',
    notAttached: 'Ei vielä liitetty instanssiin',
    global: 'Perusdatapohja',
    empty: 'Ei tietopohjia vielä.',
    sourcesTitle: 'Lähteet',
    noSources: 'Ei lähteitä vielä. Tuo PDF-tiedostoja yllä.',
    addSource: 'Lisää lähde',
    sourceName: 'Nimi',
    publisher: 'Julkaisija',
    link: 'Linkki',
    file: 'PDF (valinnainen)',
    fileHelp: 'Jos PDF puuttuu, se ladataan linkistä. Verkkosivu muunnetaan sellaisenaan.',
    add: 'Lisää',
    status: 'Tila',
    quality: 'Laatu',
    chunks: 'Paloja',
    approve: 'Hyväksy ja indeksoi',
    reject: 'Hylkää',
    remove: 'Poista',
    save: 'Tallenna',
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    preview: 'Muunnettu teksti',
    noPreview: 'Ei muunnettua tekstiä vielä.',
    pages: 'Sivuja {{pages}}, joista visuaalisia {{visual}}',
    confirmRemove: 'Poistetaanko lähde?',
    fixTitle: 'Korjaa lähde',
    uploadFile: 'Tuo tiedosto',
    openPdf: 'Avaa PDF',
    replaceFile: 'Korvaa tiedosto',
    uploading: 'Tuodaan…',
    blockedHelp: 'Sivusto ei salli tiedoston automaattista latausta. Lataa tiedosto linkistä omalla selaimellasi ja tuo se tähän. Nimi, julkaisija ja linkki säilyvät.',
    failedHelp: 'Korjaa linkki muokkaamalla lähdettä tai tuo tiedosto itse.',
    awaitingHelp: 'Lähteeltä puuttuu tiedosto. Lisää linkki muokkaamalla lähdettä tai tuo tiedosto.',
    errorDetails: 'Virheen tiedot',
    errors: {
      download_blocked: 'Virhe: automaattinen lataus estetty',
      download_failed: 'Virhe: lataus epäonnistui',
      generic: 'Virhe',
    },
    settings: {
      open: 'Asetukset',
      description: 'Kuvaus',
      global: 'Perusdatapohja: kaikki instanssit hakevat tästä',
      globalHelp: 'Perusdatapohja näkyy jokaisessa Kuutiossa ilman liittämistä, ja useampi perusdatapohja lasketaan yhteen. Tietopohjaa ei voi poistaa: sen palat katoaisivat hauista huomaamatta.',
      confirmGlobalOn: 'Tästä tulee perusdatapohja: se näkyy kaikissa {{count}} instanssissa heti. Jatketaanko?',
      confirmGlobalOff: 'Tämä ei ole enää perusdatapohja: instanssit, joihin sitä ei ole erikseen liitetty, eivät enää hae siitä ({{count}} instanssia yhteensä). Jatketaanko?',
      otherGlobals: 'Huom: perusdatapohjia on jo: {{names}}. Ne kaikki näkyvät yhdessä.',
    },
    access: {
      title: 'Käyttöoikeudet',
      lead: 'Ketkä saavat käyttää tätä tietopohjaa. Hallinnoija hyväksyy lähteet ja muuttaa asetuksia, lisääjä tuo ja korjaa lähteitä niiden hyväksyntään asti, katsoja näkee lähteet ja niiden tilan.',
      empty: 'Ei myönnettyjä oikeuksia. Pääkäyttäjät näkevät kaikki tietopohjat ilman erillistä oikeutta.',
      emailLabel: 'Sähköposti',
      emailPlaceholder: 'etunimi.sukunimi@esimerkki.fi',
      levelLabel: 'Taso',
      add: 'Lisää',
      remove: 'Poista',
      actions: { manage: 'Hallinnoija', contribute: 'Lisääjä', view: 'Katsoja' },
      shareLabel: 'Lähetä lisätyille tämä linkki. Sitran ulkopuoliset kirjautuvat sähköpostiin tulevalla koodilla:',
      copy: 'Kopioi',
      copied: 'Kopioitu',
    },
    bulk: {
      select: 'Valitse',
      selectAll: 'Valitse kaikki odottavat ({{count}})',
      approve: 'Hyväksy ja indeksoi {{count}} (~{{cost}} $)',
      reject: 'Hylkää {{count}}',
      clear: 'Tyhjennä valinta',
      confirmReject: 'Hylätäänkö {{count}} lähdettä?',
      approveDone: '{{count}} hyväksytty, indeksointi alkaa',
      rejectDone: '{{count}} hylätty',
    },
    duplicates: {
      flag: 'kaksoiskappale?',
      detail: 'Sama teksti kuin: {{titles}}',
    },
    text: {
      edit: 'Muokkaa tekstiä',
      edited: 'muokattu',
    },
    vision: {
      run: 'Lue kuvat ({{pages}} sivua, ~{{cost}} $)',
      confirm: 'Kuvalliset sivut ({{pages}}) luetaan kuvantunnistuksella, arviolta {{cost}} $. Lähde muunnetaan uudelleen ja tarvitsee taas hyväksynnän. Jatketaanko?',
    },
    rerun: {
      redownload: 'Lataa uudelleen',
      reconvert: 'Muunna uudelleen',
      reindex: 'Indeksoi uudelleen',
      confirmIndexed: 'Lähde muunnetaan uudelleen ja tarvitsee taas hyväksynnän. Nykyinen versio pysyy haussa, kunnes uusi on indeksoitu. Jatketaanko?',
      editIndexedHint: 'Muutos näkyy haussa, kun lähde indeksoidaan uudelleen.',
    },
    results: {
      images: 'Kuvat',
      imagesRead: 'luettu {{described}}/{{pages}} sivulta',
      imagesNotRead: 'ei luettu',
      conversion: 'Muunnos',
      file: 'Tiedosto',
      pages: 'Sivut',
      matched: 'Yhdistetty',
      cost: 'Arvioitu kustannus',
      reviewReason: 'Tarkistettavaa',
      rejectionReason: 'Hylkäyksen syy',
      index: 'Indeksi',
      chunks: 'Paloja',
      words: 'Sanoja',
      language: 'Kieli',
      topics: 'Aiheet',
      indexedAt: 'Indeksoitu',
      quality: 'Laatu',
      credibility: 'Luotettavuus',
      researchBasis: 'Tutkimuspohja',
      recency: 'Ajantasaisuus',
      documentType: 'Asiakirjatyyppi',
      publisherType: 'Julkaisijatyyppi',
      year: 'Julkaisuvuosi',
      bias: 'Näkökulma',
      none: 'Ei tuloksia vielä.',
    },
    statuses: {
      draft: 'Tuonnissa',
      unmatched_file: 'Ilman lähdettä',
      awaiting_file: 'Odottaa tiedostoa',
      pending_download: 'Ladataan',
      pending_conversion: 'Muunnetaan',
      needs_review: 'Tarkista',
      pending_review: 'Odottaa hyväksyntää',
      approved: 'Hyväksytty',
      indexing: 'Indeksoidaan',
      indexed: 'Indeksoitu',
      rejected: 'Hylätty',
      failed: 'Virhe',
    },
  },

  datasetImport: {
    alternative: 'Vaihtoehtoisesti lähdeluettelo (Excel tai CSV) ja PDF:t, jotka yhdistetään luettelon riveihin.',
    openForm: 'Tuo lähdeluettelo',
    title: 'Tuo lähdeluettelo ja PDF:t',
    lead: 'Lähdeluettelo (Excel tai CSV: nimi, julkaisija, linkki) ja ZIP-paketti PDF-tiedostoista. PDF:t yhdistetään luettelon riveihin tiedostonimen, PDF:n metatietojen ja ensimmäisten sivujen perusteella. Muunnos alkaa vasta, kun vahvistat yhdistämisen.',
    sourcesLabel: 'Lähdeluettelo (.xlsx, .csv)',
    archiveLabel: 'PDF-paketti (.zip)',
    filesLabel: 'Tai yksittäiset PDF:t',
    start: 'Tuo',
    uploading: 'Ladataan…',
    extracting: 'Luetaan PDF:iä ja yhdistetään lähteisiin…',
    failed: 'Tuonti epäonnistui',
    summary: '{{matched}} yhdistetty, {{pdfs}} PDF:ää ja {{rows}} riviä ilman paria',
    aiCalls: 'Tekoäly luki {{count}} PDF:ää',
    matchedTitle: 'Yhdistetyt',
    unmatchedPdfsTitle: 'PDF:t ilman lähdettä',
    unmatchedRowsTitle: 'Lähteet ilman PDF:ää',
    noUnmatchedPdfs: 'Kaikki PDF:t on käsitelty.',
    noUnmatchedRows: 'Kaikilla lähteillä on PDF.',
    readAs: 'PDF:n mukaan',
    unknownTitle: 'Nimeä ei löytynyt',
    suggestions: 'Ehdotukset',
    selectPdf: 'Valitse PDF',
    selected: 'Valittu',
    matchHere: 'Yhdistä valittu PDF tähän',
    unmatch: 'Pura',
    auto: 'automaattinen',
    manual: 'käsin',
    own: 'oma lähde',
    keepOwn: 'Oma lähde',
    keep: 'Lisää omana lähteenä',
    discard: 'Hylkää',
    excerpt: 'Ensimmäinen sivu',
    rowNumber: 'rivi {{n}}',
    linkNote: 'Ladataan linkistä vahvistuksen jälkeen',
    noLinkNote: 'Ei linkkiä: odottaa tiedostoa',
    confirm: 'Vahvista ja aloita muunnos',
    confirmBlocked: 'Käsittele ensin kaikki PDF:t: yhdistä, lisää omana lähteenä tai hylkää.',
    cancel: 'Peru tuonti',
    confirmCancel: 'Perutaanko tuonti? Luettelon rivit ja PDF:t poistetaan.',
    methods: {
      filename_column: 'tiedostonimi luettelossa',
      link_filename: 'linkin tiedostonimi',
      title_in_text: 'nimi tekstissä',
      pdf_metadata: 'PDF:n metatiedot',
      first_page_title: 'kansilehden otsikko',
      ai_title: 'tekoälyn lukema nimi',
      filename: 'tiedostonimi',
      text: 'sanat tekstissä',
    },
  },


  clicker: {
    step: 'Vaihe {{i}}/{{n}}',
    tila: 'Tila {{i}}/{{n}}',
    slide: 'Dia {{i}}/{{n}}',
    paused: 'Tauolla',
    notRunning: 'Työpaja ei ole käynnissä.',
    prev: 'Edellinen',
    next: 'Seuraava',
    start: 'Käynnistä työpaja',
    pause: 'Tauko',
    resume: 'Jatka',
    steps: 'Vaiheet',
    stop: 'Lopeta',
    stopHint: 'Avaa vaiheet ensin; Lopeta pysäyttää työpajan.',
    phase: 'Vaiheen ohjaimet',
    phaseEmpty: 'Tällä vaiheella ei ole ohjaimia.',
  },
  infoWall: {
    title: 'Kuutio · mitä nyt tehdään',
    week: 'viikko {{week}}',
    underWork: 'Työn alla',
    nextDemo: 'Seuraava demo',
    noDemo: 'Ei sovittua demoa. Kirjoita se sivulla /admin/info.',
    shipped: 'Valmistunut viimeksi',
    theme: 'Teema',
    themeLight: 'vaalea',
    themeDark: 'tumma',
    doors: 'Ovet',
    doorsHint: 'Skannaa, avaa puhelimessa',
    pulse: 'Pulssi',
    pulseKuutiot: 'Kuutiota pidetty',
    pulseArticles: 'Artikkelia tietopohjassa',
    pulseParticipants: 'Osallistujaa',
    pulseNext: 'Seuraava Kuutio',
    pulseLenses: 'Estettä ja mahdollisuutta',
    pulseSolutions: 'Ratkaisua',
    pulseUpcoming: 'Kuutiota tulossa',
    pulseNodes: 'Solmua kartoilla',
    pulsePrework: 'Ennakkotehtävää tehty',
    vote: 'Mikä kiinnostaa Kuution kehityksessä?',
    voteHint: 'Napauta yhtä. Koodista pääset vastaamaan puhelimella.',
    voteAnswers: '{{n}} vastausta',
    voteQr: 'Kysymykset ja lisätietoa puhelimeen',
    voteQrHint: 'Yksi koodi: ideat, kolme kysymystä kustakin, tarinat ja Kuution sanasto.',
    kysyLead: 'Vastaa nimettömänä. Kolme kysymystä per idea, kun haluat.',
    sanasto: 'Kuution sanasto',
    kysyTitle: 'Kolme kysymystä',
    kysyThanks: 'Kiitos! Vastauksesi on tallessa, nimettömänä.',
    kysySend: 'Lähetä',
    kysyMissing: 'Ideaa ei löytynyt.',
    voteNoIdeas: 'Ei ideoita äänestettävänä. Merkitse issue tunnisteella idea.',
    voteEmail: 'Sähköpostisi',
    voteSend: 'Äänestä',
    voteCancel: 'Peru',
    voteThanks: 'Kiitos! Skannaa koodi, jos haluat kertoa lisää.',
    voteAgain: 'Olit jo äänestänyt tätä.',
    voteRemoved: 'Ääni poistettu.',
    voteAsk: 'vastaa',
    voteHintOwn: 'Napauta yhtä. Vastaa kysymyksiin suoraan tästä.',
    votes: '{{n}} ääntä',
    vaihe: { tuotannossa: 'Tuotannossa', testissa: 'Testissä', kokeilu: 'Kokeilu', tutkimus: 'Tutkimus' },
    stateOpen: 'tulossa',
    stateDone: 'valmis',
    empty: 'Ei mitään näytettävää. Merkitse issue tunnisteella info.',
    lint: 'Tarinat ilman seinälausetta: {{list}}',
    noSource: 'Ei yhteyttä GitHubiin.',
    upcoming: 'Tällä viikolla',
    upcomingNoDate: 'päivä avoin',
    calendarStale: 'kalenteri ei päivity',
    eventNew: '{{n}} uutta ominaisuutta',
    eventNotes: 'Uutta',
    eventMinimise: 'Sulje',
    eventOngoing: 'Käynnissä',
    weeks: { next: 'Ensi viikko', later: 'Myöhemmin', showNext: 'Näytä ensi viikko' },
    countdown: { kuutio: 'Kuutio {{n}}', days: '{{d}} pv {{h}} h', hours: '{{h}} h' },
    weather: { clear: 'selkeää', partly: 'puolipilvistä', cloudy: 'pilvistä', fog: 'sumua', drizzle: 'tihkua', rain: 'sadetta', showers: 'kuuroja', snow: 'lunta', thunder: 'ukkosta', feels: 'tuntuu {{t}}°', range: '{{lo}}…{{hi}}°' },
    lunch: { title: 'Lounas tänään', lead: 'Lähiravintoloiden päivän listat, luettu niiden sivuilta kerran päivässä.', loading: 'Luetaan listoja…', error: 'Listoja ei saatu: {{message}}', noMenu: 'Ei päivän listaa sivulla.', noPlaces: 'Ei lounaspaikkoja. Lisää ne sivulla /admin/info.' },
    tryOut: 'Kokeile',
    tryOutEmpty: 'Ei vielä kokeiltavaa. Lisää kortille rivit "Kokeile: /polku" ja "Kuva: /info/thumbs/N.jpg" (tai liitä kuvakaappaus korttiin).',
    tryOutBack: 'Takaisin seinälle',
    tryOutOpen: 'Avaa uudessa välilehdessä',
    tryOutPhone: 'Kokeile puhelimellasi: lue koodi ja käy läpi.',
    event: { allDay: 'koko päivä', organizer: 'Kutsuja', open: 'Avaa Outlookissa' },
    story: {
      loading: 'Ladataan…',
      error: 'Korttia ei saatu: {{message}}',
      body: 'Kortti',
      subIssues: 'Osatehtävät {{done}}/{{total}}',
      open: 'Avaa GitHubissa #{{number}}',
    },
    demoEditor: {
      title: 'Demot',
      edit: 'Muokkaa demoja',
      loading: 'Ladataan…',
      signIn: 'Demojen muokkaus vaatii ylläpitäjän kirjautumisen.',
      date: 'Päivä',
      time: 'Kello',
      place: 'Paikka',
      sessionTitle: 'Otsikko (valinnainen)',
      note: 'Lause seinälle (valinnainen)',
      slots: 'Kuka esittää mitä',
      who: 'Kuka',
      what: 'Mitä',
      noStory: '(ei korttia)',
      slotNote: 'Kuvaus tarvittaessa',
      addSlot: 'Lisää esitys',
      addPresenter: 'Lisää esittäjä',
      up: 'Ylemmäs',
      down: 'Alemmas',
      noStories: 'Ei avoimia kortteja tällä nimellä.',
      sessions: 'Demot',
      noSessions: 'Ei sovittuja demoja.',
      addSession: 'Lisää demo',
      remove: 'Poista',
      removeSession: 'Poista demo',
      cancel: 'Sulje',
      save: 'Tallenna',
      badDate: 'Päivä muodossa VVVV-KK-PP.',
      error: 'Tallennus epäonnistui: {{message}}',
    },
    upcomingEmpty: 'Ei vielä merkittyjä tarinoita tähän Kuutioon.',
    noUpcoming: 'Ei tiedossa olevaa tapahtumaa. Kirjoita se sivulla /admin/info.',
    progress: '{{done}}/{{total}} tehty',
    admin: {
      title: 'Infoseinä',
      lead: 'Mitä /info kertoo seuraavasta tapahtumasta ja demosta. Tarinat ja ideat tulevat GitHubista: tunnisteet info, idea ja K9.',
      nextEvent: 'Seuraava tapahtuma',
      nextDemo: 'Seuraava demo',
      eventTitle: 'Otsikko (esim. Kuutio 9)',
      date: 'Päivä',
      time: 'Kello',
      place: 'Paikka',
      note: 'Yksi lause seinälle',
      eventHint: 'Tyhjänä seinä ottaa seuraavan Kuution instansseista. Tarinat, joiden milestone tai tunniste on tämä Kuutio, näkyvät tämän alla.',
      demoHint: 'Rastita tarinat demon järjestyksessä. Demo katoaa seinältä päivän jälkeen; kortin vastuuhenkilö GitHubissa näkyy seinällä.',
      demoItems: 'Demossa näytettävät tarinat',
      demoItemsNone: 'Ei avoimia info-tarinoita.',
      lunch: 'Lounaspaikat',
      lunchHint: 'Seinän lounasnappi lukee näiden sivut kerran päivässä ja poimii päivän listan. Nimi ja sivu, jolla lista on.',
      lunchName: 'Ravintola',
      lunchAdd: 'Lisää paikka',
      save: 'Tallenna',
      saved: 'Tallennettu',
      open: 'Avaa /info',
      loading: 'Ladataan…',
      error: 'Tallennus epäonnistui: {{message}}',
    },
  },
  painPointVote: {
    title: 'Mikä sattuu eniten?',
    intro: 'Ennakkotehtävistä koottiin nämä kipupisteryhmät. Sinulla on {{budget}} ääntä: anna ne niille, joiden kanssa päivä kannattaa käyttää.',
    closedIntro: 'Äänestys on päättynyt. Tässä huoneen tulos.',
    left: '{{left}} / {{budget}} ääntä jäljellä',
    closed: 'Äänestys ei ole auki',
    noVotesLeft: 'Äänet on käytetty. Poista ääni, jos haluat siirtää sen.',
    empty: 'Ryhmiä ei ole vielä. Fasilitaattori ryhmittelee kipupisteet ennen äänestystä.',
    noInstance: 'Työpajaa ei ole valittu.',
  },
  homework: {
    title: 'Kotitehtävät',
    tabBefore: 'Ennen Kuutiota',
    tabAfter: 'Kuution jälkeen',
    prev: 'Edellinen',
    next: 'Seuraava',
    empty: 'Ei vielä vastauksia.',
    answered: '{{count}} vastannutta',
    mean: 'keskiarvo',
    agree: 'Samaa mieltä', unsure: 'En osaa sanoa', disagree: 'Eri mieltä',
    holds: 'Pitää paikkansa', notHere: 'Ei täällä',
    doneTitle: 'Huone ennen Kuutiota',
    doneLead: 'Näin moni teki ennakkotehtävät. Päivä alkaa siitä, mitä huone jo tietää.',
    invited: 'kutsuttua',
    didSelfAssessment: 'teki itsearvioinnin',
    didKysely: 'vastasi kyselyyn',
    didPainPoints: 'nimesi kipupisteen ({{count}} kipupistettä)',
    selfAssessmentTitle: 'Itsearviointi: näin arvioimme itsemme',
    dividedTitle: 'Mistä olemme eri mieltä',
    dividedLead: 'Jakautuneimmat väitteet ensin. Tästä kannattaa aloittaa.',
    claimsTitle: 'Mikä pitää paikkansa tänään',
    targetTitle: 'Mitä tavoitetilan pitää täyttää',
    expectTitle: 'Mihin uskomme työpajan päätyvän',
    painPointsTitle: 'Kipupisteet',
    painPointsCount: '{{count}} kipupistettä, {{people}} henkilöltä',
    promoted: 'muuttujaksi',
    ungrouped: '+ {{count}} ryhmittelemätöntä',
    peilausTitle: 'Peilaus: mitä tietopohja sanoi, ja pitikö se',
    peilausLead: 'Osallistujat ottivat kantaa lähteiden väitteisiin omasta kipupisteestään käsin.',
    mirrorsAnswered: '{{count}} peilausta',
    allMirrors: 'Kaikki peilaukset',
    unknownSource: 'Lähde ei tiedossa',
    afterDoneTitle: 'Huone Kuution jälkeen',
    didSelfAssessmentBefore: 'itsearviointia ennen',
    didSelfAssessmentAfter: 'itsearviointia jälkeen',
    noPost: 'Kotitehtäviä ei ole vielä tehty.',
    changeTitle: 'Itsearviointi ennen ja jälkeen',
    beforeAfter: 'ennen {{before}} · jälkeen {{after}}',
    before: 'ennen',
    after: 'jälkeen',
  },
  // Participant's own page (/me) — the one Kuutio surface written for
  // attendees rather than staff.
  me: {
    datasets: { title: 'Tietopohjat', sources: '{{count}} lähdettä' },
    heading: 'Sinun Kuutiosi',
    signInPrompt: 'Kirjaudu sähköpostillasi nähdäksesi Kuutiosi.',
    signIn: 'Kirjaudu',
    enterWorkshop: 'Siirry työpajaan',
    openFacilitator: 'Avaa fasilitaattorinäkymä',
    enterLater: 'Työpajaan pääsee tältä sivulta, kun se alkaa.',
    enterOnSite: 'Työpajaan osallistutaan paikan päällä. Jos etäosallistuminen avataan, pääset kartalle tästä.',
    signInInvited: 'Koodi lähetetään vain kutsutuille osallistujille. Käytä osoitetta, jolla ilmoittauduit Kuutioon.',
    selfAssessment: {
      label: 'Itsearviointi',
      postLabel: 'Itsearviointi työpajan jälkeen',
      hint: 'Seitsemän väittämää, kaksi minuuttia.',
      postHint: 'Samat väittämät kuin ennen työpajaa, ja yksi lisää.',
      intro: 'Arvioi omaa ennakointi- ja innovaatiokykyäsi. Vastaa siltä pohjalta, mitä ajattelet nyt. Vastaukset ovat sinulle ja Kuution vaikuttavuuden arviointiin, eivät kenenkään luettavissa nimelläsi.',
      postIntro: 'Samat väittämät kuin ennen työpajaa. Vastaa niin kuin ajattelet nyt, älä sen mukaan mitä vastasit silloin.',
      progress: '{{n}} / {{of}}',
      scale: { 1: 'täysin eri mieltä', 2: 'jokseenkin eri mieltä', 3: 'ei samaa eikä eri mieltä', 4: 'jokseenkin samaa mieltä', 5: 'täysin samaa mieltä' },
      unknown: 'En osaa sanoa',
      submit: 'Lähetä vastaukset',
      finalNote: 'Vastaukset tallennetaan lopullisina, eikä niitä voi muuttaa jälkeenpäin.',
      done: 'Itsearviointi tehty',
      doneNote: 'Kiitos. Vastauksesi on tallennettu.',
      postDoneNote: 'Kiitos. Vastauksesi ovat mukana Kuution vaikuttavuuden arvioinnissa.',
      items: {
        1: 'Tunnistan tulevaisuuteen liittyviä omia ja muiden oletuksia.',
        2: 'Hyödynnän ennakointia organisaationi päätöksenteon tukena.',
        3: 'Osaan edistää tulevaisuusajattelua omassa organisaatiossani.',
        4: 'Tarkastelen asioita systeemisesti tunnistaen moniulotteisia syy-seuraussuhteita.',
        5: 'Osaan hyödyntää työssäni innovatiivisuutta ja luovuutta tukevia menetelmiä.',
        6: 'Pystyn tunnistamaan ratkaisuja tulevaisuuden haasteisiin.',
        7: 'Olen motivoitunut hyödyntämään ennakoinnin ja innovoinnin menetelmiä ja työkaluja työssäni.',
        8: 'Kuutiossa työskentely vahvisti ennakointi- ja innovaatiokykyäni.',
      },
      info: {
        title: 'Miten vastauksesi tallennetaan',
        close: 'Sulje',
        stored: 'Vastauksesi tallennetaan Kuution tietokantaan sähköpostiosoitteesi yhteyteen, kuten muutkin ennakkotehtäväsi. Niitä käsittelee vain Kuution kehitystiimi.',
        paired: 'Vastausten avulla arvioidaan, muuttuiko jokin Kuution myötä. Myös "ei muuttunut" on tulos.',
        whoSees: 'Fasilitaattori ja Sitra näkevät vain, miten huone vastasi kuhunkin väittämään yhteenlaskettuna. Kukaan ei näe yksittäisen henkilön vastauksia.',
        purpose: 'Sitra käyttää tietoja Kuution vaikuttavuuden arviointiin: vahvistuiko osallistujien ennakointi- ja innovaatiokyky Kuution avulla.',
      },
    },
    kysely: {
      label: 'Kysely',
      hint: 'Kaksitoista kohtaa, kolme minuuttia. Sama kaikille.',
      intro: 'Vastaa siltä pohjalta, mitä ajattelet nyt. Vastaukset näytetään huoneelle vain yhteenlaskettuina, eikä kukaan näe kenen ne ovat. Tämä on lähtötilasi: siihen palataan työpajan jälkeen.',
      part: 'Osa {{n}} / {{of}}',
      claimsQ: 'Mitkä näistä pitävät paikkansa tänään?',
      claimsHint: 'Valitse kaikki, joiden kanssa olet samaa mieltä.',
      stanceQ: 'Ota kanta jokaiseen väitteeseen.',
      socketsQ: 'Mitkä näistä tavoitetilan pitää täyttää?',
      socketsHint: 'Valitse ne, joita pidät välttämättöminä.',
      expectQ: 'Mihin uskot työpajan päätyvän?',
      expectHint: 'Yksi valinta. Tähän palataan, kun työpaja on ohi.',
      expectFoot: 'Odotus ennen työpajaa. Verrataan lopputulokseen jälkeenpäin.',
      agree: 'Samaa mieltä',
      unsure: 'En osaa sanoa',
      disagree: 'Eri mieltä',
      submit: 'Lähetä vastaukset',
      finalNote: 'Lähetys on lopullinen. Työpajan jälkeen samat kysymykset kysytään uudelleen.',
      done: 'Kysely vastattu',
      resultsIntro: 'Näin huone vastasi tähän mennessä. Omat vastauksesi on merkitty.',
      answered: '{{count}} vastannutta',
      notReady: 'Kyselyä ei ole vielä laadittu tälle Kuutiolle. Ilmoitamme, kun se on valmis.',
    },
    online: 'Verkossa. Linkki työpajaan avautuu tälle sivulle.',
    placeLater: 'Paikka ilmoitetaan lähempänä ajankohtaa.',
    kuutioRoom: 'Sitran Kuutio-tila',
    dateLater: 'Ajankohta ilmoitetaan lähempänä.',
    door: {
      emailLabel: 'Sähköpostiosoite',
      emailPlaceholder: 'etunimi.sukunimi@esimerkki.fi',
      sendCode: 'Lähetä koodi',
      codeSent: 'Koodi lähetettiin osoitteeseen {{email}}. Se on voimassa 10 minuuttia.',
      codeLabel: 'Kuusinumeroinen koodi',
      verify: 'Kirjaudu',
      resend: 'Lähetä uusi koodi',
      resendIn: 'Uusi koodi {{seconds}} s',
      resent: 'Uusi koodi lähetetty.',
      changeEmail: 'Vaihda osoite',
      signingIn: 'Kirjaudutaan…',
      joining: 'Olet liittymässä Kuutioon ”{{title}}”.',
      joiningUnknown: 'Liittymislinkki Kuutioon.',
      noJoinCode: 'Tähän Kuutioon ei ole asetettu liittymiskoodia. Pyydä järjestäjältä uusi linkki.',
      howJoin: 'Kirjaudu sähköpostillasi. Linkin koodi liittää sinut tähän Kuutioon.',
    },
    none: 'Sinulle ei ole vielä avattu yhtään Kuutiota. Jos odotit näkeväsi jotain, ota yhteyttä järjestäjään.',
    loading: 'Ladataan…',
    failed: 'Tietojen lataaminen epäonnistui.',
    chooseWorkshop: 'Sinulla on useampi Kuutio. Valitse mitä haluat katsoa.',
    staffView: 'Näet kaikki Kuutiot, koska olet ylläpitäjä. Osallistuja näkee vain omansa.',
    back: 'Takaisin',
    when: 'Milloin',
    where: 'Missä',
    directions: 'Näytä kartalla',
    contact: 'Kysyttävää?',
    goodToKnow: 'Hyvä tietää',
    tabPractical: 'Käytännön tiedot',
    tabPreWork: 'Ennakkotehtävät',
    tabHomework: 'Kotitehtävät',
    homeworkIntro: 'Työpaja on ohi. Kotitehtävät ovat lyhyitä, ja niistä syntyy kuva siitä, mikä muuttui.',
    homeworkTodo: 'Tekemättömiä kotitehtäviä',
    preWorkClosed: 'Ennakkotehtävät on lukittu: työpaja on ohi. Vastauksesi säilyvät sellaisina kuin ne olivat ennen työpajaa.',
    preWorkClosedShort: 'Lukittu',
    noPreWork: 'Ennakkotehtäviä ei ole vielä julkaistu. Ilmoitamme, kun ne ovat valmiina.',
    phone: 'Puhelin',
    assistant: 'Viestit myös',
    preWorkIntro: 'Tee ennakkotehtävät ennen työpajaa. Silloin päivä alkaa siitä, mitä sinä jo tiedät, ja saamme siitä parhaan mahdollisen hyödyn.',
    preWorkBack: 'Kaikki ennakkotehtävät',
    preWorkBackToList: 'Takaisin ennakkotehtävälistaan',
    preWorkDone: 'Tehty',
    countdown: { days: 'Kuutioon {{days}} pv {{hours}} h', hours: 'Kuutioon {{hours}} h {{minutes}} min' },
    reading: {
      title: 'Ennakkolukemista: vakioskenaariot',
      body: 'Kuutiossa aihetta tarkastellaan neljän vakioskenaarion kautta: demokratia, väestö, teknologia ja ilmasto. Silmäile skenaarioraportit ennen työpajaa, niin tulevaisuuskuvat ovat tuttuja kun työ alkaa.',
      url: 'https://www.sitra.fi/kuutio',
      linkText: 'sitra.fi/kuutio',
    },
    preWorkLocked: 'Avautuu, kun Kipupiste on tehty',
    preWorkLockedAfter: 'Avautuu, kun tehtävä ”{{title}}” on tehty',
    chatham: {
      title: 'Chatham House -sääntö',
      body: 'Kuutiossa käydyn keskustelun sisältöä saa käyttää, mutta puhujaa tai hänen organisaatiotaan ei nimetä.',
    },
    peilaus: {
      researchSearchFailed: 'Tietopohjaa ei saatu haettua juuri nyt. Yritä hetken päästä uudelleen.',
      researchNoDatasets: 'Työpajalle ei ole liitetty tutkimusaineistoa, joten peilattavaa ei ole.',
      intro: 'Tietopohja peilataan siihen, mitä pidit kartalla: enintään kolme kohtaa, joissa lähde sanoo jotain muuta tai lisää. Sinä kerrot, päteekö se teillä. Erimielisyys on arvokasta.',
      pick: 'Valitse kipupiste',
      label: 'Peilaus',
      start: 'Peilaa',
      loading: 'Haetaan tietopohjasta… tässä menee hetki.',
      you: 'Sinä',
      source: 'Tietopohja',
      kindPain: 'Kipupiste',
      holds: 'Pätee',
      not_here: 'Ei päde meillä',
      unsure: 'En osaa sanoa',
      notePlaceholder: 'Miksi? (valinnainen)',
      done: 'Kiitos. Kantasi ovat kartalla huomioina lähteineen. Jatketaan tästä työpajassa.',
      empty: 'Tietopohja ei sano tästä kipupisteestä mitään suoraa. Sekin on tieto, ja siihen palataan työpajassa.',
    },
    phase: { upcoming: 'Tulossa', ongoing: 'Käynnissä', past: 'Päättynyt', online: 'Online' },
    preWorkTodo: 'Tekemättömiä ennakkotehtäviä',
    devices: { title: 'Laitteet', body: 'Työskentely tapahtuu Kuution laitteilla; omia laitteita ei tarvita.' },
    comfort: { title: 'Villasukat ja rento asenne', body: 'Pukeudu mukavasti. Villasukat ovat tervetulleet, samoin rento asenne: Kuutio on työpaja, ei seminaari.' },
    about: {
      title: 'Kuutio lyhyesti',
      lines: [
        'Kuutio on Sitran menetelmä, jossa tarkastelemme aihetta tulevaisuuksien ja syy-seuraussuhteiden kautta ja etsimme yhdessä vipupisteitä ja ratkaisuja. Tekoäly on työskentelyn tukena.',
        'Kuutio on kokeilu. Heittäydy mukaan ja luota prosessiin.',
        'Tekoälyalustalle viedään vain asiantuntijoiden tarkistamia aineistoja, eikä sinne syötetä henkilötietoja.',
        'Kuutiosta saa somettaa: LinkedInissä @Sitra, Instagramissa @sitrafund.',
      ],
    },
    transit: { subway: 'Metro', train: 'Juna', tram: 'Raitiovaunut', bus: 'Bussit', more: '+{{count}} muuta' },
    preWorkUntitled: 'Ennakkotehtävä',
    kipupiste: {
      scenario: 'Mihin skenaarioon tämä kuuluu?',
      aiSuggested: 'tekoälyn ehdotus',
      defaultQuestion: 'Mikä on mieltä polttavin ongelma päivän aiheeseen liittyen?',
      intro: 'Kirjoita omin sanoin. Sen jälkeen kysyn muutaman kysymyksen ja poimin kuulemastani ehdotuksia, jotka voit pitää tai hylätä. Vain pitämäsi päätyvät työpajan kartalle.',
      placeholder: 'Esimerkiksi: verotus ei tavoita alustatalouden tuloja…',
      start: 'Aloita',
      answer: 'Vastaa',
      stop: 'Riittää tältä erää',
      thinking: 'Hetki…',
      answerPlaceholder: 'Vastaa omin sanoin',
      heard: 'Kuulin tämän',
      cause: 'Syy',
      blocker: 'Este',
      keep: 'Pidä',
      drop: 'Pois',
      kept: 'Kartalla',
      dropped: 'Hylätty',
      done: 'Kiitos. Kartalle jäi {{count}} asiaa kipupisteesi ympärille. Jatketaan tästä työpajassa.',
      addAnother: 'Lisää uusi kipupiste ({{count}}/{{max}})',
      addFirst: 'Kirjoita kipupiste',
      label: 'Kipupiste',
      causeOf: 'Taustalla: {{cause}}',
      mergedInto: 'Kipupisteesi on nyt muuttuja ”{{title}}” skenaariossa {{scenario}}.',
      mergedWith: 'Yhdessä {{count}} muun kanssa.',
      cancelNew: 'Peruuta',
      yours: 'Kipupisteesi ({{count}}/{{max}})',
      inProgress: 'Kesken',
      keptCount: '{{count}} kartalla',
      limit: 'Enintään {{max}} kipupistettä. Loput kannattaa säästää työpajaan.',
    },
    assistantIntro: 'Toimit avustajana: {{name}}. Nämä tiedot järjestäjällä on hänestä. Niitä voi muuttaa hänen ilmoittautumissivullaan.',
    theirDetails: 'Ilmoittautumisen tiedot',
    editTheirs: 'Muuta tietoja',
    attendingCount: '{{count}} osallistujaa ilmoittautunut',
    yourDetails: 'Ilmoittautumisesi tiedot',
    detailsIntro: 'Nämä tiedot järjestäjällä on sinusta. Voit muuttaa niitä omalla ilmoittautumissivullasi.',
    editInLyyti: 'Muuta tietojani',
    organisation: 'Organisaatio',
    title: 'Titteli',
    allergies: 'Ruoka-aineallergiat',
    diet: 'Erityisruokavalio',
    notGiven: 'Ei ilmoitettu',
    noRegistration: 'Emme löytäneet ilmoittautumistasi tähän Kuutioon. Pääset silti mukaan — ota yhteyttä järjestäjään, jos tämä näyttää väärältä.',
    noEventInfo: 'Käytännön tiedot tarkentuvat lähempänä.',
    detailsUnavailable: 'Käytännön tietoja ei juuri nyt saada haettua. Yritä hetken päästä uudelleen.',
  },

  futureSelection: {
    loading: 'Ladataan skenaarioita...',
    empty: 'Ei skenaarioita.',
    scenarioFallback: 'Skenaario',
    futuresCount: '{{count}} tulevaisuuskuvaa',
    activeFuture: 'Aktiivinen tulevaisuuskuva',
    customFuture: 'Oma tulevaisuuskuva',
    freeBadge: 'Vapaa',
    saving: 'Tallennetaan...',
    saved: 'Tallennettu',
    noFutures: 'Ei tulevaisuuskuvia',
    modalTitle: 'Vaihdetaanko tulevaisuuskuva?',
    modalExisting: 'Skenaariolla {{scenario}} on jo {{count}} osallistujien luomaa solmua nykyisellä tulevaisuuskuvalla {{previous}}.',
    modalRecommendation: 'Suositeltu: säilytä osallistujien sisältö ja vaihda vain tulevaisuuskuva + muuttujat. Tuleva AI-analyysi käyttää uutta tulevaisuuskuvaa {{next}}.',
    switching: 'Vaihdetaan…',
    keepContent: 'Säilytä sisältö, vaihda tulevaisuuskuva',
    wipeAndRestart: 'Tyhjennä vaikutuspolku ja aloita alusta',
    swapFailed: 'Tulevaisuuskuvan vaihto epäonnistui: {{error}}',
    wipeFailed: 'Tyhjennys epäonnistui: {{error}}',
  },

  topicFocus: {
    selectedLabel: 'Valittu näkökulma',
    noneSelected: 'Ei valittu – kaikki näkökulmat',
    noFilter: 'Ei rajausta',
    noFilterDescription: 'Kaikki näkökulmat ovat samanarvoisia',
    saving: 'Tallennetaan...',
    saved: 'Tallennettu',
    focusLabel: 'Rajaus',
    original: 'Alkuperäinen: {{title}}',
  },

  pivotPointContent: {
    loading: 'Ladataan vipupisteitä...',
    saveFailed: 'Vipupisteen tallennus epäonnistui: {{error}}',
    deleteTitle: 'Poista vipupiste',
    deleteMessage: 'Poistetaanko "{{title}}"? Tätä ei voi perua.',
    clearTitle: 'Poistetaanko kaikki valitut vipupisteet?',
    clearMessage: 'Tämä jättää työpajan ilman valittuja vipupisteitä — Linssit-, Ratkaisut- ja raporttinäkymät eivät näytä mitään ennen kuin valitset uudet. Jatketaanko?',
    clearConfirm: 'Tyhjennä valinnat',
  },

  preworkCuration: {
    loading: 'Ladataan ennakkotehtäviä…',
    title: 'Ennakkotehtävät: kipupisteistä muuttujiksi',
    intro: 'Tekoäly ehdottaa ryhmät, otsikot ja skenaarion. Sinä päätät, mistä tulee muuttuja. Osallistujien omat sanat eivät muutu.',
    clustering: 'Ryhmitellään… tämä kestää noin minuutin',
    recluster: 'Ryhmittele uudelleen',
    cluster: 'Ryhmittele',
    countPainPoints: 'kipupistettä',
    countParticipants: 'osallistujalta',
    countGroups: 'ryhmää',
    countPromoted: 'muuttujaa kartalla',
    unembedded: '{{count}} ilman vektoria (ryhmittely upottaa ne)',
    noPainPoints: 'Kukaan ei ole vielä kirjoittanut kipupistettä.',
    noClusters: 'Ei vielä ryhmiä. Paina Ryhmittele.',
    closeVote: 'Sulje äänestys',
    openVote: 'Avaa äänestys huoneelle',
    voteOpenInfo: 'Äänestys auki: laitteet osoitteessa /kipupisteet, {{budget}} ääntä per laite. Äänet nostavat ryhmän järjestyksessä.',
    voteClosedInfo: 'Kun ryhmät ovat valmiit, huone voi äänestää niistä laitteillaan ennen kuin nostat muuttujat.',
    scenarioFallback: 'Skenaario',
    noScenario: 'Ilman skenaariota',
    groupHeading: '{{title}} · {{count}} muuttujaa',
    unclusteredHeading: 'Ryhmittelemättä · {{count}}',
    clusterCard: {
      rankTitle: 'Järjestys skenaarion sisällä: huoneen äänet, osallistujat, erimielisyys, esteet',
      namePlaceholder: 'Muuttujan nimi',
      scenarioPlaceholder: 'Skenaario…',
      votes: 'ääntä',
      participants: 'osallistujaa',
      painPoints: 'kipupistettä',
      disagreement: 'erimielisyys',
      obstacles: 'estettä',
      overCap: 'skenaariossa on jo paljon muuttujia',
      promoted: 'Muuttuja kartalla: {{title}}',
      undo: 'Peru',
      promote: 'Muuttujaksi',
      pickScenarioFirst: 'valitse skenaario ensin',
      dissolve: 'Pura ryhmä',
    },
    painPoint: {
      move: 'Siirrä…',
      ownGroup: 'Omaksi ryhmäksi',
      untitled: '(nimetön)',
      done: 'Kipupiste tehty',
      inProgress: 'Kipupiste kesken',
      causes: '{{count}} syytä',
      blockers: '{{count}} estettä',
      noVector: 'ei vektoria',
      stance: {
        holds: 'pätee',
        not_here: 'ei meillä',
        unsure: 'epävarma',
      },
    },
    scenarioProposal: {
      fromAction: 'Ehdotus syntyy osion toiminnolla Ehdota skenaariot ryhmistä; se näkyy tässä muokattavana.',
      proposing: 'Ehdotetaan… noin minuutti',
      propose: 'Ehdota skenaariot ryhmistä',
      form: 'Muodosta skenaariot ryhmistä',
      place: 'Sijoita ryhmät nykyisiin skenaarioihin',
      hintExisting: 'Skenaariot ovat jo olemassa; ryhmät sijoitetaan niihin, tai tekoäly ehdottaa uusia, jos mikään ei sovi.',
      hintNone: 'Instanssilla ei ole skenaarioita. Tekoäly ehdottaa ne kipupisteryhmistä ja juurisyistä; sinä muokkaat ja vahvistat.',
      heading: 'Ehdotus: {{count}} skenaariota',
      editHint: 'Muokkaa otsikoita ja kuvauksia. Ryhmät voi siirtää skenaarioiden välillä luomisen jälkeen.',
      namePlaceholder: 'Skenaarion nimi',
      existingTag: 'olemassa',
      descriptionPlaceholder: 'Kuvaus',
      unplaced: 'Ilman sijoitusta: {{titles}}. Ne jäävät ryhmiksi, joille valitset skenaarion itse.',
      create: 'Luo ja sijoita',
      reject: 'Hylkää',
    },
  },

  // Legacy room screens: what they say instead of invented data (#1413)
  moodScreen: {
    loading: 'Ladataan tunnelmadataa...',
    title: 'Työpajan tunnelma',
    analysed: '{{count}} ehdotusta analysoitu',
    noInstance: 'Työpajaa ei ole valittu, joten tunnelmaa ei ole näytettävänä.',
    loadFailed: 'Tunnelmadatan haku epäonnistui: {{reason}}',
    empty: 'Ehdotuksia ei ole vielä, joten tunnelmaa ei ole näytettävänä.',
    retry: 'Yritä uudelleen',
    moods: {
      positive: 'Positiivinen',
      neutral: 'Neutraali',
      negative: 'Huolestunut',
      hopeful: 'Toiveikas',
      concerned: 'Huolissaan',
    },
  },
  impactMachine: {
    loading: 'Ladataan tallennettua suunnitelmaa...',
    empty: 'Suunnitelmaa ei ole vielä tallennettu, joten seinä on tyhjä.',
    loadFailed: 'Tallennetun suunnitelman lataus epäonnistui: {{reason}}',
    noAnswer: 'Palvelin ei vastannut tallennetun suunnitelman hakuun. Lataa sivu uudelleen.',
    accessDenied: 'Palvelin kieltäytyi lataamasta suunnitelmaa, koska istuntoa ei ole. Kirjaudu sisään uudelleen.',
    connectFailed: 'Yhteys palvelimeen epäonnistui: {{reason}}',
  },
  solutionComponents: solutionComponentsFi,
  lensComponents: lensComponentsFi,
  moduleIntro: moduleIntroFi,
  languagePicker: {
    common: 'Yleisimmät:',
    search: 'Hae kieltä nimellä tai koodilla (esim. viro, eesti, et)',
    noMatch: 'Ei osumia',
    remove: 'Poista {{lang}} valinnoista',
  },
  report: reportStringsFi,
  foresight: { ...foresightFi, ...foresightScenarioFi, ...foresightPathFi, ...foresightWildcardFi },
};